/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// use `yarn generate:graphql to regenerate

import { useMemo } from "react";
import parseVariables, { useMutationVariables, useQueryVariables, useLazyQueryVariables } from "@virtuslab/nfs-shared/src/schema/parseVariables";
import { scalarPaths } from "./scalarPaths";
import { scalarParsers } from "./scalars";
import * as ApolloReact from "@apollo/client/react"
import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export const AbsenceRecordTypename = 'AbsenceRecord';
export interface AbsenceRecordTypeLike extends TypeLike { readonly __typename?: typeof AbsenceRecordTypename; }
export const NfsErrorTypename = 'NfsError';
export interface NfsErrorTypeLike extends TypeLike { readonly __typename?: typeof NfsErrorTypename; }
export const ActiveReportingRangeErrorTypename = 'ActiveReportingRangeError';
export interface ActiveReportingRangeErrorTypeLike extends TypeLike { readonly __typename?: typeof ActiveReportingRangeErrorTypename; }
export const AggregatedValidationErrorsTypename = 'AggregatedValidationErrors';
export interface AggregatedValidationErrorsTypeLike extends TypeLike { readonly __typename?: typeof AggregatedValidationErrorsTypename; }
export const DuplicatedEntityErrorTypename = 'DuplicatedEntityError';
export interface DuplicatedEntityErrorTypeLike extends TypeLike { readonly __typename?: typeof DuplicatedEntityErrorTypename; }
export const EmptyRequestInputErrorTypename = 'EmptyRequestInputError';
export interface EmptyRequestInputErrorTypeLike extends TypeLike { readonly __typename?: typeof EmptyRequestInputErrorTypename; }
export const EntitiesNotFoundErrorTypename = 'EntitiesNotFoundError';
export interface EntitiesNotFoundErrorTypeLike extends TypeLike { readonly __typename?: typeof EntitiesNotFoundErrorTypename; }
export const EntityNotFoundErrorTypename = 'EntityNotFoundError';
export interface EntityNotFoundErrorTypeLike extends TypeLike { readonly __typename?: typeof EntityNotFoundErrorTypename; }
export const EntityVersionMismatchedTypename = 'EntityVersionMismatched';
export interface EntityVersionMismatchedTypeLike extends TypeLike { readonly __typename?: typeof EntityVersionMismatchedTypename; }
export const ForeignKeyConstraintErrorTypename = 'ForeignKeyConstraintError';
export interface ForeignKeyConstraintErrorTypeLike extends TypeLike { readonly __typename?: typeof ForeignKeyConstraintErrorTypename; }
export const IllegalPositionRemovalErrorTypename = 'IllegalPositionRemovalError';
export interface IllegalPositionRemovalErrorTypeLike extends TypeLike { readonly __typename?: typeof IllegalPositionRemovalErrorTypename; }
export const IncompleteArgumentErrorTypename = 'IncompleteArgumentError';
export interface IncompleteArgumentErrorTypeLike extends TypeLike { readonly __typename?: typeof IncompleteArgumentErrorTypename; }
export const IncompleteArgumentsErrorTypename = 'IncompleteArgumentsError';
export interface IncompleteArgumentsErrorTypeLike extends TypeLike { readonly __typename?: typeof IncompleteArgumentsErrorTypename; }
export const InternalNfsErrorTypename = 'InternalNfsError';
export interface InternalNfsErrorTypeLike extends TypeLike { readonly __typename?: typeof InternalNfsErrorTypename; }
export const InvalidApiTokenErrorTypename = 'InvalidApiTokenError';
export interface InvalidApiTokenErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidApiTokenErrorTypename; }
export const InvalidArgumentsErrorTypename = 'InvalidArgumentsError';
export interface InvalidArgumentsErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidArgumentsErrorTypename; }
export const InvalidCompanyTypeErrorTypename = 'InvalidCompanyTypeError';
export interface InvalidCompanyTypeErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidCompanyTypeErrorTypename; }
export const InvalidContentTypeErrorTypename = 'InvalidContentTypeError';
export interface InvalidContentTypeErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidContentTypeErrorTypename; }
export const InvalidCursorErrorTypename = 'InvalidCursorError';
export interface InvalidCursorErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidCursorErrorTypename; }
export const InvalidEmailAddressTypename = 'InvalidEmailAddress';
export interface InvalidEmailAddressTypeLike extends TypeLike { readonly __typename?: typeof InvalidEmailAddressTypename; }
export const InvalidStateErrorTypename = 'InvalidStateError';
export interface InvalidStateErrorTypeLike extends TypeLike { readonly __typename?: typeof InvalidStateErrorTypename; }
export const InvoiceAlreadyAcceptedErrorTypename = 'InvoiceAlreadyAcceptedError';
export interface InvoiceAlreadyAcceptedErrorTypeLike extends TypeLike { readonly __typename?: typeof InvoiceAlreadyAcceptedErrorTypename; }
export const InvoiceImportedFromSaldeoErrorTypename = 'InvoiceImportedFromSaldeoError';
export interface InvoiceImportedFromSaldeoErrorTypeLike extends TypeLike { readonly __typename?: typeof InvoiceImportedFromSaldeoErrorTypename; }
export const LeaveEntitlementExceededErrorTypename = 'LeaveEntitlementExceededError';
export interface LeaveEntitlementExceededErrorTypeLike extends TypeLike { readonly __typename?: typeof LeaveEntitlementExceededErrorTypename; }
export const MissingFileMetadataErrorTypename = 'MissingFileMetadataError';
export interface MissingFileMetadataErrorTypeLike extends TypeLike { readonly __typename?: typeof MissingFileMetadataErrorTypename; }
export const NbpBaseCurrencyErrorTypename = 'NbpBaseCurrencyError';
export interface NbpBaseCurrencyErrorTypeLike extends TypeLike { readonly __typename?: typeof NbpBaseCurrencyErrorTypename; }
export const NoParkingSpotAvailableErrorTypename = 'NoParkingSpotAvailableError';
export interface NoParkingSpotAvailableErrorTypeLike extends TypeLike { readonly __typename?: typeof NoParkingSpotAvailableErrorTypename; }
export const OperationAlreadyInProgressErrorTypename = 'OperationAlreadyInProgressError';
export interface OperationAlreadyInProgressErrorTypeLike extends TypeLike { readonly __typename?: typeof OperationAlreadyInProgressErrorTypename; }
export const OperationNotAvailableErrorTypename = 'OperationNotAvailableError';
export interface OperationNotAvailableErrorTypeLike extends TypeLike { readonly __typename?: typeof OperationNotAvailableErrorTypename; }
export const OtherInvalidRequestErrorTypename = 'OtherInvalidRequestError';
export interface OtherInvalidRequestErrorTypeLike extends TypeLike { readonly __typename?: typeof OtherInvalidRequestErrorTypename; }
export const PaymentCouldNotBeChangedErrorTypename = 'PaymentCouldNotBeChangedError';
export interface PaymentCouldNotBeChangedErrorTypeLike extends TypeLike { readonly __typename?: typeof PaymentCouldNotBeChangedErrorTypename; }
export const PositionInactiveErrorTypename = 'PositionInactiveError';
export interface PositionInactiveErrorTypeLike extends TypeLike { readonly __typename?: typeof PositionInactiveErrorTypename; }
export const RaiseNoLongerDueErrorTypename = 'RaiseNoLongerDueError';
export interface RaiseNoLongerDueErrorTypeLike extends TypeLike { readonly __typename?: typeof RaiseNoLongerDueErrorTypename; }
export const ReservationNotPendingErrorTypename = 'ReservationNotPendingError';
export interface ReservationNotPendingErrorTypeLike extends TypeLike { readonly __typename?: typeof ReservationNotPendingErrorTypename; }
export const ReservationRequestStateErrorTypename = 'ReservationRequestStateError';
export interface ReservationRequestStateErrorTypeLike extends TypeLike { readonly __typename?: typeof ReservationRequestStateErrorTypename; }
export const ResourceAlreadyReservedErrorTypename = 'ResourceAlreadyReservedError';
export interface ResourceAlreadyReservedErrorTypeLike extends TypeLike { readonly __typename?: typeof ResourceAlreadyReservedErrorTypename; }
export const TimeBasedActivityOverlapErrorTypename = 'TimeBasedActivityOverlapError';
export interface TimeBasedActivityOverlapErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeBasedActivityOverlapErrorTypename; }
export const TimeBasedEffectiveFromInPastErrorTypename = 'TimeBasedEffectiveFromInPastError';
export interface TimeBasedEffectiveFromInPastErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeBasedEffectiveFromInPastErrorTypename; }
export const TimeReportOverlapErrorTypename = 'TimeReportOverlapError';
export interface TimeReportOverlapErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeReportOverlapErrorTypename; }
export const TimeReportRecordApprovalNotInPendingStateErrorTypename = 'TimeReportRecordApprovalNotInPendingStateError';
export interface TimeReportRecordApprovalNotInPendingStateErrorTypeLike extends TypeLike { readonly __typename?: typeof TimeReportRecordApprovalNotInPendingStateErrorTypename; }
export const UnauthorizedOperationErrorTypename = 'UnauthorizedOperationError';
export interface UnauthorizedOperationErrorTypeLike extends TypeLike { readonly __typename?: typeof UnauthorizedOperationErrorTypename; }
export const UnknownContentTypeErrorTypename = 'UnknownContentTypeError';
export interface UnknownContentTypeErrorTypeLike extends TypeLike { readonly __typename?: typeof UnknownContentTypeErrorTypename; }
export const UserFacingAuthzErrorTypename = 'UserFacingAuthzError';
export interface UserFacingAuthzErrorTypeLike extends TypeLike { readonly __typename?: typeof UserFacingAuthzErrorTypename; }
export const ValidationErrorTypename = 'ValidationError';
export interface ValidationErrorTypeLike extends TypeLike { readonly __typename?: typeof ValidationErrorTypename; }
export const AdditionalCostsDrawerTypename = 'AdditionalCostsDrawer';
export interface AdditionalCostsDrawerTypeLike extends TypeLike { readonly __typename?: typeof AdditionalCostsDrawerTypename; }
export const BookDeskDrawerTypename = 'BookDeskDrawer';
export interface BookDeskDrawerTypeLike extends TypeLike { readonly __typename?: typeof BookDeskDrawerTypename; }
export const BookParkingDrawerTypename = 'BookParkingDrawer';
export interface BookParkingDrawerTypeLike extends TypeLike { readonly __typename?: typeof BookParkingDrawerTypename; }
export const CopyrightsDrawerTypename = 'CopyrightsDrawer';
export interface CopyrightsDrawerTypeLike extends TypeLike { readonly __typename?: typeof CopyrightsDrawerTypename; }
export const EditAdditionalDataDrawerTypename = 'EditAdditionalDataDrawer';
export interface EditAdditionalDataDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditAdditionalDataDrawerTypename; }
export const EditAddressDrawerTypename = 'EditAddressDrawer';
export interface EditAddressDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditAddressDrawerTypename; }
export const EditProfileDetailsDrawerTypename = 'EditProfileDetailsDrawer';
export interface EditProfileDetailsDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditProfileDetailsDrawerTypename; }
export const EditSkillsAndCertificatesDrawerTypename = 'EditSkillsAndCertificatesDrawer';
export interface EditSkillsAndCertificatesDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditSkillsAndCertificatesDrawerTypename; }
export const EditSocialMediaHandlesDrawerTypename = 'EditSocialMediaHandlesDrawer';
export interface EditSocialMediaHandlesDrawerTypeLike extends TypeLike { readonly __typename?: typeof EditSocialMediaHandlesDrawerTypename; }
export const InvoicesDrawerTypename = 'InvoicesDrawer';
export interface InvoicesDrawerTypeLike extends TypeLike { readonly __typename?: typeof InvoicesDrawerTypename; }
export const TimeReportPreferencesDrawerTypename = 'TimeReportPreferencesDrawer';
export interface TimeReportPreferencesDrawerTypeLike extends TypeLike { readonly __typename?: typeof TimeReportPreferencesDrawerTypename; }
export const AnnualLeaveSummaryTypename = 'AnnualLeaveSummary';
export interface AnnualLeaveSummaryTypeLike extends TypeLike { readonly __typename?: typeof AnnualLeaveSummaryTypename; }
export const AppreciationBonusTypename = 'AppreciationBonus';
export interface AppreciationBonusTypeLike extends TypeLike { readonly __typename?: typeof AppreciationBonusTypename; }
export const BusinessTravelBonusTypename = 'BusinessTravelBonus';
export interface BusinessTravelBonusTypeLike extends TypeLike { readonly __typename?: typeof BusinessTravelBonusTypename; }
export const ClientReferralBonusTypename = 'ClientReferralBonus';
export interface ClientReferralBonusTypeLike extends TypeLike { readonly __typename?: typeof ClientReferralBonusTypename; }
export const ConferenceBonusTypename = 'ConferenceBonus';
export interface ConferenceBonusTypeLike extends TypeLike { readonly __typename?: typeof ConferenceBonusTypename; }
export const CostRechargeBonusTypename = 'CostRechargeBonus';
export interface CostRechargeBonusTypeLike extends TypeLike { readonly __typename?: typeof CostRechargeBonusTypename; }
export const EmployeeReferralBonusTypename = 'EmployeeReferralBonus';
export interface EmployeeReferralBonusTypeLike extends TypeLike { readonly __typename?: typeof EmployeeReferralBonusTypename; }
export const LanguageLearningBonusTypename = 'LanguageLearningBonus';
export interface LanguageLearningBonusTypeLike extends TypeLike { readonly __typename?: typeof LanguageLearningBonusTypename; }
export const OtherBonusTypename = 'OtherBonus';
export interface OtherBonusTypeLike extends TypeLike { readonly __typename?: typeof OtherBonusTypename; }
export const RemoteWorkEquipmentBonusTypename = 'RemoteWorkEquipmentBonus';
export interface RemoteWorkEquipmentBonusTypeLike extends TypeLike { readonly __typename?: typeof RemoteWorkEquipmentBonusTypename; }
export const SalesCommissionsBonusTypename = 'SalesCommissionsBonus';
export interface SalesCommissionsBonusTypeLike extends TypeLike { readonly __typename?: typeof SalesCommissionsBonusTypename; }
export const SeverancePayBonusTypename = 'SeverancePayBonus';
export interface SeverancePayBonusTypeLike extends TypeLike { readonly __typename?: typeof SeverancePayBonusTypename; }
export const ShareholderDividendBonusTypename = 'ShareholderDividendBonus';
export interface ShareholderDividendBonusTypeLike extends TypeLike { readonly __typename?: typeof ShareholderDividendBonusTypename; }
export const TrainingPackageBonusTypename = 'TrainingPackageBonus';
export interface TrainingPackageBonusTypeLike extends TypeLike { readonly __typename?: typeof TrainingPackageBonusTypename; }
export const TrainingPackageExternalDeductionValueTypename = 'TrainingPackageExternalDeductionValue';
export interface TrainingPackageExternalDeductionValueTypeLike extends TypeLike { readonly __typename?: typeof TrainingPackageExternalDeductionValueTypename; }
export const ApprovedTypename = 'Approved';
export interface ApprovedTypeLike extends TypeLike { readonly __typename?: typeof ApprovedTypename; }
export const NotRequiredTypename = 'NotRequired';
export interface NotRequiredTypeLike extends TypeLike { readonly __typename?: typeof NotRequiredTypename; }
export const PendingApprovalTypename = 'PendingApproval';
export interface PendingApprovalTypeLike extends TypeLike { readonly __typename?: typeof PendingApprovalTypename; }
export const B2BContractTypename = 'B2BContract';
export interface B2BContractTypeLike extends TypeLike { readonly __typename?: typeof B2BContractTypename; }
export const EmploymentContractTypename = 'EmploymentContract';
export interface EmploymentContractTypeLike extends TypeLike { readonly __typename?: typeof EmploymentContractTypename; }
export const SubcontractTypename = 'Subcontract';
export interface SubcontractTypeLike extends TypeLike { readonly __typename?: typeof SubcontractTypename; }
export const B2BContractSalaryDetailsTypename = 'B2BContractSalaryDetails';
export interface B2BContractSalaryDetailsTypeLike extends TypeLike { readonly __typename?: typeof B2BContractSalaryDetailsTypename; }
export const EmploymentContractSalaryDetailsTypename = 'EmploymentContractSalaryDetails';
export interface EmploymentContractSalaryDetailsTypeLike extends TypeLike { readonly __typename?: typeof EmploymentContractSalaryDetailsTypename; }
export const B2BTimeReportStatsTypename = 'B2BTimeReportStats';
export interface B2BTimeReportStatsTypeLike extends TypeLike { readonly __typename?: typeof B2BTimeReportStatsTypename; }
export const EmploymentTimeReportStatsTypename = 'EmploymentTimeReportStats';
export interface EmploymentTimeReportStatsTypeLike extends TypeLike { readonly __typename?: typeof EmploymentTimeReportStatsTypename; }
export const BenefitTypename = 'Benefit';
export interface BenefitTypeLike extends TypeLike { readonly __typename?: typeof BenefitTypename; }
export const SubBenefitTypename = 'SubBenefit';
export interface SubBenefitTypeLike extends TypeLike { readonly __typename?: typeof SubBenefitTypename; }
export const BenefitAdditionalAdultsTypename = 'BenefitAdditionalAdults';
export interface BenefitAdditionalAdultsTypeLike extends TypeLike { readonly __typename?: typeof BenefitAdditionalAdultsTypename; }
export const BenefitAdditionalFamilyTypename = 'BenefitAdditionalFamily';
export interface BenefitAdditionalFamilyTypeLike extends TypeLike { readonly __typename?: typeof BenefitAdditionalFamilyTypename; }
export const BenefitAdditionalKidsTypename = 'BenefitAdditionalKids';
export interface BenefitAdditionalKidsTypeLike extends TypeLike { readonly __typename?: typeof BenefitAdditionalKidsTypename; }
export const BonusResponseTypename = 'BonusResponse';
export interface BonusResponseTypeLike extends TypeLike { readonly __typename?: typeof BonusResponseTypename; }
export const BooleanResponseTypename = 'BooleanResponse';
export interface BooleanResponseTypeLike extends TypeLike { readonly __typename?: typeof BooleanResponseTypename; }
export const CertificateTypename = 'Certificate';
export interface CertificateTypeLike extends TypeLike { readonly __typename?: typeof CertificateTypename; }
export const ClosedEndLocalDateRangeTypename = 'ClosedEndLocalDateRange';
export interface ClosedEndLocalDateRangeTypeLike extends TypeLike { readonly __typename?: typeof ClosedEndLocalDateRangeTypename; }
export const ContractResponseTypename = 'ContractResponse';
export interface ContractResponseTypeLike extends TypeLike { readonly __typename?: typeof ContractResponseTypename; }
export const ContractSalaryDetailsResponseTypename = 'ContractSalaryDetailsResponse';
export interface ContractSalaryDetailsResponseTypeLike extends TypeLike { readonly __typename?: typeof ContractSalaryDetailsResponseTypename; }
export const DaysBalanceTypename = 'DaysBalance';
export interface DaysBalanceTypeLike extends TypeLike { readonly __typename?: typeof DaysBalanceTypename; }
export const DownloadableFileUrlTypename = 'DownloadableFileUrl';
export interface DownloadableFileUrlTypeLike extends TypeLike { readonly __typename?: typeof DownloadableFileUrlTypename; }
export const DailyIncomeRowTypename = 'DailyIncomeRow';
export interface DailyIncomeRowTypeLike extends TypeLike { readonly __typename?: typeof DailyIncomeRowTypename; }
export const HourlyIncomeRowTypename = 'HourlyIncomeRow';
export interface HourlyIncomeRowTypeLike extends TypeLike { readonly __typename?: typeof HourlyIncomeRowTypename; }
export const MonthlyIncomeRowTypename = 'MonthlyIncomeRow';
export interface MonthlyIncomeRowTypeLike extends TypeLike { readonly __typename?: typeof MonthlyIncomeRowTypename; }
export const InvoiceDetailsTypename = 'InvoiceDetails';
export interface InvoiceDetailsTypeLike extends TypeLike { readonly __typename?: typeof InvoiceDetailsTypename; }
export const ListOfAbsenceRecordResponseTypename = 'ListOfAbsenceRecordResponse';
export interface ListOfAbsenceRecordResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfAbsenceRecordResponseTypename; }
export const ListOfAssignedProjectResponseTypename = 'ListOfAssignedProjectResponse';
export interface ListOfAssignedProjectResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfAssignedProjectResponseTypename; }
export const ListOfContractSalaryDetailsResponseTypename = 'ListOfContractSalaryDetailsResponse';
export interface ListOfContractSalaryDetailsResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfContractSalaryDetailsResponseTypename; }
export const ListOfDeskAssignmentResponseTypename = 'ListOfDeskAssignmentResponse';
export interface ListOfDeskAssignmentResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfDeskAssignmentResponseTypename; }
export const ListOfKvWorkTagIdMinutesResponseTypename = 'ListOfKvWorkTagIdMinutesResponse';
export interface ListOfKvWorkTagIdMinutesResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfKvWorkTagIdMinutesResponseTypename; }
export const ListOfOnCallRecordResponseTypename = 'ListOfOnCallRecordResponse';
export interface ListOfOnCallRecordResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfOnCallRecordResponseTypename; }
export const ListOfProjectIdResponseTypename = 'ListOfProjectIdResponse';
export interface ListOfProjectIdResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfProjectIdResponseTypename; }
export const ListOfProjectTimeReportsResponseTypename = 'ListOfProjectTimeReportsResponse';
export interface ListOfProjectTimeReportsResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfProjectTimeReportsResponseTypename; }
export const ListOfReservableOfficeResponseTypename = 'ListOfReservableOfficeResponse';
export interface ListOfReservableOfficeResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfReservableOfficeResponseTypename; }
export const ListOfReservationRequestResponseTypename = 'ListOfReservationRequestResponse';
export interface ListOfReservationRequestResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfReservationRequestResponseTypename; }
export const ListOfTimeReportValidationResponseTypename = 'ListOfTimeReportValidationResponse';
export interface ListOfTimeReportValidationResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfTimeReportValidationResponseTypename; }
export const ListOfWorkRecordResponseTypename = 'ListOfWorkRecordResponse';
export interface ListOfWorkRecordResponseTypeLike extends TypeLike { readonly __typename?: typeof ListOfWorkRecordResponseTypename; }
export const OfficeAvailabilityTypename = 'OfficeAvailability';
export interface OfficeAvailabilityTypeLike extends TypeLike { readonly __typename?: typeof OfficeAvailabilityTypename; }
export const OfficeReservationSettingsTypename = 'OfficeReservationSettings';
export interface OfficeReservationSettingsTypeLike extends TypeLike { readonly __typename?: typeof OfficeReservationSettingsTypename; }
export const OnCallMultipliersTypename = 'OnCallMultipliers';
export interface OnCallMultipliersTypeLike extends TypeLike { readonly __typename?: typeof OnCallMultipliersTypename; }
export const OnCallRecordTypename = 'OnCallRecord';
export interface OnCallRecordTypeLike extends TypeLike { readonly __typename?: typeof OnCallRecordTypename; }
export const ReservationRequestTypename = 'ReservationRequest';
export interface ReservationRequestTypeLike extends TypeLike { readonly __typename?: typeof ReservationRequestTypename; }
export const IncompleteDataTypename = 'IncompleteData';
export interface IncompleteDataTypeLike extends TypeLike { readonly __typename?: typeof IncompleteDataTypename; }
export const PaymentDisbursedTypename = 'PaymentDisbursed';
export interface PaymentDisbursedTypeLike extends TypeLike { readonly __typename?: typeof PaymentDisbursedTypename; }
export const ReadyTypename = 'Ready';
export interface ReadyTypeLike extends TypeLike { readonly __typename?: typeof ReadyTypename; }
export const TimeReportTypename = 'TimeReport';
export interface TimeReportTypeLike extends TypeLike { readonly __typename?: typeof TimeReportTypename; }
export const IncompleteEntriesTypename = 'IncompleteEntries';
export interface IncompleteEntriesTypeLike extends TypeLike { readonly __typename?: typeof IncompleteEntriesTypename; }
export const MissingEntriesTypename = 'MissingEntries';
export interface MissingEntriesTypeLike extends TypeLike { readonly __typename?: typeof MissingEntriesTypename; }
export const NegativeFlexTimeBalanceTypename = 'NegativeFlexTimeBalance';
export interface NegativeFlexTimeBalanceTypeLike extends TypeLike { readonly __typename?: typeof NegativeFlexTimeBalanceTypename; }
export const TrainingBudgetSummaryTypename = 'TrainingBudgetSummary';
export interface TrainingBudgetSummaryTypeLike extends TypeLike { readonly __typename?: typeof TrainingBudgetSummaryTypename; }
export const UnitResponseTypename = 'UnitResponse';
export interface UnitResponseTypeLike extends TypeLike { readonly __typename?: typeof UnitResponseTypename; }
export const UserTypename = 'User';
export interface UserTypeLike extends TypeLike { readonly __typename?: typeof UserTypename; }
export const VatAppliedTypename = 'VatApplied';
export interface VatAppliedTypeLike extends TypeLike { readonly __typename?: typeof VatAppliedTypename; }
export const VatNotAppliedTypename = 'VatNotApplied';
export interface VatNotAppliedTypeLike extends TypeLike { readonly __typename?: typeof VatNotAppliedTypename; }
export const WorkRecordTypename = 'WorkRecord';
export interface WorkRecordTypeLike extends TypeLike { readonly __typename?: typeof WorkRecordTypename; }
export const WorkTransferProtocolTypename = 'WorkTransferProtocol';
export interface WorkTransferProtocolTypeLike extends TypeLike { readonly __typename?: typeof WorkTransferProtocolTypename; }
export const FileTypename = 'File';
export interface FileTypeLike extends TypeLike { readonly __typename?: typeof FileTypename; }
export const NoWorkToBeTransferedThisMonthTypename = 'NoWorkToBeTransferedThisMonth';
export interface NoWorkToBeTransferedThisMonthTypeLike extends TypeLike { readonly __typename?: typeof NoWorkToBeTransferedThisMonthTypename; }

/** types implementing AbsenceRecordOrNfsError */
export type AbsenceRecordOrNfsErrorUnionInterface = AbsenceRecord | NfsError;
export const AbsenceRecordOrNfsErrorTypename = 'AbsenceRecordOrNfsError';
export const AbsenceRecordOrNfsErrorTypenames = [AbsenceRecordTypename, NfsErrorTypename] as const;

/** types implementing UserError */
export type UserErrorUnionInterface = ActiveReportingRangeError | AggregatedValidationErrors | DuplicatedEntityError | EmptyRequestInputError | EntitiesNotFoundError | EntityNotFoundError | EntityVersionMismatched | ForeignKeyConstraintError | IllegalPositionRemovalError | IncompleteArgumentError | IncompleteArgumentsError | InternalNfsError | InvalidApiTokenError | InvalidArgumentsError | InvalidCompanyTypeError | InvalidContentTypeError | InvalidCursorError | InvalidEmailAddress | InvalidStateError | InvoiceAlreadyAcceptedError | InvoiceImportedFromSaldeoError | LeaveEntitlementExceededError | MissingFileMetadataError | NbpBaseCurrencyError | NoParkingSpotAvailableError | OperationAlreadyInProgressError | OperationNotAvailableError | OtherInvalidRequestError | PaymentCouldNotBeChangedError | PositionInactiveError | RaiseNoLongerDueError | ReservationNotPendingError | ReservationRequestStateError | ResourceAlreadyReservedError | TimeBasedActivityOverlapError | TimeBasedEffectiveFromInPastError | TimeReportOverlapError | TimeReportRecordApprovalNotInPendingStateError | UnauthorizedOperationError | UnknownContentTypeError | UserFacingAuthzError | ValidationError;
export const UserErrorTypename = 'UserError';
export const UserErrorTypenames = [ActiveReportingRangeErrorTypename, AggregatedValidationErrorsTypename, DuplicatedEntityErrorTypename, EmptyRequestInputErrorTypename, EntitiesNotFoundErrorTypename, EntityNotFoundErrorTypename, EntityVersionMismatchedTypename, ForeignKeyConstraintErrorTypename, IllegalPositionRemovalErrorTypename, IncompleteArgumentErrorTypename, IncompleteArgumentsErrorTypename, InternalNfsErrorTypename, InvalidApiTokenErrorTypename, InvalidArgumentsErrorTypename, InvalidCompanyTypeErrorTypename, InvalidContentTypeErrorTypename, InvalidCursorErrorTypename, InvalidEmailAddressTypename, InvalidStateErrorTypename, InvoiceAlreadyAcceptedErrorTypename, InvoiceImportedFromSaldeoErrorTypename, LeaveEntitlementExceededErrorTypename, MissingFileMetadataErrorTypename, NbpBaseCurrencyErrorTypename, NoParkingSpotAvailableErrorTypename, OperationAlreadyInProgressErrorTypename, OperationNotAvailableErrorTypename, OtherInvalidRequestErrorTypename, PaymentCouldNotBeChangedErrorTypename, PositionInactiveErrorTypename, RaiseNoLongerDueErrorTypename, ReservationNotPendingErrorTypename, ReservationRequestStateErrorTypename, ResourceAlreadyReservedErrorTypename, TimeBasedActivityOverlapErrorTypename, TimeBasedEffectiveFromInPastErrorTypename, TimeReportOverlapErrorTypename, TimeReportRecordApprovalNotInPendingStateErrorTypename, UnauthorizedOperationErrorTypename, UnknownContentTypeErrorTypename, UserFacingAuthzErrorTypename, ValidationErrorTypename] as const;

/** types implementing AbstractDrawer */
export type AbstractDrawerUnionInterface = AdditionalCostsDrawer | BookDeskDrawer | BookParkingDrawer | CopyrightsDrawer | EditAdditionalDataDrawer | EditAddressDrawer | EditProfileDetailsDrawer | EditSkillsAndCertificatesDrawer | EditSocialMediaHandlesDrawer | InvoicesDrawer | TimeReportPreferencesDrawer;
export const AbstractDrawerTypename = 'AbstractDrawer';
export const AbstractDrawerTypenames = [AdditionalCostsDrawerTypename, BookDeskDrawerTypename, BookParkingDrawerTypename, CopyrightsDrawerTypename, EditAdditionalDataDrawerTypename, EditAddressDrawerTypename, EditProfileDetailsDrawerTypename, EditSkillsAndCertificatesDrawerTypename, EditSocialMediaHandlesDrawerTypename, InvoicesDrawerTypename, TimeReportPreferencesDrawerTypename] as const;

/** types implementing AnnualLeaveSummaryOrNfsError */
export type AnnualLeaveSummaryOrNfsErrorUnionInterface = AnnualLeaveSummary | NfsError;
export const AnnualLeaveSummaryOrNfsErrorTypename = 'AnnualLeaveSummaryOrNfsError';
export const AnnualLeaveSummaryOrNfsErrorTypenames = [AnnualLeaveSummaryTypename, NfsErrorTypename] as const;

/** types implementing Bonus */
export type BonusUnionInterface = AppreciationBonus | BusinessTravelBonus | ClientReferralBonus | ConferenceBonus | CostRechargeBonus | EmployeeReferralBonus | LanguageLearningBonus | OtherBonus | RemoteWorkEquipmentBonus | SalesCommissionsBonus | SeverancePayBonus | ShareholderDividendBonus | TrainingPackageBonus | TrainingPackageExternalDeductionValue;
export const BonusTypename = 'Bonus';
export const BonusTypenames = [AppreciationBonusTypename, BusinessTravelBonusTypename, ClientReferralBonusTypename, ConferenceBonusTypename, CostRechargeBonusTypename, EmployeeReferralBonusTypename, LanguageLearningBonusTypename, OtherBonusTypename, RemoteWorkEquipmentBonusTypename, SalesCommissionsBonusTypename, SeverancePayBonusTypename, ShareholderDividendBonusTypename, TrainingPackageBonusTypename, TrainingPackageExternalDeductionValueTypename] as const;

/** types implementing Approval */
export type ApprovalUnionInterface = Approved | NotRequired | PendingApproval;
export const ApprovalTypename = 'Approval';
export const ApprovalTypenames = [ApprovedTypename, NotRequiredTypename, PendingApprovalTypename] as const;

/** types implementing Contract */
export type ContractUnionInterface = B2BContract | EmploymentContract | Subcontract;
export const ContractTypename = 'Contract';
export const ContractTypenames = [B2BContractTypename, EmploymentContractTypename, SubcontractTypename] as const;

/** types implementing ContractSalaryDetails */
export type ContractSalaryDetailsUnionInterface = B2BContractSalaryDetails | EmploymentContractSalaryDetails;
export const ContractSalaryDetailsTypename = 'ContractSalaryDetails';
export const ContractSalaryDetailsTypenames = [B2BContractSalaryDetailsTypename, EmploymentContractSalaryDetailsTypename] as const;

/** types implementing TimeReportStats */
export type TimeReportStatsUnionInterface = B2BTimeReportStats | EmploymentTimeReportStats;
export const TimeReportStatsTypename = 'TimeReportStats';
export const TimeReportStatsTypenames = [B2BTimeReportStatsTypename, EmploymentTimeReportStatsTypename] as const;

/** types implementing BenefitCommon */
export type BenefitCommonUnionInterface = Benefit | SubBenefit;
export const BenefitCommonTypename = 'BenefitCommon';
export const BenefitCommonTypenames = [BenefitTypename, SubBenefitTypename] as const;

/** types implementing BenefitAdditionalPeople */
export type BenefitAdditionalPeopleUnionInterface = BenefitAdditionalAdults | BenefitAdditionalFamily | BenefitAdditionalKids;
export const BenefitAdditionalPeopleTypename = 'BenefitAdditionalPeople';
export const BenefitAdditionalPeopleTypenames = [BenefitAdditionalAdultsTypename, BenefitAdditionalFamilyTypename, BenefitAdditionalKidsTypename] as const;

/** types implementing BonusResponseOrNfsError */
export type BonusResponseOrNfsErrorUnionInterface = BonusResponse | NfsError;
export const BonusResponseOrNfsErrorTypename = 'BonusResponseOrNfsError';
export const BonusResponseOrNfsErrorTypenames = [BonusResponseTypename, NfsErrorTypename] as const;

/** types implementing BooleanResponseOrNfsError */
export type BooleanResponseOrNfsErrorUnionInterface = BooleanResponse | NfsError;
export const BooleanResponseOrNfsErrorTypename = 'BooleanResponseOrNfsError';
export const BooleanResponseOrNfsErrorTypenames = [BooleanResponseTypename, NfsErrorTypename] as const;

/** types implementing CertificateOrNfsError */
export type CertificateOrNfsErrorUnionInterface = Certificate | NfsError;
export const CertificateOrNfsErrorTypename = 'CertificateOrNfsError';
export const CertificateOrNfsErrorTypenames = [CertificateTypename, NfsErrorTypename] as const;

/** types implementing ClosedEndLocalDateRangeOrNfsError */
export type ClosedEndLocalDateRangeOrNfsErrorUnionInterface = ClosedEndLocalDateRange | NfsError;
export const ClosedEndLocalDateRangeOrNfsErrorTypename = 'ClosedEndLocalDateRangeOrNfsError';
export const ClosedEndLocalDateRangeOrNfsErrorTypenames = [ClosedEndLocalDateRangeTypename, NfsErrorTypename] as const;

/** types implementing ContractResponseOrNfsError */
export type ContractResponseOrNfsErrorUnionInterface = ContractResponse | NfsError;
export const ContractResponseOrNfsErrorTypename = 'ContractResponseOrNfsError';
export const ContractResponseOrNfsErrorTypenames = [ContractResponseTypename, NfsErrorTypename] as const;

/** types implementing ContractSalaryDetailsResponseOrNfsError */
export type ContractSalaryDetailsResponseOrNfsErrorUnionInterface = ContractSalaryDetailsResponse | NfsError;
export const ContractSalaryDetailsResponseOrNfsErrorTypename = 'ContractSalaryDetailsResponseOrNfsError';
export const ContractSalaryDetailsResponseOrNfsErrorTypenames = [ContractSalaryDetailsResponseTypename, NfsErrorTypename] as const;

/** types implementing DaysBalanceOrNfsError */
export type DaysBalanceOrNfsErrorUnionInterface = DaysBalance | NfsError;
export const DaysBalanceOrNfsErrorTypename = 'DaysBalanceOrNfsError';
export const DaysBalanceOrNfsErrorTypenames = [DaysBalanceTypename, NfsErrorTypename] as const;

/** types implementing DownloadableFileUrlOrNfsError */
export type DownloadableFileUrlOrNfsErrorUnionInterface = DownloadableFileUrl | NfsError;
export const DownloadableFileUrlOrNfsErrorTypename = 'DownloadableFileUrlOrNfsError';
export const DownloadableFileUrlOrNfsErrorTypenames = [DownloadableFileUrlTypename, NfsErrorTypename] as const;

/** types implementing IncomeRow */
export type IncomeRowUnionInterface = DailyIncomeRow | HourlyIncomeRow | MonthlyIncomeRow;
export const IncomeRowTypename = 'IncomeRow';
export const IncomeRowTypenames = [DailyIncomeRowTypename, HourlyIncomeRowTypename, MonthlyIncomeRowTypename] as const;

/** types implementing InvoiceDetailsOrNfsError */
export type InvoiceDetailsOrNfsErrorUnionInterface = InvoiceDetails | NfsError;
export const InvoiceDetailsOrNfsErrorTypename = 'InvoiceDetailsOrNfsError';
export const InvoiceDetailsOrNfsErrorTypenames = [InvoiceDetailsTypename, NfsErrorTypename] as const;

/** types implementing ListOfAbsenceRecordResponseOrNfsError */
export type ListOfAbsenceRecordResponseOrNfsErrorUnionInterface = ListOfAbsenceRecordResponse | NfsError;
export const ListOfAbsenceRecordResponseOrNfsErrorTypename = 'ListOfAbsenceRecordResponseOrNfsError';
export const ListOfAbsenceRecordResponseOrNfsErrorTypenames = [ListOfAbsenceRecordResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfAssignedProjectResponseOrNfsError */
export type ListOfAssignedProjectResponseOrNfsErrorUnionInterface = ListOfAssignedProjectResponse | NfsError;
export const ListOfAssignedProjectResponseOrNfsErrorTypename = 'ListOfAssignedProjectResponseOrNfsError';
export const ListOfAssignedProjectResponseOrNfsErrorTypenames = [ListOfAssignedProjectResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfContractSalaryDetailsResponseOrNfsError */
export type ListOfContractSalaryDetailsResponseOrNfsErrorUnionInterface = ListOfContractSalaryDetailsResponse | NfsError;
export const ListOfContractSalaryDetailsResponseOrNfsErrorTypename = 'ListOfContractSalaryDetailsResponseOrNfsError';
export const ListOfContractSalaryDetailsResponseOrNfsErrorTypenames = [ListOfContractSalaryDetailsResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfDeskAssignmentResponseOrNfsError */
export type ListOfDeskAssignmentResponseOrNfsErrorUnionInterface = ListOfDeskAssignmentResponse | NfsError;
export const ListOfDeskAssignmentResponseOrNfsErrorTypename = 'ListOfDeskAssignmentResponseOrNfsError';
export const ListOfDeskAssignmentResponseOrNfsErrorTypenames = [ListOfDeskAssignmentResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfKvWorkTagIdMinutesResponseOrNfsError */
export type ListOfKvWorkTagIdMinutesResponseOrNfsErrorUnionInterface = ListOfKvWorkTagIdMinutesResponse | NfsError;
export const ListOfKvWorkTagIdMinutesResponseOrNfsErrorTypename = 'ListOfKvWorkTagIdMinutesResponseOrNfsError';
export const ListOfKvWorkTagIdMinutesResponseOrNfsErrorTypenames = [ListOfKvWorkTagIdMinutesResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfOnCallRecordResponseOrNfsError */
export type ListOfOnCallRecordResponseOrNfsErrorUnionInterface = ListOfOnCallRecordResponse | NfsError;
export const ListOfOnCallRecordResponseOrNfsErrorTypename = 'ListOfOnCallRecordResponseOrNfsError';
export const ListOfOnCallRecordResponseOrNfsErrorTypenames = [ListOfOnCallRecordResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfProjectIdResponseOrNfsError */
export type ListOfProjectIdResponseOrNfsErrorUnionInterface = ListOfProjectIdResponse | NfsError;
export const ListOfProjectIdResponseOrNfsErrorTypename = 'ListOfProjectIdResponseOrNfsError';
export const ListOfProjectIdResponseOrNfsErrorTypenames = [ListOfProjectIdResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfProjectTimeReportsResponseOrNfsError */
export type ListOfProjectTimeReportsResponseOrNfsErrorUnionInterface = ListOfProjectTimeReportsResponse | NfsError;
export const ListOfProjectTimeReportsResponseOrNfsErrorTypename = 'ListOfProjectTimeReportsResponseOrNfsError';
export const ListOfProjectTimeReportsResponseOrNfsErrorTypenames = [ListOfProjectTimeReportsResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfReservableOfficeResponseOrNfsError */
export type ListOfReservableOfficeResponseOrNfsErrorUnionInterface = ListOfReservableOfficeResponse | NfsError;
export const ListOfReservableOfficeResponseOrNfsErrorTypename = 'ListOfReservableOfficeResponseOrNfsError';
export const ListOfReservableOfficeResponseOrNfsErrorTypenames = [ListOfReservableOfficeResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfReservationRequestResponseOrNfsError */
export type ListOfReservationRequestResponseOrNfsErrorUnionInterface = ListOfReservationRequestResponse | NfsError;
export const ListOfReservationRequestResponseOrNfsErrorTypename = 'ListOfReservationRequestResponseOrNfsError';
export const ListOfReservationRequestResponseOrNfsErrorTypenames = [ListOfReservationRequestResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfTimeReportValidationResponseOrNfsError */
export type ListOfTimeReportValidationResponseOrNfsErrorUnionInterface = ListOfTimeReportValidationResponse | NfsError;
export const ListOfTimeReportValidationResponseOrNfsErrorTypename = 'ListOfTimeReportValidationResponseOrNfsError';
export const ListOfTimeReportValidationResponseOrNfsErrorTypenames = [ListOfTimeReportValidationResponseTypename, NfsErrorTypename] as const;

/** types implementing ListOfWorkRecordResponseOrNfsError */
export type ListOfWorkRecordResponseOrNfsErrorUnionInterface = ListOfWorkRecordResponse | NfsError;
export const ListOfWorkRecordResponseOrNfsErrorTypename = 'ListOfWorkRecordResponseOrNfsError';
export const ListOfWorkRecordResponseOrNfsErrorTypenames = [ListOfWorkRecordResponseTypename, NfsErrorTypename] as const;

/** types implementing OfficeAvailabilityOrNfsError */
export type OfficeAvailabilityOrNfsErrorUnionInterface = NfsError | OfficeAvailability;
export const OfficeAvailabilityOrNfsErrorTypename = 'OfficeAvailabilityOrNfsError';
export const OfficeAvailabilityOrNfsErrorTypenames = [NfsErrorTypename, OfficeAvailabilityTypename] as const;

/** types implementing OfficeReservationSettingsOrNfsError */
export type OfficeReservationSettingsOrNfsErrorUnionInterface = NfsError | OfficeReservationSettings;
export const OfficeReservationSettingsOrNfsErrorTypename = 'OfficeReservationSettingsOrNfsError';
export const OfficeReservationSettingsOrNfsErrorTypenames = [NfsErrorTypename, OfficeReservationSettingsTypename] as const;

/** types implementing OnCallMultipliersOrNfsError */
export type OnCallMultipliersOrNfsErrorUnionInterface = NfsError | OnCallMultipliers;
export const OnCallMultipliersOrNfsErrorTypename = 'OnCallMultipliersOrNfsError';
export const OnCallMultipliersOrNfsErrorTypenames = [NfsErrorTypename, OnCallMultipliersTypename] as const;

/** types implementing OnCallRecordOrNfsError */
export type OnCallRecordOrNfsErrorUnionInterface = NfsError | OnCallRecord;
export const OnCallRecordOrNfsErrorTypename = 'OnCallRecordOrNfsError';
export const OnCallRecordOrNfsErrorTypenames = [NfsErrorTypename, OnCallRecordTypename] as const;

/** types implementing ReservationRequestOrNfsError */
export type ReservationRequestOrNfsErrorUnionInterface = NfsError | ReservationRequest;
export const ReservationRequestOrNfsErrorTypename = 'ReservationRequestOrNfsError';
export const ReservationRequestOrNfsErrorTypenames = [NfsErrorTypename, ReservationRequestTypename] as const;

/** types implementing SalaryState */
export type SalaryStateUnionInterface = IncompleteData | PaymentDisbursed | Ready;
export const SalaryStateTypename = 'SalaryState';
export const SalaryStateTypenames = [IncompleteDataTypename, PaymentDisbursedTypename, ReadyTypename] as const;

/** types implementing TimeReportOrNfsError */
export type TimeReportOrNfsErrorUnionInterface = NfsError | TimeReport;
export const TimeReportOrNfsErrorTypename = 'TimeReportOrNfsError';
export const TimeReportOrNfsErrorTypenames = [NfsErrorTypename, TimeReportTypename] as const;

/** types implementing TimeReportValidation */
export type TimeReportValidationUnionInterface = IncompleteEntries | MissingEntries | NegativeFlexTimeBalance;
export const TimeReportValidationTypename = 'TimeReportValidation';
export const TimeReportValidationTypenames = [IncompleteEntriesTypename, MissingEntriesTypename, NegativeFlexTimeBalanceTypename] as const;

/** types implementing TrainingBudgetSummaryOrNfsError */
export type TrainingBudgetSummaryOrNfsErrorUnionInterface = NfsError | TrainingBudgetSummary;
export const TrainingBudgetSummaryOrNfsErrorTypename = 'TrainingBudgetSummaryOrNfsError';
export const TrainingBudgetSummaryOrNfsErrorTypenames = [NfsErrorTypename, TrainingBudgetSummaryTypename] as const;

/** types implementing UnitResponseOrNfsError */
export type UnitResponseOrNfsErrorUnionInterface = NfsError | UnitResponse;
export const UnitResponseOrNfsErrorTypename = 'UnitResponseOrNfsError';
export const UnitResponseOrNfsErrorTypenames = [NfsErrorTypename, UnitResponseTypename] as const;

/** types implementing UserOrNfsError */
export type UserOrNfsErrorUnionInterface = NfsError | User;
export const UserOrNfsErrorTypename = 'UserOrNfsError';
export const UserOrNfsErrorTypenames = [NfsErrorTypename, UserTypename] as const;

/** types implementing VatType */
export type VatTypeUnionInterface = VatApplied | VatNotApplied;
export const VatTypeTypename = 'VatType';
export const VatTypeTypenames = [VatAppliedTypename, VatNotAppliedTypename] as const;

/** types implementing WorkRecordOrNfsError */
export type WorkRecordOrNfsErrorUnionInterface = NfsError | WorkRecord;
export const WorkRecordOrNfsErrorTypename = 'WorkRecordOrNfsError';
export const WorkRecordOrNfsErrorTypenames = [NfsErrorTypename, WorkRecordTypename] as const;

/** types implementing WorkTransferProtocolOrNfsError */
export type WorkTransferProtocolOrNfsErrorUnionInterface = NfsError | WorkTransferProtocol;
export const WorkTransferProtocolOrNfsErrorTypename = 'WorkTransferProtocolOrNfsError';
export const WorkTransferProtocolOrNfsErrorTypenames = [NfsErrorTypename, WorkTransferProtocolTypename] as const;

/** types implementing WorkTransferProtocolPayload */
export type WorkTransferProtocolPayloadUnionInterface = File | NoWorkToBeTransferedThisMonth;
export const WorkTransferProtocolPayloadTypename = 'WorkTransferProtocolPayload';
export const WorkTransferProtocolPayloadTypenames = [FileTypename, NoWorkToBeTransferedThisMonthTypename] as const;

type TypeLike = { readonly __typename?: string };
export type InstanceOf<T extends TypeLike, U extends string> = Extract<T, { __typename?: U | undefined}>
export interface StrictTypeLike extends TypeLike { readonly __typename: string }
export function isInstanceOf<T extends TypeLike, U extends string>(typ: T, typename: U): typ is InstanceOf<T, U> {
  return typ.__typename === typename;
}
export const ApprovalFragmentDoc = /*#__PURE__*/ gql`
    fragment Approval on Approval {
  ... on Approved {
    by {
      id
      firstName
      lastName
    }
    at
  }
  ... on PendingApproval {
    isCurrentUserAllowedToApprove
  }
}
    `;
export const NetGrossFragmentDoc = /*#__PURE__*/ gql`
    fragment NetGross on NetGross {
  net
  gross
}
    `;
export const AdditionalCostDrawerBonusFragmentDoc = /*#__PURE__*/ gql`
    fragment AdditionalCostDrawer_Bonus on Bonus {
  applyAt
  id
  note
  revoked
  paidOutAt
  allocateCostToProject {
    id
    name
  }
  approval {
    ...Approval
  }
  amount {
    ...NetGross
  }
  ... on LanguageLearningBonus {
    language
    quarterYear {
      quarter
      year
    }
  }
  ... on OtherBonus {
    description
  }
  ... on CostRechargeBonus {
    description
  }
}
    ${ApprovalFragmentDoc}
${NetGrossFragmentDoc}`;
export const AddressFragmentDoc = /*#__PURE__*/ gql`
    fragment Address on Address {
  country
  region
  city
  postalCode
  streetLine
}
    `;
export const BenefitSectionsExternalBeneficiaryFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitSections_ExternalBeneficiary on ExternalBeneficiary {
  id
  firstName
  lastName
  email
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const ExternalBeneficiaryFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalBeneficiary on ExternalBeneficiary {
  id
  firstName
  lastName
  email
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const VatTypeFragmentDoc = /*#__PURE__*/ gql`
    fragment VatType on VatType {
  ... on VatApplied {
    value
  }
  ... on VatNotApplied {
    reason
  }
}
    `;
export const BenefitVariantRateFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitVariantRate on BenefitVariantRate {
  vat {
    ...VatType
  }
  netGross {
    net
    gross
  }
  period
}
    ${VatTypeFragmentDoc}`;
export const BenefitAdditionalPeopleFragmentDoc = /*#__PURE__*/ gql`
    fragment BenefitAdditionalPeople on BenefitAdditionalPeople {
  ... on BenefitAdditionalAdults {
    adults
  }
  ... on BenefitAdditionalKids {
    kids
  }
  ... on BenefitAdditionalFamily {
    adults
    kids
  }
}
    `;
export const UserBenefitSectionsBenefitVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment UserBenefitSections_BenefitVariant on BenefitVariant {
  id
  productId
  startDate
  endDate
  buyerType
  contractTypes
  promiseeRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  promisorRate {
    value {
      ...BenefitVariantRate
    }
    futureUpdates {
      activityId
      applyDate
      value {
        value {
          ...BenefitVariantRate
        }
      }
    }
  }
  parent {
    id
    name
    alternativeBenefitsGroupId
    ... on Benefit {
      benefitParent: parent
    }
  }
  additionalPeople {
    ...BenefitAdditionalPeople
  }
}
    ${BenefitVariantRateFragmentDoc}
${BenefitAdditionalPeopleFragmentDoc}`;
export const UserBenefitSectionsAssignedVariantFragmentDoc = /*#__PURE__*/ gql`
    fragment UserBenefitSections_AssignedVariant on AssignedVariant {
  id
  invoiceTo {
    value {
      ...ExternalBeneficiary
    }
    futureUpdates {
      applyDate
      activityId
      value {
        value {
          ...ExternalBeneficiary
        }
      }
    }
    history {
      applyDate
      activityId
      value {
        value {
          ...ExternalBeneficiary
        }
      }
    }
  }
  externalBeneficiaries {
    value {
      ...ExternalBeneficiary
    }
    futureUpdates {
      applyDate
      activityId
      value {
        ...ExternalBeneficiary
      }
    }
    history {
      applyDate
      activityId
      value {
        ...ExternalBeneficiary
      }
    }
  }
  buyerType {
    value
    futureUpdates {
      applyDate
      activityId
      value
    }
    history {
      applyDate
    }
  }
  active {
    value
    futureUpdates {
      applyDate
      activityId
      value
    }
    history {
      applyDate
      activityId
      value
    }
  }
  variant {
    value {
      ...UserBenefitSections_BenefitVariant
    }
    futureUpdates {
      applyDate
      activityId
      value {
        ...UserBenefitSections_BenefitVariant
      }
    }
    history {
      applyDate
      activityId
      value {
        ...UserBenefitSections_BenefitVariant
      }
    }
  }
}
    ${ExternalBeneficiaryFragmentDoc}
${UserBenefitSectionsBenefitVariantFragmentDoc}`;
export const CopyrightsDrawerWorkTransferFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyrightsDrawer_WorkTransfer on WorkTransferProtocol {
  id
  description
  payload {
    ... on File {
      value {
        url
        fileName
      }
    }
  }
  approval {
    ...Approval
  }
}
    ${ApprovalFragmentDoc}`;
export const CopyrightsDrawerSalaryFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyrightsDrawer_Salary on EmploymentContractSalaryDetails {
  contractId
  yearMonth
  workTransferProtocols {
    ...CopyrightsDrawer_WorkTransfer
  }
}
    ${CopyrightsDrawerWorkTransferFragmentDoc}`;
export const CopyrightTrButtonContractFragmentDoc = /*#__PURE__*/ gql`
    fragment CopyrightTRButton_Contract on Contract {
  id
  ... on EmploymentContract {
    copyrightCosts {
      value
      history {
        activityId
        applyDate
        value {
          value
        }
      }
      futureUpdates {
        activityId
        applyDate
        value {
          value
        }
      }
    }
  }
}
    `;
export const DirectReportingStructureUserFragmentDoc = /*#__PURE__*/ gql`
    fragment DirectReportingStructure_User on Person {
  firstName
  lastName
  email
  avatar
  role
}
    `;
export const InvoicesDrawerSalaryStateFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoicesDrawer_SalaryState on SalaryState {
  __typename
  ... on PaymentDisbursed {
    transferState
  }
}
    `;
export const InvoicesDrawerInvoiceDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoicesDrawer_InvoiceDetails on InvoiceDetails {
  id
  correct
  number
  userNote
  ksefNumber
  grossValue
  currency
  file {
    url
    fileName
  }
}
    `;
export const InvoicesDrawerSalaryFragmentDoc = /*#__PURE__*/ gql`
    fragment InvoicesDrawer_Salary on B2BContractSalaryDetails {
  contractId
  yearMonth
  salaryState {
    ...InvoicesDrawer_SalaryState
  }
  invoiceDetails {
    ...InvoicesDrawer_InvoiceDetails
  }
}
    ${InvoicesDrawerSalaryStateFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;
export const TimeReportDashBoardProviderTimeReportValidationsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_TimeReportValidations on TimeReportValidation {
  ... on IncompleteEntries {
    days
  }
  ... on MissingEntries {
    days
  }
  ... on NegativeFlexTimeBalance {
    minutes
  }
}
    `;
export const TimeReportDashBoardProviderAbsenceTypeDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_AbsenceTypeDetails on KVAbsenceTypeAbsenceTypeDetails {
  key
  value {
    canBeReportedOnHoliday
    applicableFor
    canTakeCustomNumberOfHours
    limit
  }
}
    `;
export const TimeReportDashBoardProviderOnCallFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_OnCall on TimeBasedOptClearableOnCallRate {
  value {
    holiday {
      net
    }
  }
  futureUpdates {
    applyDate
    value {
      value {
        holiday {
          net
        }
      }
    }
  }
  history {
    activityId
    applyDate
    value {
      value {
        holiday {
          net
        }
      }
    }
  }
}
    `;
export const TimeReportDashBoardProviderOvertimeRateFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_OvertimeRate on TimeBasedOptClearableNetGross {
  value {
    net
  }
  futureUpdates {
    applyDate
    value {
      value {
        net
      }
    }
  }
  history {
    applyDate
    value {
      value {
        net
      }
    }
  }
}
    `;
export const TimeReportDashBoardProviderTimeBasedRateFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportDashBoardProvider_TimeBasedRate on TimeBasedRate {
  value {
    settlement
  }
  futureUpdates {
    applyDate
    value {
      settlement
    }
  }
  history {
    applyDate
    value {
      settlement
    }
  }
}
    `;
export const AnnualLeaveEntitlementValueFragmentDoc = /*#__PURE__*/ gql`
    fragment AnnualLeaveEntitlementValue on AnnualLeaveEntitlementValue {
  days
  minutes
}
    `;
export const AnnualLeaveBalanceFragmentDoc = /*#__PURE__*/ gql`
    fragment AnnualLeaveBalance on AnnualLeaveBalance {
  entitlement {
    ...AnnualLeaveEntitlementValue
  }
  used {
    ...AnnualLeaveEntitlementValue
  }
  available {
    ...AnnualLeaveEntitlementValue
  }
}
    ${AnnualLeaveEntitlementValueFragmentDoc}`;
export const TimeReportEntryModalAnnualLeaveSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportEntryModal_AnnualLeaveSummary on AnnualLeaveSummary {
  yearlySummary {
    key
    value {
      year
      totalBalance {
        ...AnnualLeaveBalance
      }
      onDemandBalance {
        ...AnnualLeaveBalance
      }
    }
  }
}
    ${AnnualLeaveBalanceFragmentDoc}`;
export const TimeReportFinancesSalaryDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_SalaryDetails on ContractSalaryDetailsResponse {
  value {
    contractId
    yearMonth
    transferAmount
    transferDeduction {
      grossValue
      note
    }
    ... on EmploymentContractSalaryDetails {
      accountingData {
        taxPrepayment
        zusContribution
        ppkAmount
      }
    }
  }
}
    `;
export const RateFragmentDoc = /*#__PURE__*/ gql`
    fragment Rate on Rate {
  settlement
  amount {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const RateDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment RateDetails on RateDetails {
  rate {
    ...Rate
  }
  overtimeRate {
    ...NetGross
  }
  vat
  currency
  rateIncreaseDueToRefundedBenefits {
    ...NetGross
  }
}
    ${RateFragmentDoc}
${NetGrossFragmentDoc}`;
export const DailyIncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment DailyIncomeRow on DailyIncomeRow {
  workDays
  value {
    ...NetGross
  }
  rateAmount {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const HourlyIncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment HourlyIncomeRow on HourlyIncomeRow {
  workHours
  rateAmount {
    ...NetGross
  }
  rateIncreaseDueToRefundedBenefits {
    ...NetGross
  }
  valueWithoutRateIncrease {
    ...NetGross
  }
  valueIncludingRateIncrease {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const MonthlyIncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment MonthlyIncomeRow on MonthlyIncomeRow {
  rateAmount {
    ...NetGross
  }
}
    ${NetGrossFragmentDoc}`;
export const IncomeRowFragmentDoc = /*#__PURE__*/ gql`
    fragment IncomeRow on IncomeRow {
  ...DailyIncomeRow
  ...HourlyIncomeRow
  ...MonthlyIncomeRow
}
    ${DailyIncomeRowFragmentDoc}
${HourlyIncomeRowFragmentDoc}
${MonthlyIncomeRowFragmentDoc}`;
export const TimeReportFinancesBenefitValueFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_BenefitValue on BenefitValue {
  variant {
    id
    productId
    promiseeRate {
      value {
        ...BenefitVariantRate
      }
    }
    promisorRate {
      value {
        ...BenefitVariantRate
      }
    }
    parent {
      id
      name
    }
  }
  refundedValue {
    ...NetGross
  }
  notRefundedValue {
    ...NetGross
  }
  totalValue {
    ...NetGross
  }
}
    ${BenefitVariantRateFragmentDoc}
${NetGrossFragmentDoc}`;
export const TimeReportFinancesIncomeDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_IncomeDetails on IncomeDetails {
  from
  to
  totalWorkTime
  overtimeWorkTime
  standardWorkTime
  rateDetails {
    ...RateDetails
  }
  remoteWorkReimbursement {
    time
    rate
    totalValue {
      ...NetGross
    }
  }
  totalPayout {
    ...NetGross
  }
  payoutWithoutBenefits {
    ...NetGross
  }
  totalValueStandardTimeIncome {
    ...NetGross
  }
  totalValueOvertimeIncome {
    ...NetGross
  }
  standardTimeIncome {
    ...IncomeRow
  }
  overtimeIncome {
    ...HourlyIncomeRow
  }
  onCallLogs {
    multiplier
    shifts
    dates
    shift
    multiplierRate {
      ...NetGross
    }
    totalValue {
      ...NetGross
    }
  }
  totalValueOnCalls {
    ...NetGross
  }
  bonusesValueByCategory {
    bonusCategory
    amount {
      ...NetGross
    }
  }
  totalValueStandardTimeIncomeIncludingBenefits {
    ...NetGross
  }
  totalValueOvertimeIncomeIncludingBenefits {
    ...NetGross
  }
  totalValueBonuses {
    ...NetGross
  }
  benefitsValue {
    totalValueRefunded {
      ...NetGross
    }
    refunded {
      ...TimeReportFinances_BenefitValue
    }
    totalValueNotRefunded {
      ...NetGross
    }
    notRefunded {
      ...TimeReportFinances_BenefitValue
    }
    totalValueThirdParty {
      ...NetGross
    }
    thirdParty {
      ...TimeReportFinances_BenefitValue
    }
    totalValueAll {
      ...NetGross
    }
    refundedHourlyRate {
      ...NetGross
    }
  }
}
    ${RateDetailsFragmentDoc}
${NetGrossFragmentDoc}
${IncomeRowFragmentDoc}
${HourlyIncomeRowFragmentDoc}
${TimeReportFinancesBenefitValueFragmentDoc}`;
export const TimeReportFinancesContractFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportFinances_Contract on Contract {
  id
  ... on EmploymentContract {
    currency {
      value
    }
    rate {
      value {
        ...Rate
      }
    }
    overtimeRate {
      value {
        ...NetGross
      }
    }
  }
  ... on B2BContract {
    currency {
      value
    }
    rate {
      value {
        ...Rate
      }
    }
    overtimeRate {
      value {
        ...NetGross
      }
    }
  }
}
    ${RateFragmentDoc}
${NetGrossFragmentDoc}`;
export const TimeReportLeaveAndTrainingAnnualLeaveSummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_AnnualLeaveSummary on AnnualLeaveSummary {
  yearlySummary {
    key
    value {
      year
      totalBalance {
        ...AnnualLeaveBalance
      }
      balanceThisYear {
        ...AnnualLeaveBalance
      }
      carriedOverEntitlementBalance {
        ...AnnualLeaveBalance
      }
      onDemandBalance {
        ...AnnualLeaveBalance
      }
    }
  }
}
    ${AnnualLeaveBalanceFragmentDoc}`;
export const CentsBalanceFragmentDoc = /*#__PURE__*/ gql`
    fragment CentsBalance on CentsBalance {
  entitlement
  used
  available
}
    `;
export const TimeReportLeaveAndTrainingTrainingPackageFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_TrainingPackage on TrainingBudgetSummary {
  currency
  yearlySummary {
    key
    value {
      year
      totalBalance {
        ...CentsBalance
      }
      balanceThisYear {
        ...CentsBalance
      }
      carriedOverEntitlementBalance {
        ...CentsBalance
      }
    }
  }
}
    ${CentsBalanceFragmentDoc}`;
export const TimeReportLeaveAndTrainingStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_Stats on TimeReportStats {
  incomeDetails {
    from
    to
    bonusesValueByCategory {
      bonusCategory
      amount {
        net
        gross
      }
    }
  }
}
    `;
export const ReportedLeaveDaysFragmentDoc = /*#__PURE__*/ gql`
    fragment ReportedLeaveDays on ReportedLeaveDays {
  annual {
    ...AnnualLeaveEntitlementValue
  }
  outOfOffice
  sickLeave
  sickFamilyMemberCare
  paid
  unpaid
  special
  maternity
  paternity
  caregiving
  childCare
  dueToForceMajeure
  parental
}
    ${AnnualLeaveEntitlementValueFragmentDoc}`;
export const TimeReportLeaveAndTrainingTimeReportFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportLeaveAndTraining_TimeReport on TimeReport {
  timeReportStats {
    ...TimeReportLeaveAndTraining_Stats
    ... on EmploymentTimeReportStats {
      reportedLeaveDays {
        ...ReportedLeaveDays
      }
      flexTime {
        balance
        absenceTime
      }
    }
    ... on B2BTimeReportStats {
      reportedDaysOff
    }
  }
}
    ${TimeReportLeaveAndTrainingStatsFragmentDoc}
${ReportedLeaveDaysFragmentDoc}`;
export const TimeReportStatsB2BStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportStats_B2BStats on B2BTimeReportStats {
  timeBalanceAtEndOfMonth {
    reportedStandardWorkTime
    currentTimeRequirement
    balance
    currentTimeRequirementWithAbsenceTimeSubtracted
    totalTimeInPeriod
  }
  reportedDaysOff
  overtime
  incomeDetails {
    onCallLogs {
      shifts
      multiplier
      dates
      shift
      multiplierRate {
        ...NetGross
      }
      totalValue {
        ...NetGross
      }
    }
  }
}
    ${NetGrossFragmentDoc}`;
export const TimeReportStatsEmploymentStatsFragmentDoc = /*#__PURE__*/ gql`
    fragment TimeReportStats_EmploymentStats on EmploymentTimeReportStats {
  overtime
  timeBalanceAtEndOfMonth {
    reportedStandardWorkTime
    currentTimeRequirement
    balance
    currentTimeRequirementWithAbsenceTimeSubtracted
    totalTimeInPeriod
  }
  reportedLeaveDays {
    ...ReportedLeaveDays
  }
  flexTime {
    balance
    reportedStandardWorkTime
    currentTimeRequirement
    totalTimeInPeriod
    period {
      from
      to
    }
  }
  incomeDetails {
    onCallLogs {
      shifts
      multiplier
      dates
      shift
      multiplierRate {
        ...NetGross
      }
      totalValue {
        ...NetGross
      }
    }
  }
}
    ${ReportedLeaveDaysFragmentDoc}
${NetGrossFragmentDoc}`;
export const NfsErrorFragmentDoc = /*#__PURE__*/ gql`
    fragment NfsError on NfsError {
  error {
    nfsErrorId
    msg
    ... on IncompleteArgumentsError {
      missingFields
    }
    ... on ValidationError {
      fields
    }
    ... on AggregatedValidationErrors {
      errors {
        fields
        desc
      }
    }
    ... on ResourceAlreadyReservedError {
      dates
    }
    ... on NoParkingSpotAvailableError {
      dates
    }
  }
}
    `;
export const WorkRecordFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkRecord on WorkRecord {
  id
  date
  duration
  overtime
  draft
  comment
  remoteWork
  approval {
    ...Approval
  }
  workTag {
    id
    name
  }
  workTime {
    timeFrom
    timeTo
    break
  }
  project {
    id
    name
  }
}
    ${ApprovalFragmentDoc}`;
export const OnCallRecordFragmentDoc = /*#__PURE__*/ gql`
    fragment OnCallRecord on OnCallRecord {
  id
  date
  dayShift
  nightShift
  comment
  project {
    id
    name
  }
}
    `;
export const AbstractDrawerFragmentDoc = /*#__PURE__*/ gql`
    fragment AbstractDrawer on AbstractDrawer {
  id
  visible
  ... on BookDeskDrawer {
    prefillDeskId
    prefillFrom
    prefillRoomId
    prefillTo
    requiredOfficeId
  }
  ... on BookParkingDrawer {
    prefillFrom
    prefillParkingSpotId
    prefillTo
    requiredOfficeId
  }
  ... on TimeReportPreferencesDrawer {
    requiredContractId
  }
}
    `;
export const ChildLevel3FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel3 on AbstractDrawer {
  ...AbstractDrawer
}
    ${AbstractDrawerFragmentDoc}`;
export const ChildLevel2FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel2 on AbstractDrawer {
  ...AbstractDrawer
  child {
    ...ChildLevel3
  }
}
    ${AbstractDrawerFragmentDoc}
${ChildLevel3FragmentDoc}`;
export const ChildLevel1FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel1 on AbstractDrawer {
  ...AbstractDrawer
  child {
    ...ChildLevel2
  }
}
    ${AbstractDrawerFragmentDoc}
${ChildLevel2FragmentDoc}`;
export const ChildLevel0FragmentDoc = /*#__PURE__*/ gql`
    fragment ChildLevel0 on AbstractDrawer {
  ...AbstractDrawer
  child {
    ...ChildLevel1
  }
}
    ${AbstractDrawerFragmentDoc}
${ChildLevel1FragmentDoc}`;
export const WorkTagFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkTag on WorkTag {
  id
  name
  canBeOvertime
  canHaveProjectSelected
  canHaveRecurringWorkRecords
}
    `;
export const LeaveBalanceFragmentDoc = /*#__PURE__*/ gql`
    fragment LeaveBalance on DaysBalance {
  entitlement
  used
  available
}
    `;
export const AbsenceRecordFragmentDoc = /*#__PURE__*/ gql`
    fragment AbsenceRecord on AbsenceRecord {
  id
  absenceType
  from
  to
  comment
  customDurationPerDay
  isOnDemand
  approval {
    ...Approval
  }
  attachment {
    url
    fileName
  }
}
    ${ApprovalFragmentDoc}`;
export const BookDeskDrawerRoomFragmentDoc = /*#__PURE__*/ gql`
    fragment BookDeskDrawerRoom on ReservableRoom {
  id
  name
  desks {
    id
    name
    monitors
    standing
  }
}
    `;
export const BookParkingDrawerSpotFragmentDoc = /*#__PURE__*/ gql`
    fragment BookParkingDrawerSpot on ReservableParkingSpot {
  id
  number
  name
  guest
}
    `;
export const EditSkillsAndCertificatesDrawerUserFragmentDoc = /*#__PURE__*/ gql`
    fragment EditSkillsAndCertificatesDrawer_User on User {
  id
  skillsAndCompetences
  declaredNoCertificates
  certificates {
    id
    name
    issueDate
    expirationDate
    file {
      fileName
      url
    }
  }
}
    `;
export const OfficeDeskAssignmentFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeDeskAssignment on DeskAssignment {
  id
  office {
    officeId
    name
  }
  desk {
    id
    name
  }
  from
  to
}
    `;
export const OfficeReservationFragmentDoc = /*#__PURE__*/ gql`
    fragment OfficeReservation on ReservationRequest {
  requestId
  office {
    officeId
    name
  }
  kind
  resources {
    id
    name
  }
  range {
    from
    to
  }
  approval {
    __typename
  }
  plateNumber
  guestEmails
}
    `;
export const ProgressionCurrencyFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_Currency on TimeBasedCurrency {
  value
  futureUpdates {
    applyDate
    activityId
    value
  }
  history {
    applyDate
    activityId
    value
  }
}
    `;
export const ProgressionRateFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_Rate on TimeBasedRate {
  value {
    ...Rate
  }
  history {
    value {
      ...Rate
    }
    applyDate
    activityId
  }
  futureUpdates {
    value {
      ...Rate
    }
    applyDate
    activityId
  }
}
    ${RateFragmentDoc}`;
export const ProgressionOvertimeRateFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_OvertimeRate on TimeBasedOptClearableNetGross {
  value {
    ...NetGross
  }
  history {
    value {
      value {
        ...NetGross
      }
    }
    applyDate
    activityId
  }
  futureUpdates {
    value {
      value {
        ...NetGross
      }
    }
    applyDate
    activityId
  }
}
    ${NetGrossFragmentDoc}`;
export const ProgressionOnCallsFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_OnCalls on TimeBasedOptClearableOnCallRate {
  value {
    night {
      ...NetGross
    }
    holiday {
      ...NetGross
    }
    weekend {
      ...NetGross
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      value {
        night {
          ...NetGross
        }
        holiday {
          ...NetGross
        }
        weekend {
          ...NetGross
        }
      }
    }
  }
  history {
    activityId
    applyDate
    value {
      value {
        night {
          ...NetGross
        }
        holiday {
          ...NetGross
        }
        weekend {
          ...NetGross
        }
      }
    }
  }
}
    ${NetGrossFragmentDoc}`;
export const ProgressionPositionFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_Position on TimeBasedOptClearableString {
  value
  futureUpdates {
    activityId
    applyDate
    value {
      value
    }
  }
  history {
    activityId
    applyDate
    value {
      value
    }
  }
}
    `;
export const WorkingTimeFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkingTime on WorkingTime {
  numerator
  denominator
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
}
    `;
export const ProgressionWorkingTimeFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_WorkingTime on TimeBasedWorkingTime {
  value {
    ...WorkingTime
  }
  history {
    activityId
    applyDate
    value {
      ...WorkingTime
    }
  }
  futureUpdates {
    activityId
    applyDate
    value {
      ...WorkingTime
    }
  }
}
    ${WorkingTimeFragmentDoc}`;
export const ProgressionContractFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_Contract on Contract {
  id
  status
  startDate
  terminationDate
  ... on B2BContract {
    currency {
      ...Progression_Currency
    }
    rate {
      ...Progression_Rate
    }
    overtimeRate {
      ...Progression_OvertimeRate
    }
    onCall {
      ...Progression_OnCalls
    }
    position {
      ...Progression_Position
    }
  }
  ... on EmploymentContract {
    type
    currency {
      ...Progression_Currency
    }
    rate {
      ...Progression_Rate
    }
    overtimeRate {
      ...Progression_OvertimeRate
    }
    onCall {
      ...Progression_OnCalls
    }
    position {
      ...Progression_Position
    }
    workingTime {
      ...Progression_WorkingTime
    }
  }
}
    ${ProgressionCurrencyFragmentDoc}
${ProgressionRateFragmentDoc}
${ProgressionOvertimeRateFragmentDoc}
${ProgressionOnCallsFragmentDoc}
${ProgressionPositionFragmentDoc}
${ProgressionWorkingTimeFragmentDoc}`;
export const ProgressionUserFragmentDoc = /*#__PURE__*/ gql`
    fragment Progression_User on User {
  id
  progressionLevel {
    value
    history {
      applyDate
      activityId
      value {
        value
      }
    }
    futureUpdates {
      applyDate
      activityId
      value {
        value
      }
    }
  }
}
    `;
export const UserAdditionalCostsDrawerDocument = /*#__PURE__*/ gql`
    query User_AdditionalCostsDrawer($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ... on ContractResponse {
      value {
        id
        bonuses {
          paidOut {
            ...AdditionalCostDrawer_Bonus
          }
          future {
            ...AdditionalCostDrawer_Bonus
          }
        }
      }
    }
  }
}
    ${AdditionalCostDrawerBonusFragmentDoc}`;

/**
 * __useUserAdditionalCostsDrawerQuery__
 *
 * To run a query within a React component, call `useUserAdditionalCostsDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAdditionalCostsDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAdditionalCostsDrawerQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useUserAdditionalCostsDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<UserAdditionalCostsDrawerQuery, UserAdditionalCostsDrawerQueryVariables> & ({ variables: UserAdditionalCostsDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserAdditionalCostsDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserAdditionalCostsDrawerQuery, UserAdditionalCostsDrawerQueryVariables>(UserAdditionalCostsDrawerDocument, parser(options)));
      }
export function useUserAdditionalCostsDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserAdditionalCostsDrawerQuery, UserAdditionalCostsDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserAdditionalCostsDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserAdditionalCostsDrawerQuery, UserAdditionalCostsDrawerQueryVariables>(UserAdditionalCostsDrawerDocument, options));
        }

export type UserAdditionalCostsDrawerQueryResult = ApolloReact.QueryResult<UserAdditionalCostsDrawerQuery, UserAdditionalCostsDrawerQueryVariables>;
export function refetchUserAdditionalCostsDrawerQuery(variables: UserAdditionalCostsDrawerQueryVariables) {
      return { query: UserAdditionalCostsDrawerDocument, variables: variables }
    }
export const UserAdditionalCostDrawerRequestBonusDocument = /*#__PURE__*/ gql`
    mutation User_AdditionalCostDrawer_RequestBonus($input: BonusInput!) {
  reporting {
    bonus {
      requestBonus(input: $input) {
        ...NfsError
        ... on BonusResponse {
          value {
            ...AdditionalCostDrawer_Bonus
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AdditionalCostDrawerBonusFragmentDoc}`;


/**
 * __useUserAdditionalCostDrawerRequestBonusMutation__
 *
 * To run a mutation, you first call `useUserAdditionalCostDrawerRequestBonusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAdditionalCostDrawerRequestBonusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAdditionalCostDrawerRequestBonusMutation, { data, loading, error }] = useUserAdditionalCostDrawerRequestBonusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAdditionalCostDrawerRequestBonusMutation(baseOptions?: ApolloReact.MutationHookOptions<UserAdditionalCostDrawerRequestBonusMutation, UserAdditionalCostDrawerRequestBonusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserAdditionalCostDrawerRequestBonusDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserAdditionalCostDrawerRequestBonusMutation, UserAdditionalCostDrawerRequestBonusMutationVariables>(UserAdditionalCostDrawerRequestBonusDocument, parser(options)));
      }
export type UserAdditionalCostDrawerRequestBonusMutationHookResult = ReturnType<typeof useUserAdditionalCostDrawerRequestBonusMutation>;
export type UserAdditionalCostDrawerRequestBonusMutationResult = ApolloReact.MutationResult<UserAdditionalCostDrawerRequestBonusMutation>;
export type UserAdditionalCostDrawerRequestBonusMutationOptions = Apollo.MutationOptions<UserAdditionalCostDrawerRequestBonusMutation, UserAdditionalCostDrawerRequestBonusMutationVariables>;
export const UserAdditionalCostDrawerDeleteDocument = /*#__PURE__*/ gql`
    mutation User_AdditionalCostDrawer_Delete($id: BonusId!) {
  reporting {
    bonus {
      bonus(id: $id) {
        delete {
          ...NfsError
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useUserAdditionalCostDrawerDeleteMutation__
 *
 * To run a mutation, you first call `useUserAdditionalCostDrawerDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAdditionalCostDrawerDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAdditionalCostDrawerDeleteMutation, { data, loading, error }] = useUserAdditionalCostDrawerDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserAdditionalCostDrawerDeleteMutation(baseOptions?: ApolloReact.MutationHookOptions<UserAdditionalCostDrawerDeleteMutation, UserAdditionalCostDrawerDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserAdditionalCostDrawerDeleteDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserAdditionalCostDrawerDeleteMutation, UserAdditionalCostDrawerDeleteMutationVariables>(UserAdditionalCostDrawerDeleteDocument, parser(options)));
      }
export type UserAdditionalCostDrawerDeleteMutationHookResult = ReturnType<typeof useUserAdditionalCostDrawerDeleteMutation>;
export type UserAdditionalCostDrawerDeleteMutationResult = ApolloReact.MutationResult<UserAdditionalCostDrawerDeleteMutation>;
export type UserAdditionalCostDrawerDeleteMutationOptions = Apollo.MutationOptions<UserAdditionalCostDrawerDeleteMutation, UserAdditionalCostDrawerDeleteMutationVariables>;
export const UserBenefitSectionsAssignedBenefitVariantsDocument = /*#__PURE__*/ gql`
    query UserBenefitSections_AssignedBenefitVariants($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        startDate
        conclusionDate
        terminationDate
        ... on EmploymentContract {
          assignedVariants(activeOnly: false) {
            ...UserBenefitSections_AssignedVariant
          }
        }
        ... on B2BContract {
          assignedVariants(activeOnly: false) {
            ...UserBenefitSections_AssignedVariant
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${UserBenefitSectionsAssignedVariantFragmentDoc}`;

/**
 * __useUserBenefitSectionsAssignedBenefitVariantsQuery__
 *
 * To run a query within a React component, call `useUserBenefitSectionsAssignedBenefitVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBenefitSectionsAssignedBenefitVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBenefitSectionsAssignedBenefitVariantsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useUserBenefitSectionsAssignedBenefitVariantsQuery(baseOptions: ApolloReact.QueryHookOptions<UserBenefitSectionsAssignedBenefitVariantsQuery, UserBenefitSectionsAssignedBenefitVariantsQueryVariables> & ({ variables: UserBenefitSectionsAssignedBenefitVariantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserBenefitSectionsAssignedBenefitVariantsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserBenefitSectionsAssignedBenefitVariantsQuery, UserBenefitSectionsAssignedBenefitVariantsQueryVariables>(UserBenefitSectionsAssignedBenefitVariantsDocument, parser(options)));
      }
export function useUserBenefitSectionsAssignedBenefitVariantsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserBenefitSectionsAssignedBenefitVariantsQuery, UserBenefitSectionsAssignedBenefitVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserBenefitSectionsAssignedBenefitVariantsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserBenefitSectionsAssignedBenefitVariantsQuery, UserBenefitSectionsAssignedBenefitVariantsQueryVariables>(UserBenefitSectionsAssignedBenefitVariantsDocument, options));
        }

export type UserBenefitSectionsAssignedBenefitVariantsQueryResult = ApolloReact.QueryResult<UserBenefitSectionsAssignedBenefitVariantsQuery, UserBenefitSectionsAssignedBenefitVariantsQueryVariables>;
export function refetchUserBenefitSectionsAssignedBenefitVariantsQuery(variables: UserBenefitSectionsAssignedBenefitVariantsQueryVariables) {
      return { query: UserBenefitSectionsAssignedBenefitVariantsDocument, variables: variables }
    }
export const CopyrightsDrawerCopyrightsDocument = /*#__PURE__*/ gql`
    query CopyrightsDrawer_Copyrights($contractId: ContractId!, $from: YearMonth!, $to: YearMonth!) {
  contractSalaryDetailsInRange(contractId: $contractId, from: $from, to: $to) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      value {
        ... on EmploymentContractSalaryDetails {
          ...CopyrightsDrawer_Salary
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerSalaryFragmentDoc}`;

/**
 * __useCopyrightsDrawerCopyrightsQuery__
 *
 * To run a query within a React component, call `useCopyrightsDrawerCopyrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightsDrawerCopyrightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyrightsDrawerCopyrightsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCopyrightsDrawerCopyrightsQuery(baseOptions: ApolloReact.QueryHookOptions<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables> & ({ variables: CopyrightsDrawerCopyrightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CopyrightsDrawerCopyrightsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>(CopyrightsDrawerCopyrightsDocument, parser(options)));
      }
export function useCopyrightsDrawerCopyrightsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CopyrightsDrawerCopyrightsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>(CopyrightsDrawerCopyrightsDocument, options));
        }

export type CopyrightsDrawerCopyrightsQueryResult = ApolloReact.QueryResult<CopyrightsDrawerCopyrightsQuery, CopyrightsDrawerCopyrightsQueryVariables>;
export function refetchCopyrightsDrawerCopyrightsQuery(variables: CopyrightsDrawerCopyrightsQueryVariables) {
      return { query: CopyrightsDrawerCopyrightsDocument, variables: variables }
    }
export const UserCopyrightsDrawerUpdateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation User_CopyrightsDrawer_UpdateWorkTransfer($id: WorkTransferProtocolId!, $description: ClearableStringInput, $payload: Upload) {
  reporting {
    workTransferProtocolApi {
      update(id: $id, description: $description, payload: $payload) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __useUserCopyrightsDrawerUpdateWorkTransferMutation__
 *
 * To run a mutation, you first call `useUserCopyrightsDrawerUpdateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCopyrightsDrawerUpdateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCopyrightsDrawerUpdateWorkTransferMutation, { data, loading, error }] = useUserCopyrightsDrawerUpdateWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUserCopyrightsDrawerUpdateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<UserCopyrightsDrawerUpdateWorkTransferMutation, UserCopyrightsDrawerUpdateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserCopyrightsDrawerUpdateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserCopyrightsDrawerUpdateWorkTransferMutation, UserCopyrightsDrawerUpdateWorkTransferMutationVariables>(UserCopyrightsDrawerUpdateWorkTransferDocument, parser(options)));
      }
export type UserCopyrightsDrawerUpdateWorkTransferMutationHookResult = ReturnType<typeof useUserCopyrightsDrawerUpdateWorkTransferMutation>;
export type UserCopyrightsDrawerUpdateWorkTransferMutationResult = ApolloReact.MutationResult<UserCopyrightsDrawerUpdateWorkTransferMutation>;
export type UserCopyrightsDrawerUpdateWorkTransferMutationOptions = Apollo.MutationOptions<UserCopyrightsDrawerUpdateWorkTransferMutation, UserCopyrightsDrawerUpdateWorkTransferMutationVariables>;
export const UserCopyrightsDrawerCreateWorkTransferDocument = /*#__PURE__*/ gql`
    mutation User_CopyrightsDrawer_CreateWorkTransfer($contractSalaryDetailsId: ContractSalaryDetailsIdInput!, $id: WorkTransferProtocolId!, $description: String, $payload: Upload!) {
  reporting {
    workTransferProtocolApi {
      create(
        contractSalaryDetailsId: $contractSalaryDetailsId
        id: $id
        description: $description
        payload: $payload
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __useUserCopyrightsDrawerCreateWorkTransferMutation__
 *
 * To run a mutation, you first call `useUserCopyrightsDrawerCreateWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCopyrightsDrawerCreateWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCopyrightsDrawerCreateWorkTransferMutation, { data, loading, error }] = useUserCopyrightsDrawerCreateWorkTransferMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUserCopyrightsDrawerCreateWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<UserCopyrightsDrawerCreateWorkTransferMutation, UserCopyrightsDrawerCreateWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserCopyrightsDrawerCreateWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserCopyrightsDrawerCreateWorkTransferMutation, UserCopyrightsDrawerCreateWorkTransferMutationVariables>(UserCopyrightsDrawerCreateWorkTransferDocument, parser(options)));
      }
export type UserCopyrightsDrawerCreateWorkTransferMutationHookResult = ReturnType<typeof useUserCopyrightsDrawerCreateWorkTransferMutation>;
export type UserCopyrightsDrawerCreateWorkTransferMutationResult = ApolloReact.MutationResult<UserCopyrightsDrawerCreateWorkTransferMutation>;
export type UserCopyrightsDrawerCreateWorkTransferMutationOptions = Apollo.MutationOptions<UserCopyrightsDrawerCreateWorkTransferMutation, UserCopyrightsDrawerCreateWorkTransferMutationVariables>;
export const UserCopyrightsDrawerRemoveWorkTransferDocument = /*#__PURE__*/ gql`
    mutation User_CopyrightsDrawer_RemoveWorkTransfer($id: WorkTransferProtocolId!) {
  reporting {
    workTransferProtocolApi {
      remove(id: $id) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useUserCopyrightsDrawerRemoveWorkTransferMutation__
 *
 * To run a mutation, you first call `useUserCopyrightsDrawerRemoveWorkTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCopyrightsDrawerRemoveWorkTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCopyrightsDrawerRemoveWorkTransferMutation, { data, loading, error }] = useUserCopyrightsDrawerRemoveWorkTransferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCopyrightsDrawerRemoveWorkTransferMutation(baseOptions?: ApolloReact.MutationHookOptions<UserCopyrightsDrawerRemoveWorkTransferMutation, UserCopyrightsDrawerRemoveWorkTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserCopyrightsDrawerRemoveWorkTransferDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserCopyrightsDrawerRemoveWorkTransferMutation, UserCopyrightsDrawerRemoveWorkTransferMutationVariables>(UserCopyrightsDrawerRemoveWorkTransferDocument, parser(options)));
      }
export type UserCopyrightsDrawerRemoveWorkTransferMutationHookResult = ReturnType<typeof useUserCopyrightsDrawerRemoveWorkTransferMutation>;
export type UserCopyrightsDrawerRemoveWorkTransferMutationResult = ApolloReact.MutationResult<UserCopyrightsDrawerRemoveWorkTransferMutation>;
export type UserCopyrightsDrawerRemoveWorkTransferMutationOptions = Apollo.MutationOptions<UserCopyrightsDrawerRemoveWorkTransferMutation, UserCopyrightsDrawerRemoveWorkTransferMutationVariables>;
export const UserCopyrightsDrawerMarkNoWorkDocument = /*#__PURE__*/ gql`
    mutation User_CopyrightsDrawer_MarkNoWork($contractSalaryDetailsId: ContractSalaryDetailsIdInput!) {
  reporting {
    workTransferProtocolApi {
      markNoWorkToBeTransferedThisMonth(
        contractSalaryDetailsId: $contractSalaryDetailsId
      ) {
        ...NfsError
        ... on WorkTransferProtocol {
          ...CopyrightsDrawer_WorkTransfer
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightsDrawerWorkTransferFragmentDoc}`;


/**
 * __useUserCopyrightsDrawerMarkNoWorkMutation__
 *
 * To run a mutation, you first call `useUserCopyrightsDrawerMarkNoWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCopyrightsDrawerMarkNoWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCopyrightsDrawerMarkNoWorkMutation, { data, loading, error }] = useUserCopyrightsDrawerMarkNoWorkMutation({
 *   variables: {
 *      contractSalaryDetailsId: // value for 'contractSalaryDetailsId'
 *   },
 * });
 */
export function useUserCopyrightsDrawerMarkNoWorkMutation(baseOptions?: ApolloReact.MutationHookOptions<UserCopyrightsDrawerMarkNoWorkMutation, UserCopyrightsDrawerMarkNoWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserCopyrightsDrawerMarkNoWorkDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserCopyrightsDrawerMarkNoWorkMutation, UserCopyrightsDrawerMarkNoWorkMutationVariables>(UserCopyrightsDrawerMarkNoWorkDocument, parser(options)));
      }
export type UserCopyrightsDrawerMarkNoWorkMutationHookResult = ReturnType<typeof useUserCopyrightsDrawerMarkNoWorkMutation>;
export type UserCopyrightsDrawerMarkNoWorkMutationResult = ApolloReact.MutationResult<UserCopyrightsDrawerMarkNoWorkMutation>;
export type UserCopyrightsDrawerMarkNoWorkMutationOptions = Apollo.MutationOptions<UserCopyrightsDrawerMarkNoWorkMutation, UserCopyrightsDrawerMarkNoWorkMutationVariables>;
export const CopyrightsTrButtonDocument = /*#__PURE__*/ gql`
    query CopyrightsTRButton($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...CopyrightTRButton_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${CopyrightTrButtonContractFragmentDoc}`;

/**
 * __useCopyrightsTrButtonQuery__
 *
 * To run a query within a React component, call `useCopyrightsTrButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyrightsTrButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyrightsTrButtonQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useCopyrightsTrButtonQuery(baseOptions: ApolloReact.QueryHookOptions<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables> & ({ variables: CopyrightsTrButtonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(CopyrightsTrButtonDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>(CopyrightsTrButtonDocument, parser(options)));
      }
export function useCopyrightsTrButtonLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(CopyrightsTrButtonDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>(CopyrightsTrButtonDocument, options));
        }

export type CopyrightsTrButtonQueryResult = ApolloReact.QueryResult<CopyrightsTrButtonQuery, CopyrightsTrButtonQueryVariables>;
export function refetchCopyrightsTrButtonQuery(variables: CopyrightsTrButtonQueryVariables) {
      return { query: CopyrightsTrButtonDocument, variables: variables }
    }
export const UserDirectReportingStructureDocument = /*#__PURE__*/ gql`
    query User_DirectReportingStructure {
  profile {
    ...NfsError
    ... on User {
      id
      role {
        value
        futureUpdates {
          activityId
          applyDate
          value
        }
        history {
          activityId
          applyDate
          value
        }
      }
      directReporting {
        activeProjects: assignedProjects(status_oneOf: [Live]) {
          project {
            id
            name
          }
        }
        primaryProjectId {
          value
          futureUpdates {
            activityId
            applyDate
            value {
              value
            }
          }
          history {
            activityId
            applyDate
            value {
              value
            }
          }
        }
        operationalLead {
          value {
            ...DirectReportingStructure_User
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
          history {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
        }
        practiceLead {
          value {
            ...DirectReportingStructure_User
          }
          futureUpdates {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
          history {
            activityId
            applyDate
            value {
              value {
                ...DirectReportingStructure_User
              }
            }
          }
        }
        space {
          value {
            id
            name
            owner {
              ...DirectReportingStructure_User
            }
          }
          futureUpdates {
            activityId
            applyDate
            value {
              id
              name
              owner {
                ...DirectReportingStructure_User
              }
            }
          }
          history {
            activityId
            applyDate
            value {
              id
              name
              owner {
                ...DirectReportingStructure_User
              }
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${DirectReportingStructureUserFragmentDoc}`;

/**
 * __useUserDirectReportingStructureQuery__
 *
 * To run a query within a React component, call `useUserDirectReportingStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDirectReportingStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDirectReportingStructureQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDirectReportingStructureQuery(baseOptions?: ApolloReact.QueryHookOptions<UserDirectReportingStructureQuery, UserDirectReportingStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserDirectReportingStructureDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserDirectReportingStructureQuery, UserDirectReportingStructureQueryVariables>(UserDirectReportingStructureDocument, parser(options)));
      }
export function useUserDirectReportingStructureLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserDirectReportingStructureQuery, UserDirectReportingStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserDirectReportingStructureDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserDirectReportingStructureQuery, UserDirectReportingStructureQueryVariables>(UserDirectReportingStructureDocument, options));
        }

export type UserDirectReportingStructureQueryResult = ApolloReact.QueryResult<UserDirectReportingStructureQuery, UserDirectReportingStructureQueryVariables>;
export function refetchUserDirectReportingStructureQuery(variables?: UserDirectReportingStructureQueryVariables) {
      return { query: UserDirectReportingStructureDocument, variables: variables }
    }
export const InvoicesDrawerInvoicesDocument = /*#__PURE__*/ gql`
    query InvoicesDrawer_Invoices($contractId: ContractId!, $from: YearMonth!, $to: YearMonth!) {
  contractSalaryDetailsInRange(contractId: $contractId, from: $from, to: $to) {
    ...NfsError
    ... on ListOfContractSalaryDetailsResponse {
      value {
        ... on B2BContractSalaryDetails {
          ...InvoicesDrawer_Salary
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerSalaryFragmentDoc}`;

/**
 * __useInvoicesDrawerInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesDrawerInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesDrawerInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesDrawerInvoicesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useInvoicesDrawerInvoicesQuery(baseOptions: ApolloReact.QueryHookOptions<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables> & ({ variables: InvoicesDrawerInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(InvoicesDrawerInvoicesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>(InvoicesDrawerInvoicesDocument, parser(options)));
      }
export function useInvoicesDrawerInvoicesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(InvoicesDrawerInvoicesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>(InvoicesDrawerInvoicesDocument, options));
        }

export type InvoicesDrawerInvoicesQueryResult = ApolloReact.QueryResult<InvoicesDrawerInvoicesQuery, InvoicesDrawerInvoicesQueryVariables>;
export function refetchInvoicesDrawerInvoicesQuery(variables: InvoicesDrawerInvoicesQueryVariables) {
      return { query: InvoicesDrawerInvoicesDocument, variables: variables }
    }
export const UserInvoicesDrawerUpdateInvoiceDocument = /*#__PURE__*/ gql`
    mutation User_InvoicesDrawer_UpdateInvoice($contractId: ContractId!, $yearMonth: YearMonth!, $invoiceDetailsId: InvoiceDetailsId!, $invoiceDetails: UpdateInvoiceDetailsInput!) {
  reporting {
    invoiceDetailsApi {
      updateInvoiceDetails(
        contractSalaryDetailsId: {contractId: $contractId, yearMonth: $yearMonth}
        invoiceDetailsId: $invoiceDetailsId
        invoiceDetails: $invoiceDetails
      ) {
        ...NfsError
        ... on InvoiceDetails {
          ...InvoicesDrawer_InvoiceDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;


/**
 * __useUserInvoicesDrawerUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUserInvoicesDrawerUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInvoicesDrawerUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInvoicesDrawerUpdateInvoiceMutation, { data, loading, error }] = useUserInvoicesDrawerUpdateInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      invoiceDetailsId: // value for 'invoiceDetailsId'
 *      invoiceDetails: // value for 'invoiceDetails'
 *   },
 * });
 */
export function useUserInvoicesDrawerUpdateInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<UserInvoicesDrawerUpdateInvoiceMutation, UserInvoicesDrawerUpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserInvoicesDrawerUpdateInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserInvoicesDrawerUpdateInvoiceMutation, UserInvoicesDrawerUpdateInvoiceMutationVariables>(UserInvoicesDrawerUpdateInvoiceDocument, parser(options)));
      }
export type UserInvoicesDrawerUpdateInvoiceMutationHookResult = ReturnType<typeof useUserInvoicesDrawerUpdateInvoiceMutation>;
export type UserInvoicesDrawerUpdateInvoiceMutationResult = ApolloReact.MutationResult<UserInvoicesDrawerUpdateInvoiceMutation>;
export type UserInvoicesDrawerUpdateInvoiceMutationOptions = Apollo.MutationOptions<UserInvoicesDrawerUpdateInvoiceMutation, UserInvoicesDrawerUpdateInvoiceMutationVariables>;
export const UserInvoicesDrawerCreateInvoiceDocument = /*#__PURE__*/ gql`
    mutation User_InvoicesDrawer_CreateInvoice($contractId: ContractId!, $yearMonth: YearMonth!, $invoiceDetails: CreateInvoiceDetailsInput!) {
  reporting {
    invoiceDetailsApi {
      createInvoiceDetails(
        contractSalaryDetailsId: {contractId: $contractId, yearMonth: $yearMonth}
        invoiceDetails: $invoiceDetails
      ) {
        ...NfsError
        ... on InvoiceDetails {
          ...InvoicesDrawer_InvoiceDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${InvoicesDrawerInvoiceDetailsFragmentDoc}`;


/**
 * __useUserInvoicesDrawerCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useUserInvoicesDrawerCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInvoicesDrawerCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInvoicesDrawerCreateInvoiceMutation, { data, loading, error }] = useUserInvoicesDrawerCreateInvoiceMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      yearMonth: // value for 'yearMonth'
 *      invoiceDetails: // value for 'invoiceDetails'
 *   },
 * });
 */
export function useUserInvoicesDrawerCreateInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<UserInvoicesDrawerCreateInvoiceMutation, UserInvoicesDrawerCreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserInvoicesDrawerCreateInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserInvoicesDrawerCreateInvoiceMutation, UserInvoicesDrawerCreateInvoiceMutationVariables>(UserInvoicesDrawerCreateInvoiceDocument, parser(options)));
      }
export type UserInvoicesDrawerCreateInvoiceMutationHookResult = ReturnType<typeof useUserInvoicesDrawerCreateInvoiceMutation>;
export type UserInvoicesDrawerCreateInvoiceMutationResult = ApolloReact.MutationResult<UserInvoicesDrawerCreateInvoiceMutation>;
export type UserInvoicesDrawerCreateInvoiceMutationOptions = Apollo.MutationOptions<UserInvoicesDrawerCreateInvoiceMutation, UserInvoicesDrawerCreateInvoiceMutationVariables>;
export const UserInvoicesDrawerRemoveInvoiceDocument = /*#__PURE__*/ gql`
    mutation User_InvoicesDrawer_RemoveInvoice($invoiceDetailsId: InvoiceDetailsId!) {
  reporting {
    invoiceDetailsApi {
      removeInvoiceDetails(invoiceDetailsId: $invoiceDetailsId) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useUserInvoicesDrawerRemoveInvoiceMutation__
 *
 * To run a mutation, you first call `useUserInvoicesDrawerRemoveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserInvoicesDrawerRemoveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userInvoicesDrawerRemoveInvoiceMutation, { data, loading, error }] = useUserInvoicesDrawerRemoveInvoiceMutation({
 *   variables: {
 *      invoiceDetailsId: // value for 'invoiceDetailsId'
 *   },
 * });
 */
export function useUserInvoicesDrawerRemoveInvoiceMutation(baseOptions?: ApolloReact.MutationHookOptions<UserInvoicesDrawerRemoveInvoiceMutation, UserInvoicesDrawerRemoveInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserInvoicesDrawerRemoveInvoiceDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserInvoicesDrawerRemoveInvoiceMutation, UserInvoicesDrawerRemoveInvoiceMutationVariables>(UserInvoicesDrawerRemoveInvoiceDocument, parser(options)));
      }
export type UserInvoicesDrawerRemoveInvoiceMutationHookResult = ReturnType<typeof useUserInvoicesDrawerRemoveInvoiceMutation>;
export type UserInvoicesDrawerRemoveInvoiceMutationResult = ApolloReact.MutationResult<UserInvoicesDrawerRemoveInvoiceMutation>;
export type UserInvoicesDrawerRemoveInvoiceMutationOptions = Apollo.MutationOptions<UserInvoicesDrawerRemoveInvoiceMutation, UserInvoicesDrawerRemoveInvoiceMutationVariables>;
export const UserProjectsColorsProviderAllProjectsDocument = /*#__PURE__*/ gql`
    query User_ProjectsColorsProvider_AllProjects {
  projects {
    ...NfsError
    ... on ListOfProjectIdResponse {
      value
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useUserProjectsColorsProviderAllProjectsQuery__
 *
 * To run a query within a React component, call `useUserProjectsColorsProviderAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsColorsProviderAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsColorsProviderAllProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProjectsColorsProviderAllProjectsQuery(baseOptions?: ApolloReact.QueryHookOptions<UserProjectsColorsProviderAllProjectsQuery, UserProjectsColorsProviderAllProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserProjectsColorsProviderAllProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserProjectsColorsProviderAllProjectsQuery, UserProjectsColorsProviderAllProjectsQueryVariables>(UserProjectsColorsProviderAllProjectsDocument, parser(options)));
      }
export function useUserProjectsColorsProviderAllProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserProjectsColorsProviderAllProjectsQuery, UserProjectsColorsProviderAllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserProjectsColorsProviderAllProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserProjectsColorsProviderAllProjectsQuery, UserProjectsColorsProviderAllProjectsQueryVariables>(UserProjectsColorsProviderAllProjectsDocument, options));
        }

export type UserProjectsColorsProviderAllProjectsQueryResult = ApolloReact.QueryResult<UserProjectsColorsProviderAllProjectsQuery, UserProjectsColorsProviderAllProjectsQueryVariables>;
export function refetchUserProjectsColorsProviderAllProjectsQuery(variables?: UserProjectsColorsProviderAllProjectsQueryVariables) {
      return { query: UserProjectsColorsProviderAllProjectsDocument, variables: variables }
    }
export const UserTimeReportBlockedMessageSpaceOwnerDocument = /*#__PURE__*/ gql`
    query User_TimeReportBlockedMessage_SpaceOwner {
  profile {
    ...NfsError
    ... on User {
      id
      directReporting {
        space {
          value {
            id
            owner {
              avatar
              email
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useUserTimeReportBlockedMessageSpaceOwnerQuery__
 *
 * To run a query within a React component, call `useUserTimeReportBlockedMessageSpaceOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportBlockedMessageSpaceOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportBlockedMessageSpaceOwnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTimeReportBlockedMessageSpaceOwnerQuery(baseOptions?: ApolloReact.QueryHookOptions<UserTimeReportBlockedMessageSpaceOwnerQuery, UserTimeReportBlockedMessageSpaceOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportBlockedMessageSpaceOwnerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportBlockedMessageSpaceOwnerQuery, UserTimeReportBlockedMessageSpaceOwnerQueryVariables>(UserTimeReportBlockedMessageSpaceOwnerDocument, parser(options)));
      }
export function useUserTimeReportBlockedMessageSpaceOwnerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportBlockedMessageSpaceOwnerQuery, UserTimeReportBlockedMessageSpaceOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportBlockedMessageSpaceOwnerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportBlockedMessageSpaceOwnerQuery, UserTimeReportBlockedMessageSpaceOwnerQueryVariables>(UserTimeReportBlockedMessageSpaceOwnerDocument, options));
        }

export type UserTimeReportBlockedMessageSpaceOwnerQueryResult = ApolloReact.QueryResult<UserTimeReportBlockedMessageSpaceOwnerQuery, UserTimeReportBlockedMessageSpaceOwnerQueryVariables>;
export function refetchUserTimeReportBlockedMessageSpaceOwnerQuery(variables?: UserTimeReportBlockedMessageSpaceOwnerQueryVariables) {
      return { query: UserTimeReportBlockedMessageSpaceOwnerDocument, variables: variables }
    }
export const TimeReportBulkEditToolbarDeleteSelectedDocument = /*#__PURE__*/ gql`
    mutation TimeReportBulkEditToolbar_DeleteSelected($workRecordIds: [WorkRecordId!]!, $onCallRecordIds: [OnCallRecordId!]!, $absenceRecordIds: [AbsenceRecordId!]!) {
  reporting {
    deleteTimeReports(
      workRecordIds: $workRecordIds
      onCallRecordIds: $onCallRecordIds
      absenceRecordIds: $absenceRecordIds
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportBulkEditToolbarDeleteSelectedMutation__
 *
 * To run a mutation, you first call `useTimeReportBulkEditToolbarDeleteSelectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportBulkEditToolbarDeleteSelectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportBulkEditToolbarDeleteSelectedMutation, { data, loading, error }] = useTimeReportBulkEditToolbarDeleteSelectedMutation({
 *   variables: {
 *      workRecordIds: // value for 'workRecordIds'
 *      onCallRecordIds: // value for 'onCallRecordIds'
 *      absenceRecordIds: // value for 'absenceRecordIds'
 *   },
 * });
 */
export function useTimeReportBulkEditToolbarDeleteSelectedMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportBulkEditToolbarDeleteSelectedMutation, TimeReportBulkEditToolbarDeleteSelectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportBulkEditToolbarDeleteSelectedDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportBulkEditToolbarDeleteSelectedMutation, TimeReportBulkEditToolbarDeleteSelectedMutationVariables>(TimeReportBulkEditToolbarDeleteSelectedDocument, parser(options)));
      }
export type TimeReportBulkEditToolbarDeleteSelectedMutationHookResult = ReturnType<typeof useTimeReportBulkEditToolbarDeleteSelectedMutation>;
export type TimeReportBulkEditToolbarDeleteSelectedMutationResult = ApolloReact.MutationResult<TimeReportBulkEditToolbarDeleteSelectedMutation>;
export type TimeReportBulkEditToolbarDeleteSelectedMutationOptions = Apollo.MutationOptions<TimeReportBulkEditToolbarDeleteSelectedMutation, TimeReportBulkEditToolbarDeleteSelectedMutationVariables>;
export const TimeReportDashboardProviderValidationsDocument = /*#__PURE__*/ gql`
    query TimeReportDashboardProvider_Validations($contractId: ContractId!, $date: YearMonth!) {
  timeReportValidations(contractId: $contractId, date: $date) {
    ...NfsError
    ... on ListOfTimeReportValidationResponse {
      value {
        ...TimeReportDashBoardProvider_TimeReportValidations
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportDashBoardProviderTimeReportValidationsFragmentDoc}`;

/**
 * __useTimeReportDashboardProviderValidationsQuery__
 *
 * To run a query within a React component, call `useTimeReportDashboardProviderValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportDashboardProviderValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportDashboardProviderValidationsQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTimeReportDashboardProviderValidationsQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables> & ({ variables: TimeReportDashboardProviderValidationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportDashboardProviderValidationsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>(TimeReportDashboardProviderValidationsDocument, parser(options)));
      }
export function useTimeReportDashboardProviderValidationsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportDashboardProviderValidationsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>(TimeReportDashboardProviderValidationsDocument, options));
        }

export type TimeReportDashboardProviderValidationsQueryResult = ApolloReact.QueryResult<TimeReportDashboardProviderValidationsQuery, TimeReportDashboardProviderValidationsQueryVariables>;
export function refetchTimeReportDashboardProviderValidationsQuery(variables: TimeReportDashboardProviderValidationsQueryVariables) {
      return { query: TimeReportDashboardProviderValidationsDocument, variables: variables }
    }
export const UserTimeReportDashboardProviderContractInfoDocument = /*#__PURE__*/ gql`
    query User_TimeReportDashboardProvider_ContractInfo($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        id
        startDate
        expectedEndDate
        terminationDate
        preselectedWorkTag {
          id
        }
        holidayCalendar {
          calendarDays {
            date
            dayType
          }
        }
        preselectedProject {
          value {
            id
          }
        }
        preselectedFromTime
        preselectedToTime
        ... on B2BContract {
          enableTrainingPackage
          overtimeRate {
            ...TimeReportDashBoardProvider_OvertimeRate
          }
          onCall {
            ...TimeReportDashBoardProvider_OnCall
          }
          rate {
            ...TimeReportDashBoardProvider_TimeBasedRate
          }
        }
        ... on EmploymentContract {
          type
          enableTrainingPackage
          overtimeRate {
            ...TimeReportDashBoardProvider_OvertimeRate
          }
          onCall {
            ...TimeReportDashBoardProvider_OnCall
          }
          rate {
            ...TimeReportDashBoardProvider_TimeBasedRate
          }
          workingTime {
            value {
              ...WorkingTime
            }
            futureUpdates {
              activityId
              applyDate
              value {
                ...WorkingTime
              }
            }
            history {
              activityId
              applyDate
              value {
                ...WorkingTime
              }
            }
          }
          preselectedIsRemoteWork
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportDashBoardProviderOvertimeRateFragmentDoc}
${TimeReportDashBoardProviderOnCallFragmentDoc}
${TimeReportDashBoardProviderTimeBasedRateFragmentDoc}
${WorkingTimeFragmentDoc}`;

/**
 * __useUserTimeReportDashboardProviderContractInfoQuery__
 *
 * To run a query within a React component, call `useUserTimeReportDashboardProviderContractInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportDashboardProviderContractInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportDashboardProviderContractInfoQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useUserTimeReportDashboardProviderContractInfoQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportDashboardProviderContractInfoQuery, UserTimeReportDashboardProviderContractInfoQueryVariables> & ({ variables: UserTimeReportDashboardProviderContractInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportDashboardProviderContractInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportDashboardProviderContractInfoQuery, UserTimeReportDashboardProviderContractInfoQueryVariables>(UserTimeReportDashboardProviderContractInfoDocument, parser(options)));
      }
export function useUserTimeReportDashboardProviderContractInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportDashboardProviderContractInfoQuery, UserTimeReportDashboardProviderContractInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportDashboardProviderContractInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportDashboardProviderContractInfoQuery, UserTimeReportDashboardProviderContractInfoQueryVariables>(UserTimeReportDashboardProviderContractInfoDocument, options));
        }

export type UserTimeReportDashboardProviderContractInfoQueryResult = ApolloReact.QueryResult<UserTimeReportDashboardProviderContractInfoQuery, UserTimeReportDashboardProviderContractInfoQueryVariables>;
export function refetchUserTimeReportDashboardProviderContractInfoQuery(variables: UserTimeReportDashboardProviderContractInfoQueryVariables) {
      return { query: UserTimeReportDashboardProviderContractInfoDocument, variables: variables }
    }
export const UserTimeReportDashboardProviderDocument = /*#__PURE__*/ gql`
    query User_TimeReportDashboardProvider($dashboardFrom: LocalDate!, $dashboardTo: LocalDate!, $projectsFrom: OffsetDateTime!, $projectsTo: OffsetDateTime!, $contractId: ContractId!) {
  timeReport(from: $dashboardFrom, to: $dashboardTo, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportRecords {
        workTags {
          ...WorkTag
        }
        work {
          ...WorkRecord
        }
        absence {
          ...AbsenceRecord
        }
        onCall {
          ...OnCallRecord
        }
      }
      timeReportStats {
        ... on EmploymentTimeReportStats {
          flexTime {
            period {
              from
              to
            }
          }
        }
      }
    }
  }
  assignedProjects(from: $projectsFrom, to: $projectsTo, contractId: $contractId) {
    ...NfsError
    ... on ListOfAssignedProjectResponse {
      value {
        projectId
        projectName
        activeReportingRange {
          from
          to
        }
        assignmentPeriods {
          from
          to
        }
        reportingPeriods {
          from
          to
        }
      }
    }
  }
  defaultActiveReportingRange(contractId: $contractId) {
    ...NfsError
    ... on ClosedEndLocalDateRange {
      from
      to
    }
  }
  absenceReportingRange(contractId: $contractId) {
    ...NfsError
    ... on ClosedEndLocalDateRange {
      from
      to
    }
  }
  absenceTypeDetails {
    ...TimeReportDashBoardProvider_AbsenceTypeDetails
  }
}
    ${NfsErrorFragmentDoc}
${WorkTagFragmentDoc}
${WorkRecordFragmentDoc}
${AbsenceRecordFragmentDoc}
${OnCallRecordFragmentDoc}
${TimeReportDashBoardProviderAbsenceTypeDetailsFragmentDoc}`;

/**
 * __useUserTimeReportDashboardProviderQuery__
 *
 * To run a query within a React component, call `useUserTimeReportDashboardProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportDashboardProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportDashboardProviderQuery({
 *   variables: {
 *      dashboardFrom: // value for 'dashboardFrom'
 *      dashboardTo: // value for 'dashboardTo'
 *      projectsFrom: // value for 'projectsFrom'
 *      projectsTo: // value for 'projectsTo'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useUserTimeReportDashboardProviderQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportDashboardProviderQuery, UserTimeReportDashboardProviderQueryVariables> & ({ variables: UserTimeReportDashboardProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportDashboardProviderDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportDashboardProviderQuery, UserTimeReportDashboardProviderQueryVariables>(UserTimeReportDashboardProviderDocument, parser(options)));
      }
export function useUserTimeReportDashboardProviderLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportDashboardProviderQuery, UserTimeReportDashboardProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportDashboardProviderDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportDashboardProviderQuery, UserTimeReportDashboardProviderQueryVariables>(UserTimeReportDashboardProviderDocument, options));
        }

export type UserTimeReportDashboardProviderQueryResult = ApolloReact.QueryResult<UserTimeReportDashboardProviderQuery, UserTimeReportDashboardProviderQueryVariables>;
export function refetchUserTimeReportDashboardProviderQuery(variables: UserTimeReportDashboardProviderQueryVariables) {
      return { query: UserTimeReportDashboardProviderDocument, variables: variables }
    }
export const TimeReportEntryModalCreateWorkRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_CreateWorkRecord($workRecords: [CreateWorkRecordInput!]!) {
  reporting {
    workRecord {
      createMany(value: $workRecords) {
        ...NfsError
        ... on ListOfWorkRecordResponse {
          value {
            ...WorkRecord
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${WorkRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalCreateWorkRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalCreateWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalCreateWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalCreateWorkRecordMutation, { data, loading, error }] = useTimeReportEntryModalCreateWorkRecordMutation({
 *   variables: {
 *      workRecords: // value for 'workRecords'
 *   },
 * });
 */
export function useTimeReportEntryModalCreateWorkRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalCreateWorkRecordMutation, TimeReportEntryModalCreateWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalCreateWorkRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalCreateWorkRecordMutation, TimeReportEntryModalCreateWorkRecordMutationVariables>(TimeReportEntryModalCreateWorkRecordDocument, parser(options)));
      }
export type TimeReportEntryModalCreateWorkRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalCreateWorkRecordMutation>;
export type TimeReportEntryModalCreateWorkRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalCreateWorkRecordMutation>;
export type TimeReportEntryModalCreateWorkRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalCreateWorkRecordMutation, TimeReportEntryModalCreateWorkRecordMutationVariables>;
export const TimeReportEntryModalUpdateWorkRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_UpdateWorkRecord($workRecordId: WorkRecordId!, $projectId: ClearableProjectIdInput, $workTagId: WorkTagId, $date: LocalDate!, $duration: ClearableMinutesInput, $workTime: ClearableWorkTimeInput, $overtime: Boolean!, $comment: ClearableStringInput, $remoteWork: Boolean!) {
  reporting {
    workRecord {
      update(
        id: $workRecordId
        projectId: $projectId
        workTagId: $workTagId
        date: $date
        duration: $duration
        workTime: $workTime
        overtime: $overtime
        comment: $comment
        remoteWork: $remoteWork
      ) {
        ...NfsError
        ... on WorkRecord {
          ...WorkRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${WorkRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalUpdateWorkRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalUpdateWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalUpdateWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalUpdateWorkRecordMutation, { data, loading, error }] = useTimeReportEntryModalUpdateWorkRecordMutation({
 *   variables: {
 *      workRecordId: // value for 'workRecordId'
 *      projectId: // value for 'projectId'
 *      workTagId: // value for 'workTagId'
 *      date: // value for 'date'
 *      duration: // value for 'duration'
 *      workTime: // value for 'workTime'
 *      overtime: // value for 'overtime'
 *      comment: // value for 'comment'
 *      remoteWork: // value for 'remoteWork'
 *   },
 * });
 */
export function useTimeReportEntryModalUpdateWorkRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalUpdateWorkRecordMutation, TimeReportEntryModalUpdateWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalUpdateWorkRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalUpdateWorkRecordMutation, TimeReportEntryModalUpdateWorkRecordMutationVariables>(TimeReportEntryModalUpdateWorkRecordDocument, parser(options)));
      }
export type TimeReportEntryModalUpdateWorkRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalUpdateWorkRecordMutation>;
export type TimeReportEntryModalUpdateWorkRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalUpdateWorkRecordMutation>;
export type TimeReportEntryModalUpdateWorkRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalUpdateWorkRecordMutation, TimeReportEntryModalUpdateWorkRecordMutationVariables>;
export const TimeReportEntryModalDeleteWorkRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_DeleteWorkRecord($workRecordId: WorkRecordId!) {
  reporting {
    deleteTimeReports(
      workRecordIds: [$workRecordId]
      onCallRecordIds: []
      absenceRecordIds: []
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportEntryModalDeleteWorkRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalDeleteWorkRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalDeleteWorkRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalDeleteWorkRecordMutation, { data, loading, error }] = useTimeReportEntryModalDeleteWorkRecordMutation({
 *   variables: {
 *      workRecordId: // value for 'workRecordId'
 *   },
 * });
 */
export function useTimeReportEntryModalDeleteWorkRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalDeleteWorkRecordMutation, TimeReportEntryModalDeleteWorkRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalDeleteWorkRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalDeleteWorkRecordMutation, TimeReportEntryModalDeleteWorkRecordMutationVariables>(TimeReportEntryModalDeleteWorkRecordDocument, parser(options)));
      }
export type TimeReportEntryModalDeleteWorkRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalDeleteWorkRecordMutation>;
export type TimeReportEntryModalDeleteWorkRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalDeleteWorkRecordMutation>;
export type TimeReportEntryModalDeleteWorkRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalDeleteWorkRecordMutation, TimeReportEntryModalDeleteWorkRecordMutationVariables>;
export const TimeReportEntryModalCreateOnCallRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_CreateOnCallRecord($onCallRecords: [CreateOnCallRecordInput!]!) {
  reporting {
    oncallRecord {
      createMany(value: $onCallRecords) {
        ...NfsError
        ... on ListOfOnCallRecordResponse {
          value {
            ...OnCallRecord
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OnCallRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalCreateOnCallRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalCreateOnCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalCreateOnCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalCreateOnCallRecordMutation, { data, loading, error }] = useTimeReportEntryModalCreateOnCallRecordMutation({
 *   variables: {
 *      onCallRecords: // value for 'onCallRecords'
 *   },
 * });
 */
export function useTimeReportEntryModalCreateOnCallRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalCreateOnCallRecordMutation, TimeReportEntryModalCreateOnCallRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalCreateOnCallRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalCreateOnCallRecordMutation, TimeReportEntryModalCreateOnCallRecordMutationVariables>(TimeReportEntryModalCreateOnCallRecordDocument, parser(options)));
      }
export type TimeReportEntryModalCreateOnCallRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalCreateOnCallRecordMutation>;
export type TimeReportEntryModalCreateOnCallRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalCreateOnCallRecordMutation>;
export type TimeReportEntryModalCreateOnCallRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalCreateOnCallRecordMutation, TimeReportEntryModalCreateOnCallRecordMutationVariables>;
export const TimeReportEntryModalUpdateOnCallRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_UpdateOnCallRecord($onCallRecordId: OnCallRecordId!, $projectId: ProjectId!, $date: LocalDate!, $dayShift: Boolean!, $nightShift: Boolean!, $comment: ClearableStringInput) {
  reporting {
    oncallRecord {
      update(
        id: $onCallRecordId
        projectId: $projectId
        date: $date
        dayShift: $dayShift
        nightShift: $nightShift
        comment: $comment
      ) {
        ...NfsError
        ... on OnCallRecord {
          ...OnCallRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OnCallRecordFragmentDoc}`;


/**
 * __useTimeReportEntryModalUpdateOnCallRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalUpdateOnCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalUpdateOnCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalUpdateOnCallRecordMutation, { data, loading, error }] = useTimeReportEntryModalUpdateOnCallRecordMutation({
 *   variables: {
 *      onCallRecordId: // value for 'onCallRecordId'
 *      projectId: // value for 'projectId'
 *      date: // value for 'date'
 *      dayShift: // value for 'dayShift'
 *      nightShift: // value for 'nightShift'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useTimeReportEntryModalUpdateOnCallRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalUpdateOnCallRecordMutation, TimeReportEntryModalUpdateOnCallRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalUpdateOnCallRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalUpdateOnCallRecordMutation, TimeReportEntryModalUpdateOnCallRecordMutationVariables>(TimeReportEntryModalUpdateOnCallRecordDocument, parser(options)));
      }
export type TimeReportEntryModalUpdateOnCallRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalUpdateOnCallRecordMutation>;
export type TimeReportEntryModalUpdateOnCallRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalUpdateOnCallRecordMutation>;
export type TimeReportEntryModalUpdateOnCallRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalUpdateOnCallRecordMutation, TimeReportEntryModalUpdateOnCallRecordMutationVariables>;
export const TimeReportEntryModalDeleteOnCallRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_DeleteOnCallRecord($onCallRecordId: OnCallRecordId!) {
  reporting {
    deleteTimeReports(
      workRecordIds: []
      onCallRecordIds: [$onCallRecordId]
      absenceRecordIds: []
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportEntryModalDeleteOnCallRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalDeleteOnCallRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalDeleteOnCallRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalDeleteOnCallRecordMutation, { data, loading, error }] = useTimeReportEntryModalDeleteOnCallRecordMutation({
 *   variables: {
 *      onCallRecordId: // value for 'onCallRecordId'
 *   },
 * });
 */
export function useTimeReportEntryModalDeleteOnCallRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalDeleteOnCallRecordMutation, TimeReportEntryModalDeleteOnCallRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalDeleteOnCallRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalDeleteOnCallRecordMutation, TimeReportEntryModalDeleteOnCallRecordMutationVariables>(TimeReportEntryModalDeleteOnCallRecordDocument, parser(options)));
      }
export type TimeReportEntryModalDeleteOnCallRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalDeleteOnCallRecordMutation>;
export type TimeReportEntryModalDeleteOnCallRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalDeleteOnCallRecordMutation>;
export type TimeReportEntryModalDeleteOnCallRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalDeleteOnCallRecordMutation, TimeReportEntryModalDeleteOnCallRecordMutationVariables>;
export const TimeReportEntryModalDeleteAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation TimeReportEntryModal_DeleteAbsenceRecord($absenceRecordId: AbsenceRecordId!) {
  reporting {
    deleteTimeReports(
      workRecordIds: []
      onCallRecordIds: []
      absenceRecordIds: [$absenceRecordId]
    ) {
      ...NfsError
      ... on UnitResponse {
        value
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportEntryModalDeleteAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useTimeReportEntryModalDeleteAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportEntryModalDeleteAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportEntryModalDeleteAbsenceRecordMutation, { data, loading, error }] = useTimeReportEntryModalDeleteAbsenceRecordMutation({
 *   variables: {
 *      absenceRecordId: // value for 'absenceRecordId'
 *   },
 * });
 */
export function useTimeReportEntryModalDeleteAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportEntryModalDeleteAbsenceRecordMutation, TimeReportEntryModalDeleteAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportEntryModalDeleteAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportEntryModalDeleteAbsenceRecordMutation, TimeReportEntryModalDeleteAbsenceRecordMutationVariables>(TimeReportEntryModalDeleteAbsenceRecordDocument, parser(options)));
      }
export type TimeReportEntryModalDeleteAbsenceRecordMutationHookResult = ReturnType<typeof useTimeReportEntryModalDeleteAbsenceRecordMutation>;
export type TimeReportEntryModalDeleteAbsenceRecordMutationResult = ApolloReact.MutationResult<TimeReportEntryModalDeleteAbsenceRecordMutation>;
export type TimeReportEntryModalDeleteAbsenceRecordMutationOptions = Apollo.MutationOptions<TimeReportEntryModalDeleteAbsenceRecordMutation, TimeReportEntryModalDeleteAbsenceRecordMutationVariables>;
export const UserTimeReportEntryModalLimitsDocument = /*#__PURE__*/ gql`
    query User_TimeReportEntryModal_Limits($year: Year!, $from: LocalDate!, $to: LocalDate!, $contractId: ContractId!, $hasAnnualLeave: Boolean!) {
  remainingWorkTagReportingLimit(year: $year) {
    ...NfsError
    ... on ListOfKVWorkTagIdMinutesResponse {
      value {
        key
        value
      }
    }
  }
  paidLeaveBalanceYearlySummary(contractId: $contractId, year: $year) {
    ...NfsError
    ...LeaveBalance
  }
  annualLeaveSummary(contractId: $contractId, year: $year) @include(if: $hasAnnualLeave) {
    ...NfsError
    ...TimeReportEntryModal_AnnualLeaveSummary
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        ... on EmploymentTimeReportStats {
          reportedLeaveDays {
            ...ReportedLeaveDays
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${LeaveBalanceFragmentDoc}
${TimeReportEntryModalAnnualLeaveSummaryFragmentDoc}
${ReportedLeaveDaysFragmentDoc}`;

/**
 * __useUserTimeReportEntryModalLimitsQuery__
 *
 * To run a query within a React component, call `useUserTimeReportEntryModalLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportEntryModalLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportEntryModalLimitsQuery({
 *   variables: {
 *      year: // value for 'year'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      contractId: // value for 'contractId'
 *      hasAnnualLeave: // value for 'hasAnnualLeave'
 *   },
 * });
 */
export function useUserTimeReportEntryModalLimitsQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportEntryModalLimitsQuery, UserTimeReportEntryModalLimitsQueryVariables> & ({ variables: UserTimeReportEntryModalLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportEntryModalLimitsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportEntryModalLimitsQuery, UserTimeReportEntryModalLimitsQueryVariables>(UserTimeReportEntryModalLimitsDocument, parser(options)));
      }
export function useUserTimeReportEntryModalLimitsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportEntryModalLimitsQuery, UserTimeReportEntryModalLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportEntryModalLimitsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportEntryModalLimitsQuery, UserTimeReportEntryModalLimitsQueryVariables>(UserTimeReportEntryModalLimitsDocument, options));
        }

export type UserTimeReportEntryModalLimitsQueryResult = ApolloReact.QueryResult<UserTimeReportEntryModalLimitsQuery, UserTimeReportEntryModalLimitsQueryVariables>;
export function refetchUserTimeReportEntryModalLimitsQuery(variables: UserTimeReportEntryModalLimitsQueryVariables) {
      return { query: UserTimeReportEntryModalLimitsDocument, variables: variables }
    }
export const UserTimeReportEntryModalCreateSingularAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation User_TimeReportEntryModal_CreateSingularAbsenceRecord($absenceRecord: CreateAbsenceRecordInput!, $attachment: Upload!) {
  userCreate: reporting {
    absenceRecord {
      create(absenceRecord: $absenceRecord, attachment: $attachment) {
        ...NfsError
        ... on AbsenceRecord {
          ...AbsenceRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AbsenceRecordFragmentDoc}`;


/**
 * __useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userTimeReportEntryModalCreateSingularAbsenceRecordMutation, { data, loading, error }] = useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation({
 *   variables: {
 *      absenceRecord: // value for 'absenceRecord'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<UserTimeReportEntryModalCreateSingularAbsenceRecordMutation, UserTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportEntryModalCreateSingularAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserTimeReportEntryModalCreateSingularAbsenceRecordMutation, UserTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables>(UserTimeReportEntryModalCreateSingularAbsenceRecordDocument, parser(options)));
      }
export type UserTimeReportEntryModalCreateSingularAbsenceRecordMutationHookResult = ReturnType<typeof useUserTimeReportEntryModalCreateSingularAbsenceRecordMutation>;
export type UserTimeReportEntryModalCreateSingularAbsenceRecordMutationResult = ApolloReact.MutationResult<UserTimeReportEntryModalCreateSingularAbsenceRecordMutation>;
export type UserTimeReportEntryModalCreateSingularAbsenceRecordMutationOptions = Apollo.MutationOptions<UserTimeReportEntryModalCreateSingularAbsenceRecordMutation, UserTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables>;
export const UserTimeReportEntryModalUpdateAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation User_TimeReportEntryModal_UpdateAbsenceRecord($id: AbsenceRecordId!, $absenceType: AbsenceTypeInput, $dateFrom: LocalDate, $dateTo: LocalDate, $comment: ClearableStringInput, $customDurationPerDay: ClearableMinutesInput, $isOnDemand: Boolean, $attachment: ClearableUploadInput) {
  userUpdate: reporting {
    absenceRecord {
      update(
        id: $id
        absenceType: $absenceType
        dateFrom: $dateFrom
        dateTo: $dateTo
        comment: $comment
        customDurationPerDay: $customDurationPerDay
        isOnDemand: $isOnDemand
        attachment: $attachment
      ) {
        ...NfsError
        ... on AbsenceRecord {
          ...AbsenceRecord
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AbsenceRecordFragmentDoc}`;


/**
 * __useUserTimeReportEntryModalUpdateAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useUserTimeReportEntryModalUpdateAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportEntryModalUpdateAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userTimeReportEntryModalUpdateAbsenceRecordMutation, { data, loading, error }] = useUserTimeReportEntryModalUpdateAbsenceRecordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      absenceType: // value for 'absenceType'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      comment: // value for 'comment'
 *      customDurationPerDay: // value for 'customDurationPerDay'
 *      isOnDemand: // value for 'isOnDemand'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useUserTimeReportEntryModalUpdateAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<UserTimeReportEntryModalUpdateAbsenceRecordMutation, UserTimeReportEntryModalUpdateAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportEntryModalUpdateAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserTimeReportEntryModalUpdateAbsenceRecordMutation, UserTimeReportEntryModalUpdateAbsenceRecordMutationVariables>(UserTimeReportEntryModalUpdateAbsenceRecordDocument, parser(options)));
      }
export type UserTimeReportEntryModalUpdateAbsenceRecordMutationHookResult = ReturnType<typeof useUserTimeReportEntryModalUpdateAbsenceRecordMutation>;
export type UserTimeReportEntryModalUpdateAbsenceRecordMutationResult = ApolloReact.MutationResult<UserTimeReportEntryModalUpdateAbsenceRecordMutation>;
export type UserTimeReportEntryModalUpdateAbsenceRecordMutationOptions = Apollo.MutationOptions<UserTimeReportEntryModalUpdateAbsenceRecordMutation, UserTimeReportEntryModalUpdateAbsenceRecordMutationVariables>;
export const UserTimeReportEntryModalCreateAbsenceRecordDocument = /*#__PURE__*/ gql`
    mutation User_TimeReportEntryModal_CreateAbsenceRecord($absenceRecords: [CreateAbsenceRecordInput!]!) {
  userCreate: reporting {
    absenceRecord {
      createMany(value: $absenceRecords) {
        ...NfsError
        ... on ListOfAbsenceRecordResponse {
          value {
            ...AbsenceRecord
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AbsenceRecordFragmentDoc}`;


/**
 * __useUserTimeReportEntryModalCreateAbsenceRecordMutation__
 *
 * To run a mutation, you first call `useUserTimeReportEntryModalCreateAbsenceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportEntryModalCreateAbsenceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userTimeReportEntryModalCreateAbsenceRecordMutation, { data, loading, error }] = useUserTimeReportEntryModalCreateAbsenceRecordMutation({
 *   variables: {
 *      absenceRecords: // value for 'absenceRecords'
 *   },
 * });
 */
export function useUserTimeReportEntryModalCreateAbsenceRecordMutation(baseOptions?: ApolloReact.MutationHookOptions<UserTimeReportEntryModalCreateAbsenceRecordMutation, UserTimeReportEntryModalCreateAbsenceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportEntryModalCreateAbsenceRecordDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<UserTimeReportEntryModalCreateAbsenceRecordMutation, UserTimeReportEntryModalCreateAbsenceRecordMutationVariables>(UserTimeReportEntryModalCreateAbsenceRecordDocument, parser(options)));
      }
export type UserTimeReportEntryModalCreateAbsenceRecordMutationHookResult = ReturnType<typeof useUserTimeReportEntryModalCreateAbsenceRecordMutation>;
export type UserTimeReportEntryModalCreateAbsenceRecordMutationResult = ApolloReact.MutationResult<UserTimeReportEntryModalCreateAbsenceRecordMutation>;
export type UserTimeReportEntryModalCreateAbsenceRecordMutationOptions = Apollo.MutationOptions<UserTimeReportEntryModalCreateAbsenceRecordMutation, UserTimeReportEntryModalCreateAbsenceRecordMutationVariables>;
export const UserTimeReportFinancesDocument = /*#__PURE__*/ gql`
    query User_TimeReportFinances($contractId: ContractId!, $from: LocalDate!, $to: LocalDate!, $month: YearMonth!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...TimeReportFinances_Contract
      }
    }
  }
  contractSalaryDetails(date: $month, contractId: $contractId) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      ...TimeReportFinances_SalaryDetails
    }
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        incomeDetails {
          ...TimeReportFinances_IncomeDetails
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportFinancesContractFragmentDoc}
${TimeReportFinancesSalaryDetailsFragmentDoc}
${TimeReportFinancesIncomeDetailsFragmentDoc}`;

/**
 * __useUserTimeReportFinancesQuery__
 *
 * To run a query within a React component, call `useUserTimeReportFinancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportFinancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportFinancesQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useUserTimeReportFinancesQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportFinancesQuery, UserTimeReportFinancesQueryVariables> & ({ variables: UserTimeReportFinancesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportFinancesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportFinancesQuery, UserTimeReportFinancesQueryVariables>(UserTimeReportFinancesDocument, parser(options)));
      }
export function useUserTimeReportFinancesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportFinancesQuery, UserTimeReportFinancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportFinancesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportFinancesQuery, UserTimeReportFinancesQueryVariables>(UserTimeReportFinancesDocument, options));
        }

export type UserTimeReportFinancesQueryResult = ApolloReact.QueryResult<UserTimeReportFinancesQuery, UserTimeReportFinancesQueryVariables>;
export function refetchUserTimeReportFinancesQuery(variables: UserTimeReportFinancesQueryVariables) {
      return { query: UserTimeReportFinancesDocument, variables: variables }
    }
export const UserTimeReportLeaveAndTrainingDocument = /*#__PURE__*/ gql`
    query User_TimeReportLeaveAndTraining($contractId: ContractId!, $year: Year!, $from: LocalDate!, $to: LocalDate!) {
  annualLeaveSummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on AnnualLeaveSummary {
      ...TimeReportLeaveAndTraining_AnnualLeaveSummary
    }
  }
  paidLeaveBalanceYearlySummary(contractId: $contractId, year: $year) {
    ...NfsError
    ...LeaveBalance
  }
  remainingWorkTagReportingLimit(year: $year) {
    ...NfsError
    ... on ListOfKVWorkTagIdMinutesResponse {
      value {
        key
        value
      }
    }
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      ...TimeReportLeaveAndTraining_TimeReport
    }
  }
  trainingBudgetSummary(contractId: $contractId, year: $year) {
    ...NfsError
    ... on TrainingBudgetSummary {
      ...TimeReportLeaveAndTraining_TrainingPackage
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportLeaveAndTrainingAnnualLeaveSummaryFragmentDoc}
${LeaveBalanceFragmentDoc}
${TimeReportLeaveAndTrainingTimeReportFragmentDoc}
${TimeReportLeaveAndTrainingTrainingPackageFragmentDoc}`;

/**
 * __useUserTimeReportLeaveAndTrainingQuery__
 *
 * To run a query within a React component, call `useUserTimeReportLeaveAndTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportLeaveAndTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportLeaveAndTrainingQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      year: // value for 'year'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUserTimeReportLeaveAndTrainingQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportLeaveAndTrainingQuery, UserTimeReportLeaveAndTrainingQueryVariables> & ({ variables: UserTimeReportLeaveAndTrainingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportLeaveAndTrainingDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportLeaveAndTrainingQuery, UserTimeReportLeaveAndTrainingQueryVariables>(UserTimeReportLeaveAndTrainingDocument, parser(options)));
      }
export function useUserTimeReportLeaveAndTrainingLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportLeaveAndTrainingQuery, UserTimeReportLeaveAndTrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportLeaveAndTrainingDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportLeaveAndTrainingQuery, UserTimeReportLeaveAndTrainingQueryVariables>(UserTimeReportLeaveAndTrainingDocument, options));
        }

export type UserTimeReportLeaveAndTrainingQueryResult = ApolloReact.QueryResult<UserTimeReportLeaveAndTrainingQuery, UserTimeReportLeaveAndTrainingQueryVariables>;
export function refetchUserTimeReportLeaveAndTrainingQuery(variables: UserTimeReportLeaveAndTrainingQueryVariables) {
      return { query: UserTimeReportLeaveAndTrainingDocument, variables: variables }
    }
export const UserTimeReportOnCallDetailsModalDocument = /*#__PURE__*/ gql`
    query User_TimeReportOnCallDetailsModal {
  onCallMultipliers {
    ...NfsError
    ... on OnCallMultipliers {
      weekdays {
        day {
          saturday
          sunday
        }
        night {
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
      }
      holidays {
        beforeHolidayNight
        holidayDay
        holidayNight
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useUserTimeReportOnCallDetailsModalQuery__
 *
 * To run a query within a React component, call `useUserTimeReportOnCallDetailsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportOnCallDetailsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportOnCallDetailsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTimeReportOnCallDetailsModalQuery(baseOptions?: ApolloReact.QueryHookOptions<UserTimeReportOnCallDetailsModalQuery, UserTimeReportOnCallDetailsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportOnCallDetailsModalDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportOnCallDetailsModalQuery, UserTimeReportOnCallDetailsModalQueryVariables>(UserTimeReportOnCallDetailsModalDocument, parser(options)));
      }
export function useUserTimeReportOnCallDetailsModalLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportOnCallDetailsModalQuery, UserTimeReportOnCallDetailsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportOnCallDetailsModalDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportOnCallDetailsModalQuery, UserTimeReportOnCallDetailsModalQueryVariables>(UserTimeReportOnCallDetailsModalDocument, options));
        }

export type UserTimeReportOnCallDetailsModalQueryResult = ApolloReact.QueryResult<UserTimeReportOnCallDetailsModalQuery, UserTimeReportOnCallDetailsModalQueryVariables>;
export function refetchUserTimeReportOnCallDetailsModalQuery(variables?: UserTimeReportOnCallDetailsModalQueryVariables) {
      return { query: UserTimeReportOnCallDetailsModalDocument, variables: variables }
    }
export const UserTimeReportStatsDocument = /*#__PURE__*/ gql`
    query User_TimeReportStats($from: LocalDate!, $to: LocalDate!, $year: Year!, $contractId: ContractId!, $hasAnnualLeave: Boolean!) {
  annualLeaveSummary(contractId: $contractId, year: $year) @include(if: $hasAnnualLeave) {
    ...NfsError
    ... on AnnualLeaveSummary {
      yearlySummary {
        key
        value {
          year
          totalBalance {
            ...AnnualLeaveBalance
          }
        }
      }
    }
  }
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportStats {
        ... on EmploymentTimeReportStats {
          ...TimeReportStats_EmploymentStats
        }
        ... on B2BTimeReportStats {
          ...TimeReportStats_B2BStats
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AnnualLeaveBalanceFragmentDoc}
${TimeReportStatsEmploymentStatsFragmentDoc}
${TimeReportStatsB2BStatsFragmentDoc}`;

/**
 * __useUserTimeReportStatsQuery__
 *
 * To run a query within a React component, call `useUserTimeReportStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimeReportStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimeReportStatsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      year: // value for 'year'
 *      contractId: // value for 'contractId'
 *      hasAnnualLeave: // value for 'hasAnnualLeave'
 *   },
 * });
 */
export function useUserTimeReportStatsQuery(baseOptions: ApolloReact.QueryHookOptions<UserTimeReportStatsQuery, UserTimeReportStatsQueryVariables> & ({ variables: UserTimeReportStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserTimeReportStatsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserTimeReportStatsQuery, UserTimeReportStatsQueryVariables>(UserTimeReportStatsDocument, parser(options)));
      }
export function useUserTimeReportStatsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserTimeReportStatsQuery, UserTimeReportStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserTimeReportStatsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserTimeReportStatsQuery, UserTimeReportStatsQueryVariables>(UserTimeReportStatsDocument, options));
        }

export type UserTimeReportStatsQueryResult = ApolloReact.QueryResult<UserTimeReportStatsQuery, UserTimeReportStatsQueryVariables>;
export function refetchUserTimeReportStatsQuery(variables: UserTimeReportStatsQueryVariables) {
      return { query: UserTimeReportStatsDocument, variables: variables }
    }
export const TimeReportWorkTimeInsightsDocument = /*#__PURE__*/ gql`
    query TimeReport_WorkTimeInsights($from: LocalDate!, $to: LocalDate!, $contractId: ContractId!) {
  timeReport(from: $from, to: $to, contractId: $contractId) {
    ...NfsError
    ... on TimeReport {
      timeReportRecords {
        work {
          id
          duration
          remoteWork
          overtime
          workTag {
            id
            name
          }
          project {
            id
            name
          }
        }
        onCall {
          id
        }
      }
      timeReportStats {
        currentTimeBalance {
          currentTimeRequirement
          balance
          reportedStandardWorkTime
          absenceTime
        }
        ... on EmploymentTimeReportStats {
          ...TimeReportStats_EmploymentStats
        }
        ... on B2BTimeReportStats {
          ...TimeReportStats_B2BStats
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${TimeReportStatsEmploymentStatsFragmentDoc}
${TimeReportStatsB2BStatsFragmentDoc}`;

/**
 * __useTimeReportWorkTimeInsightsQuery__
 *
 * To run a query within a React component, call `useTimeReportWorkTimeInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportWorkTimeInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportWorkTimeInsightsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useTimeReportWorkTimeInsightsQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables> & ({ variables: TimeReportWorkTimeInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportWorkTimeInsightsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>(TimeReportWorkTimeInsightsDocument, parser(options)));
      }
export function useTimeReportWorkTimeInsightsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportWorkTimeInsightsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>(TimeReportWorkTimeInsightsDocument, options));
        }

export type TimeReportWorkTimeInsightsQueryResult = ApolloReact.QueryResult<TimeReportWorkTimeInsightsQuery, TimeReportWorkTimeInsightsQueryVariables>;
export function refetchTimeReportWorkTimeInsightsQuery(variables: TimeReportWorkTimeInsightsQueryVariables) {
      return { query: TimeReportWorkTimeInsightsDocument, variables: variables }
    }
export const UserPreviousMonthSalaryStateDocument = /*#__PURE__*/ gql`
    query User_PreviousMonthSalaryState($contractId: ContractId!, $date: YearMonth!) {
  contractSalaryDetails(contractId: $contractId, date: $date) {
    ...NfsError
    ... on ContractSalaryDetailsResponse {
      value {
        contractId
        yearMonth
        salaryState {
          __typename
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useUserPreviousMonthSalaryStateQuery__
 *
 * To run a query within a React component, call `useUserPreviousMonthSalaryStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPreviousMonthSalaryStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPreviousMonthSalaryStateQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUserPreviousMonthSalaryStateQuery(baseOptions: ApolloReact.QueryHookOptions<UserPreviousMonthSalaryStateQuery, UserPreviousMonthSalaryStateQueryVariables> & ({ variables: UserPreviousMonthSalaryStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(UserPreviousMonthSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<UserPreviousMonthSalaryStateQuery, UserPreviousMonthSalaryStateQueryVariables>(UserPreviousMonthSalaryStateDocument, parser(options)));
      }
export function useUserPreviousMonthSalaryStateLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<UserPreviousMonthSalaryStateQuery, UserPreviousMonthSalaryStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(UserPreviousMonthSalaryStateDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<UserPreviousMonthSalaryStateQuery, UserPreviousMonthSalaryStateQueryVariables>(UserPreviousMonthSalaryStateDocument, options));
        }

export type UserPreviousMonthSalaryStateQueryResult = ApolloReact.QueryResult<UserPreviousMonthSalaryStateQuery, UserPreviousMonthSalaryStateQueryVariables>;
export function refetchUserPreviousMonthSalaryStateQuery(variables: UserPreviousMonthSalaryStateQueryVariables) {
      return { query: UserPreviousMonthSalaryStateDocument, variables: variables }
    }
export const BookDeskDrawerInputDocument = /*#__PURE__*/ gql`
    query BookDeskDrawer_Input($officeId: OfficeId!) {
  reservableOffices {
    ...NfsError
    ... on ListOfReservableOfficeResponse {
      value {
        office {
          officeId
          name
          validFrom
          validTo
          blocked
        }
        rooms {
          ...BookDeskDrawerRoom
        }
      }
    }
  }
  officeReservationLimits {
    ...NfsError
    ... on OfficeReservationSettings {
      deskMaxDays
      deskMaxAdvanceDays
      parkingMaxAdvanceDays
    }
  }
  officeAvailability(officeId: $officeId) {
    ...NfsError
    ... on OfficeAvailability {
      desks {
        resourceId
        takenDates
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${BookDeskDrawerRoomFragmentDoc}`;

/**
 * __useBookDeskDrawerInputQuery__
 *
 * To run a query within a React component, call `useBookDeskDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookDeskDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookDeskDrawerInputQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useBookDeskDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<BookDeskDrawerInputQuery, BookDeskDrawerInputQueryVariables> & ({ variables: BookDeskDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookDeskDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BookDeskDrawerInputQuery, BookDeskDrawerInputQueryVariables>(BookDeskDrawerInputDocument, parser(options)));
      }
export function useBookDeskDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BookDeskDrawerInputQuery, BookDeskDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BookDeskDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BookDeskDrawerInputQuery, BookDeskDrawerInputQueryVariables>(BookDeskDrawerInputDocument, options));
        }

export type BookDeskDrawerInputQueryResult = ApolloReact.QueryResult<BookDeskDrawerInputQuery, BookDeskDrawerInputQueryVariables>;
export function refetchBookDeskDrawerInputQuery(variables: BookDeskDrawerInputQueryVariables) {
      return { query: BookDeskDrawerInputDocument, variables: variables }
    }
export const BookDeskDrawerReserveDocument = /*#__PURE__*/ gql`
    mutation BookDeskDrawer_Reserve($requestId: ReservationRequestId!, $roomId: RoomId!, $deskIds: [DeskId!]!, $range: ClosedEndLocalDateRangeInput!, $notes: String, $guestEmails: [EmailAddress!]!) {
  officeReservations {
    reserveDesks(
      requestId: $requestId
      roomId: $roomId
      deskIds: $deskIds
      range: $range
      notes: $notes
      guestEmails: $guestEmails
    ) {
      ...NfsError
      ... on ReservationRequest {
        requestId
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBookDeskDrawerReserveMutation__
 *
 * To run a mutation, you first call `useBookDeskDrawerReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookDeskDrawerReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookDeskDrawerReserveMutation, { data, loading, error }] = useBookDeskDrawerReserveMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      roomId: // value for 'roomId'
 *      deskIds: // value for 'deskIds'
 *      range: // value for 'range'
 *      notes: // value for 'notes'
 *      guestEmails: // value for 'guestEmails'
 *   },
 * });
 */
export function useBookDeskDrawerReserveMutation(baseOptions?: ApolloReact.MutationHookOptions<BookDeskDrawerReserveMutation, BookDeskDrawerReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookDeskDrawerReserveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BookDeskDrawerReserveMutation, BookDeskDrawerReserveMutationVariables>(BookDeskDrawerReserveDocument, parser(options)));
      }
export type BookDeskDrawerReserveMutationHookResult = ReturnType<typeof useBookDeskDrawerReserveMutation>;
export type BookDeskDrawerReserveMutationResult = ApolloReact.MutationResult<BookDeskDrawerReserveMutation>;
export type BookDeskDrawerReserveMutationOptions = Apollo.MutationOptions<BookDeskDrawerReserveMutation, BookDeskDrawerReserveMutationVariables>;
export const BookParkingDrawerInputDocument = /*#__PURE__*/ gql`
    query BookParkingDrawer_Input($officeId: OfficeId!) {
  reservableOffices {
    ...NfsError
    ... on ListOfReservableOfficeResponse {
      value {
        office {
          officeId
          name
          validFrom
          validTo
          blocked
        }
        parkingInformation
        parkingSpots {
          ...BookParkingDrawerSpot
        }
      }
    }
  }
  officeReservationLimits {
    ...NfsError
    ... on OfficeReservationSettings {
      deskMaxAdvanceDays
      parkingMaxAdvanceDays
      parkingMaxDays
    }
  }
  officeAvailability(officeId: $officeId) {
    ...NfsError
    ... on OfficeAvailability {
      parkingSpots {
        resourceId
        takenDates
      }
    }
  }
  profile {
    ...NfsError
    ... on User {
      id
      plateNumber
    }
  }
}
    ${NfsErrorFragmentDoc}
${BookParkingDrawerSpotFragmentDoc}`;

/**
 * __useBookParkingDrawerInputQuery__
 *
 * To run a query within a React component, call `useBookParkingDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookParkingDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookParkingDrawerInputQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useBookParkingDrawerInputQuery(baseOptions: ApolloReact.QueryHookOptions<BookParkingDrawerInputQuery, BookParkingDrawerInputQueryVariables> & ({ variables: BookParkingDrawerInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookParkingDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<BookParkingDrawerInputQuery, BookParkingDrawerInputQueryVariables>(BookParkingDrawerInputDocument, parser(options)));
      }
export function useBookParkingDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<BookParkingDrawerInputQuery, BookParkingDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(BookParkingDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<BookParkingDrawerInputQuery, BookParkingDrawerInputQueryVariables>(BookParkingDrawerInputDocument, options));
        }

export type BookParkingDrawerInputQueryResult = ApolloReact.QueryResult<BookParkingDrawerInputQuery, BookParkingDrawerInputQueryVariables>;
export function refetchBookParkingDrawerInputQuery(variables: BookParkingDrawerInputQueryVariables) {
      return { query: BookParkingDrawerInputDocument, variables: variables }
    }
export const BookParkingDrawerReserveDocument = /*#__PURE__*/ gql`
    mutation BookParkingDrawer_Reserve($requestId: ReservationRequestId!, $officeId: OfficeId!, $parkingSpotId: ParkingSpotId, $range: ClosedEndLocalDateRangeInput!, $plateNumber: String, $notes: String, $guestEmails: [EmailAddress!]!) {
  officeReservations {
    reserveParking(
      requestId: $requestId
      officeId: $officeId
      parkingSpotId: $parkingSpotId
      range: $range
      plateNumber: $plateNumber
      notes: $notes
      guestEmails: $guestEmails
    ) {
      ...NfsError
      ... on ReservationRequest {
        requestId
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useBookParkingDrawerReserveMutation__
 *
 * To run a mutation, you first call `useBookParkingDrawerReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookParkingDrawerReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookParkingDrawerReserveMutation, { data, loading, error }] = useBookParkingDrawerReserveMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      officeId: // value for 'officeId'
 *      parkingSpotId: // value for 'parkingSpotId'
 *      range: // value for 'range'
 *      plateNumber: // value for 'plateNumber'
 *      notes: // value for 'notes'
 *      guestEmails: // value for 'guestEmails'
 *   },
 * });
 */
export function useBookParkingDrawerReserveMutation(baseOptions?: ApolloReact.MutationHookOptions<BookParkingDrawerReserveMutation, BookParkingDrawerReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(BookParkingDrawerReserveDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<BookParkingDrawerReserveMutation, BookParkingDrawerReserveMutationVariables>(BookParkingDrawerReserveDocument, parser(options)));
      }
export type BookParkingDrawerReserveMutationHookResult = ReturnType<typeof useBookParkingDrawerReserveMutation>;
export type BookParkingDrawerReserveMutationResult = ApolloReact.MutationResult<BookParkingDrawerReserveMutation>;
export type BookParkingDrawerReserveMutationOptions = Apollo.MutationOptions<BookParkingDrawerReserveMutation, BookParkingDrawerReserveMutationVariables>;
export const EditAdditionalDataDrawerInputDocument = /*#__PURE__*/ gql`
    query EditAdditionalDataDrawer_Input {
  profile {
    ...NfsError
    ... on User {
      id
      passportExpirationDate
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useEditAdditionalDataDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditAdditionalDataDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAdditionalDataDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAdditionalDataDrawerInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditAdditionalDataDrawerInputQuery(baseOptions?: ApolloReact.QueryHookOptions<EditAdditionalDataDrawerInputQuery, EditAdditionalDataDrawerInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditAdditionalDataDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditAdditionalDataDrawerInputQuery, EditAdditionalDataDrawerInputQueryVariables>(EditAdditionalDataDrawerInputDocument, parser(options)));
      }
export function useEditAdditionalDataDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditAdditionalDataDrawerInputQuery, EditAdditionalDataDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditAdditionalDataDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditAdditionalDataDrawerInputQuery, EditAdditionalDataDrawerInputQueryVariables>(EditAdditionalDataDrawerInputDocument, options));
        }

export type EditAdditionalDataDrawerInputQueryResult = ApolloReact.QueryResult<EditAdditionalDataDrawerInputQuery, EditAdditionalDataDrawerInputQueryVariables>;
export function refetchEditAdditionalDataDrawerInputQuery(variables?: EditAdditionalDataDrawerInputQueryVariables) {
      return { query: EditAdditionalDataDrawerInputDocument, variables: variables }
    }
export const EditAdditionalDataDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditAdditionalDataDrawer_Update($passportExpirationDate: ClearableLocalDateInput) {
  updateProfile(passportExpirationDate: $passportExpirationDate) {
    ...NfsError
    ... on User {
      id
      passportExpirationDate
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditAdditionalDataDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditAdditionalDataDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAdditionalDataDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAdditionalDataDrawerUpdateMutation, { data, loading, error }] = useEditAdditionalDataDrawerUpdateMutation({
 *   variables: {
 *      passportExpirationDate: // value for 'passportExpirationDate'
 *   },
 * });
 */
export function useEditAdditionalDataDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditAdditionalDataDrawerUpdateMutation, EditAdditionalDataDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditAdditionalDataDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditAdditionalDataDrawerUpdateMutation, EditAdditionalDataDrawerUpdateMutationVariables>(EditAdditionalDataDrawerUpdateDocument, parser(options)));
      }
export type EditAdditionalDataDrawerUpdateMutationHookResult = ReturnType<typeof useEditAdditionalDataDrawerUpdateMutation>;
export type EditAdditionalDataDrawerUpdateMutationResult = ApolloReact.MutationResult<EditAdditionalDataDrawerUpdateMutation>;
export type EditAdditionalDataDrawerUpdateMutationOptions = Apollo.MutationOptions<EditAdditionalDataDrawerUpdateMutation, EditAdditionalDataDrawerUpdateMutationVariables>;
export const EditAddressDrawerInputDocument = /*#__PURE__*/ gql`
    query EditAddressDrawer_Input {
  profile {
    ...NfsError
    ... on User {
      id
      contactEmail
      phoneNumber
      address {
        ...Address
      }
      mailingAddress {
        ...Address
      }
      paczkomat
      plateNumber
      emergencyContact
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useEditAddressDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditAddressDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAddressDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAddressDrawerInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditAddressDrawerInputQuery(baseOptions?: ApolloReact.QueryHookOptions<EditAddressDrawerInputQuery, EditAddressDrawerInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditAddressDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditAddressDrawerInputQuery, EditAddressDrawerInputQueryVariables>(EditAddressDrawerInputDocument, parser(options)));
      }
export function useEditAddressDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditAddressDrawerInputQuery, EditAddressDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditAddressDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditAddressDrawerInputQuery, EditAddressDrawerInputQueryVariables>(EditAddressDrawerInputDocument, options));
        }

export type EditAddressDrawerInputQueryResult = ApolloReact.QueryResult<EditAddressDrawerInputQuery, EditAddressDrawerInputQueryVariables>;
export function refetchEditAddressDrawerInputQuery(variables?: EditAddressDrawerInputQueryVariables) {
      return { query: EditAddressDrawerInputDocument, variables: variables }
    }
export const EditAddressDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditAddressDrawer_Update($mailingAddress: ClearableAddressInput, $contactEmail: ClearableEmailAddressInput, $phoneNumber: ClearablePhoneNumberInput, $paczkomat: ClearableStringInput, $plateNumber: ClearableStringInput, $emergencyContact: ClearableStringInput) {
  updateProfile(
    mailingAddress: $mailingAddress
    contactEmail: $contactEmail
    phoneNumber: $phoneNumber
    paczkomat: $paczkomat
    plateNumber: $plateNumber
    emergencyContact: $emergencyContact
  ) {
    ...NfsError
    ... on User {
      id
      contactEmail
      phoneNumber
      address {
        ...Address
      }
      mailingAddress {
        ...Address
      }
      paczkomat
      plateNumber
      emergencyContact
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}`;


/**
 * __useEditAddressDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditAddressDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAddressDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAddressDrawerUpdateMutation, { data, loading, error }] = useEditAddressDrawerUpdateMutation({
 *   variables: {
 *      mailingAddress: // value for 'mailingAddress'
 *      contactEmail: // value for 'contactEmail'
 *      phoneNumber: // value for 'phoneNumber'
 *      paczkomat: // value for 'paczkomat'
 *      plateNumber: // value for 'plateNumber'
 *      emergencyContact: // value for 'emergencyContact'
 *   },
 * });
 */
export function useEditAddressDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditAddressDrawerUpdateMutation, EditAddressDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditAddressDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditAddressDrawerUpdateMutation, EditAddressDrawerUpdateMutationVariables>(EditAddressDrawerUpdateDocument, parser(options)));
      }
export type EditAddressDrawerUpdateMutationHookResult = ReturnType<typeof useEditAddressDrawerUpdateMutation>;
export type EditAddressDrawerUpdateMutationResult = ApolloReact.MutationResult<EditAddressDrawerUpdateMutation>;
export type EditAddressDrawerUpdateMutationOptions = Apollo.MutationOptions<EditAddressDrawerUpdateMutation, EditAddressDrawerUpdateMutationVariables>;
export const EditProfileDetailsDrawerInputDocument = /*#__PURE__*/ gql`
    query EditProfileDetailsDrawer_Input {
  profile {
    ...NfsError
    ... on User {
      id
      areaOfExpertise
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useEditProfileDetailsDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditProfileDetailsDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileDetailsDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileDetailsDrawerInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditProfileDetailsDrawerInputQuery(baseOptions?: ApolloReact.QueryHookOptions<EditProfileDetailsDrawerInputQuery, EditProfileDetailsDrawerInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileDetailsDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditProfileDetailsDrawerInputQuery, EditProfileDetailsDrawerInputQueryVariables>(EditProfileDetailsDrawerInputDocument, parser(options)));
      }
export function useEditProfileDetailsDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditProfileDetailsDrawerInputQuery, EditProfileDetailsDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditProfileDetailsDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditProfileDetailsDrawerInputQuery, EditProfileDetailsDrawerInputQueryVariables>(EditProfileDetailsDrawerInputDocument, options));
        }

export type EditProfileDetailsDrawerInputQueryResult = ApolloReact.QueryResult<EditProfileDetailsDrawerInputQuery, EditProfileDetailsDrawerInputQueryVariables>;
export function refetchEditProfileDetailsDrawerInputQuery(variables?: EditProfileDetailsDrawerInputQueryVariables) {
      return { query: EditProfileDetailsDrawerInputDocument, variables: variables }
    }
export const EditProfileDetailsDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditProfileDetailsDrawer_Update($area: ClearableStringInput) {
  updateProfile(areaOfExpertise: $area) {
    ...NfsError
    ... on User {
      id
      areaOfExpertise
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditProfileDetailsDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditProfileDetailsDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileDetailsDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileDetailsDrawerUpdateMutation, { data, loading, error }] = useEditProfileDetailsDrawerUpdateMutation({
 *   variables: {
 *      area: // value for 'area'
 *   },
 * });
 */
export function useEditProfileDetailsDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditProfileDetailsDrawerUpdateMutation, EditProfileDetailsDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditProfileDetailsDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditProfileDetailsDrawerUpdateMutation, EditProfileDetailsDrawerUpdateMutationVariables>(EditProfileDetailsDrawerUpdateDocument, parser(options)));
      }
export type EditProfileDetailsDrawerUpdateMutationHookResult = ReturnType<typeof useEditProfileDetailsDrawerUpdateMutation>;
export type EditProfileDetailsDrawerUpdateMutationResult = ApolloReact.MutationResult<EditProfileDetailsDrawerUpdateMutation>;
export type EditProfileDetailsDrawerUpdateMutationOptions = Apollo.MutationOptions<EditProfileDetailsDrawerUpdateMutation, EditProfileDetailsDrawerUpdateMutationVariables>;
export const EditSkillsAndCertificatesDrawerInputDocument = /*#__PURE__*/ gql`
    query EditSkillsAndCertificatesDrawer_Input {
  profile {
    ...NfsError
    ... on User {
      ...EditSkillsAndCertificatesDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSkillsAndCertificatesDrawerUserFragmentDoc}`;

/**
 * __useEditSkillsAndCertificatesDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditSkillsAndCertificatesDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSkillsAndCertificatesDrawerInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerInputQuery(baseOptions?: ApolloReact.QueryHookOptions<EditSkillsAndCertificatesDrawerInputQuery, EditSkillsAndCertificatesDrawerInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditSkillsAndCertificatesDrawerInputQuery, EditSkillsAndCertificatesDrawerInputQueryVariables>(EditSkillsAndCertificatesDrawerInputDocument, parser(options)));
      }
export function useEditSkillsAndCertificatesDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditSkillsAndCertificatesDrawerInputQuery, EditSkillsAndCertificatesDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditSkillsAndCertificatesDrawerInputQuery, EditSkillsAndCertificatesDrawerInputQueryVariables>(EditSkillsAndCertificatesDrawerInputDocument, options));
        }

export type EditSkillsAndCertificatesDrawerInputQueryResult = ApolloReact.QueryResult<EditSkillsAndCertificatesDrawerInputQuery, EditSkillsAndCertificatesDrawerInputQueryVariables>;
export function refetchEditSkillsAndCertificatesDrawerInputQuery(variables?: EditSkillsAndCertificatesDrawerInputQueryVariables) {
      return { query: EditSkillsAndCertificatesDrawerInputDocument, variables: variables }
    }
export const EditSkillsAndCertificatesDrawerUpdateSkillsDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_UpdateSkills($skills: [String!]) {
  updateProfile(skillsAndCompetences: $skills) {
    ...NfsError
    ... on User {
      ...EditSkillsAndCertificatesDrawer_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${EditSkillsAndCertificatesDrawerUserFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerUpdateSkillsMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerUpdateSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerUpdateSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerUpdateSkillsMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerUpdateSkillsMutation({
 *   variables: {
 *      skills: // value for 'skills'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerUpdateSkillsMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerUpdateSkillsMutation, EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerUpdateSkillsDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerUpdateSkillsMutation, EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables>(EditSkillsAndCertificatesDrawerUpdateSkillsDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerUpdateSkillsMutation>;
export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerUpdateSkillsMutation>;
export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerUpdateSkillsMutation, EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables>;
export const EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_UpdateDeclaredNoCertificates($declaredNoCertificates: Boolean!) {
  updateProfile(declaredNoCertificates: $declaredNoCertificates) {
    ...NfsError
    ... on User {
      id
      declaredNoCertificates
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation({
 *   variables: {
 *      declaredNoCertificates: // value for 'declaredNoCertificates'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables>(EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation>;
export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation>;
export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation, EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables>;
export const EditSkillsAndCertificatesDrawerCreateCertificateDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_CreateCertificate($id: CertificateId!, $name: String!, $issueDate: LocalDate, $expirationDate: LocalDate, $file: Upload) {
  reporting {
    certificateApi {
      createCertificate(
        id: $id
        name: $name
        issueDate: $issueDate
        expirationDate: $expirationDate
        file: $file
      ) {
        ...NfsError
        ... on Certificate {
          id
          name
          issueDate
          expirationDate
          file {
            fileName
            url
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerCreateCertificateMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerCreateCertificateMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerCreateCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      issueDate: // value for 'issueDate'
 *      expirationDate: // value for 'expirationDate'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerCreateCertificateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerCreateCertificateMutation, EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerCreateCertificateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerCreateCertificateMutation, EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables>(EditSkillsAndCertificatesDrawerCreateCertificateDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerCreateCertificateMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerCreateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerCreateCertificateMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerCreateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerCreateCertificateMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerCreateCertificateMutation, EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables>;
export const EditSkillsAndCertificatesDrawerUpdateCertificateDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_UpdateCertificate($certificateId: CertificateId!, $certificate: UpdateCertificateInput!) {
  reporting {
    certificateApi {
      updateCertificate(certificateId: $certificateId, certificate: $certificate) {
        ...NfsError
        ... on Certificate {
          id
          name
          issueDate
          expirationDate
          file {
            fileName
            url
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerUpdateCertificateMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerUpdateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerUpdateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerUpdateCertificateMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerUpdateCertificateMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *      certificate: // value for 'certificate'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerUpdateCertificateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerUpdateCertificateMutation, EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerUpdateCertificateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerUpdateCertificateMutation, EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables>(EditSkillsAndCertificatesDrawerUpdateCertificateDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerUpdateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerUpdateCertificateMutation>;
export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerUpdateCertificateMutation, EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables>;
export const EditSkillsAndCertificatesDrawerRemoveCertificateDocument = /*#__PURE__*/ gql`
    mutation EditSkillsAndCertificatesDrawer_RemoveCertificate($certificateId: CertificateId!) {
  reporting {
    certificateApi {
      removeCertificate(certificateId: $certificateId) {
        ...NfsError
        ... on BooleanResponse {
          value
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSkillsAndCertificatesDrawerRemoveCertificateMutation__
 *
 * To run a mutation, you first call `useEditSkillsAndCertificatesDrawerRemoveCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSkillsAndCertificatesDrawerRemoveCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSkillsAndCertificatesDrawerRemoveCertificateMutation, { data, loading, error }] = useEditSkillsAndCertificatesDrawerRemoveCertificateMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *   },
 * });
 */
export function useEditSkillsAndCertificatesDrawerRemoveCertificateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSkillsAndCertificatesDrawerRemoveCertificateMutation, EditSkillsAndCertificatesDrawerRemoveCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSkillsAndCertificatesDrawerRemoveCertificateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSkillsAndCertificatesDrawerRemoveCertificateMutation, EditSkillsAndCertificatesDrawerRemoveCertificateMutationVariables>(EditSkillsAndCertificatesDrawerRemoveCertificateDocument, parser(options)));
      }
export type EditSkillsAndCertificatesDrawerRemoveCertificateMutationHookResult = ReturnType<typeof useEditSkillsAndCertificatesDrawerRemoveCertificateMutation>;
export type EditSkillsAndCertificatesDrawerRemoveCertificateMutationResult = ApolloReact.MutationResult<EditSkillsAndCertificatesDrawerRemoveCertificateMutation>;
export type EditSkillsAndCertificatesDrawerRemoveCertificateMutationOptions = Apollo.MutationOptions<EditSkillsAndCertificatesDrawerRemoveCertificateMutation, EditSkillsAndCertificatesDrawerRemoveCertificateMutationVariables>;
export const EditSocialMediaHandlesDrawerInputDocument = /*#__PURE__*/ gql`
    query EditSocialMediaHandlesDrawer_Input {
  profile {
    ...NfsError
    ... on User {
      id
      socialMediaHandles {
        platform
        handle
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useEditSocialMediaHandlesDrawerInputQuery__
 *
 * To run a query within a React component, call `useEditSocialMediaHandlesDrawerInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSocialMediaHandlesDrawerInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSocialMediaHandlesDrawerInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditSocialMediaHandlesDrawerInputQuery(baseOptions?: ApolloReact.QueryHookOptions<EditSocialMediaHandlesDrawerInputQuery, EditSocialMediaHandlesDrawerInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSocialMediaHandlesDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<EditSocialMediaHandlesDrawerInputQuery, EditSocialMediaHandlesDrawerInputQueryVariables>(EditSocialMediaHandlesDrawerInputDocument, parser(options)));
      }
export function useEditSocialMediaHandlesDrawerInputLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<EditSocialMediaHandlesDrawerInputQuery, EditSocialMediaHandlesDrawerInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(EditSocialMediaHandlesDrawerInputDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<EditSocialMediaHandlesDrawerInputQuery, EditSocialMediaHandlesDrawerInputQueryVariables>(EditSocialMediaHandlesDrawerInputDocument, options));
        }

export type EditSocialMediaHandlesDrawerInputQueryResult = ApolloReact.QueryResult<EditSocialMediaHandlesDrawerInputQuery, EditSocialMediaHandlesDrawerInputQueryVariables>;
export function refetchEditSocialMediaHandlesDrawerInputQuery(variables?: EditSocialMediaHandlesDrawerInputQueryVariables) {
      return { query: EditSocialMediaHandlesDrawerInputDocument, variables: variables }
    }
export const EditSocialMediaHandlesDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation EditSocialMediaHandlesDrawer_Update($socialMediaHandles: [SocialMediaHandleInput!]) {
  updateProfile(socialMediaHandles: $socialMediaHandles) {
    ...NfsError
    ... on User {
      id
      socialMediaHandles {
        platform
        handle
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useEditSocialMediaHandlesDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useEditSocialMediaHandlesDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSocialMediaHandlesDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSocialMediaHandlesDrawerUpdateMutation, { data, loading, error }] = useEditSocialMediaHandlesDrawerUpdateMutation({
 *   variables: {
 *      socialMediaHandles: // value for 'socialMediaHandles'
 *   },
 * });
 */
export function useEditSocialMediaHandlesDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<EditSocialMediaHandlesDrawerUpdateMutation, EditSocialMediaHandlesDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(EditSocialMediaHandlesDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<EditSocialMediaHandlesDrawerUpdateMutation, EditSocialMediaHandlesDrawerUpdateMutationVariables>(EditSocialMediaHandlesDrawerUpdateDocument, parser(options)));
      }
export type EditSocialMediaHandlesDrawerUpdateMutationHookResult = ReturnType<typeof useEditSocialMediaHandlesDrawerUpdateMutation>;
export type EditSocialMediaHandlesDrawerUpdateMutationResult = ApolloReact.MutationResult<EditSocialMediaHandlesDrawerUpdateMutation>;
export type EditSocialMediaHandlesDrawerUpdateMutationOptions = Apollo.MutationOptions<EditSocialMediaHandlesDrawerUpdateMutation, EditSocialMediaHandlesDrawerUpdateMutationVariables>;
export const SecureRoutesWrapperContractsDocument = /*#__PURE__*/ gql`
    query SecureRoutesWrapper_Contracts {
  profile {
    ...NfsError
    ... on User {
      id
      contracts {
        id
        name
        createdAt
        startDate
        expectedEndDate
        terminationDate
        conclusionDate
        status
        promisor {
          name
          countryOfRegistration
          logo
        }
        ... on EmploymentContract {
          type
          currency {
            value
          }
        }
        ... on B2BContract {
          promiseeCompany {
            countryOfRegistration
          }
          currency {
            value
          }
          vat {
            value {
              ...VatType
            }
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${VatTypeFragmentDoc}`;

/**
 * __useSecureRoutesWrapperContractsQuery__
 *
 * To run a query within a React component, call `useSecureRoutesWrapperContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureRoutesWrapperContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureRoutesWrapperContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecureRoutesWrapperContractsQuery(baseOptions?: ApolloReact.QueryHookOptions<SecureRoutesWrapperContractsQuery, SecureRoutesWrapperContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(SecureRoutesWrapperContractsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<SecureRoutesWrapperContractsQuery, SecureRoutesWrapperContractsQueryVariables>(SecureRoutesWrapperContractsDocument, parser(options)));
      }
export function useSecureRoutesWrapperContractsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<SecureRoutesWrapperContractsQuery, SecureRoutesWrapperContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(SecureRoutesWrapperContractsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<SecureRoutesWrapperContractsQuery, SecureRoutesWrapperContractsQueryVariables>(SecureRoutesWrapperContractsDocument, options));
        }

export type SecureRoutesWrapperContractsQueryResult = ApolloReact.QueryResult<SecureRoutesWrapperContractsQuery, SecureRoutesWrapperContractsQueryVariables>;
export function refetchSecureRoutesWrapperContractsQuery(variables?: SecureRoutesWrapperContractsQueryVariables) {
      return { query: SecureRoutesWrapperContractsDocument, variables: variables }
    }
export const TimeReportPreferencesDrawerUpdateDocument = /*#__PURE__*/ gql`
    mutation TimeReportPreferencesDrawer_Update($contractId: ContractId!, $workTagId: ClearableWorkTagIdInput, $projectId: ClearablePreselectedProjectIdInput, $fromTime: ClearableLocalTimeInput, $toTime: ClearableLocalTimeInput, $isRemoteWork: Boolean) {
  reporting {
    setPreselectedFields(
      contractId: $contractId
      workTagId: $workTagId
      projectId: $projectId
      fromTime: $fromTime
      toTime: $toTime
      isRemoteWork: $isRemoteWork
    ) {
      ...NfsError
      ... on ContractResponse {
        value {
          id
          preselectedWorkTag {
            id
          }
          preselectedProject {
            value {
              id
            }
          }
          preselectedFromTime
          preselectedToTime
          ... on EmploymentContract {
            preselectedIsRemoteWork
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useTimeReportPreferencesDrawerUpdateMutation__
 *
 * To run a mutation, you first call `useTimeReportPreferencesDrawerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReportPreferencesDrawerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReportPreferencesDrawerUpdateMutation, { data, loading, error }] = useTimeReportPreferencesDrawerUpdateMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      workTagId: // value for 'workTagId'
 *      projectId: // value for 'projectId'
 *      fromTime: // value for 'fromTime'
 *      toTime: // value for 'toTime'
 *      isRemoteWork: // value for 'isRemoteWork'
 *   },
 * });
 */
export function useTimeReportPreferencesDrawerUpdateMutation(baseOptions?: ApolloReact.MutationHookOptions<TimeReportPreferencesDrawerUpdateMutation, TimeReportPreferencesDrawerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportPreferencesDrawerUpdateDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<TimeReportPreferencesDrawerUpdateMutation, TimeReportPreferencesDrawerUpdateMutationVariables>(TimeReportPreferencesDrawerUpdateDocument, parser(options)));
      }
export type TimeReportPreferencesDrawerUpdateMutationHookResult = ReturnType<typeof useTimeReportPreferencesDrawerUpdateMutation>;
export type TimeReportPreferencesDrawerUpdateMutationResult = ApolloReact.MutationResult<TimeReportPreferencesDrawerUpdateMutation>;
export type TimeReportPreferencesDrawerUpdateMutationOptions = Apollo.MutationOptions<TimeReportPreferencesDrawerUpdateMutation, TimeReportPreferencesDrawerUpdateMutationVariables>;
export const AbsencesDocument = /*#__PURE__*/ gql`
    query Absences($projectId_in: [ProjectId!], $from: YearMonth!, $to: YearMonth!) {
  projectsTimeReports(projectId_in: $projectId_in) {
    ...NfsError
    ... on ListOfProjectTimeReportsResponse {
      value {
        membersTimeReports {
          person {
            firstName
            lastName
            avatar
            email
          }
          holidayCalendar {
            id
          }
          absenceRecords(from: $from, to: $to) {
            from
            to
          }
        }
      }
    }
  }
  holidayCalendars {
    id
    calendarDays {
      date
      dayType
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAbsencesQuery__
 *
 * To run a query within a React component, call `useAbsencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesQuery({
 *   variables: {
 *      projectId_in: // value for 'projectId_in'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAbsencesQuery(baseOptions: ApolloReact.QueryHookOptions<AbsencesQuery, AbsencesQueryVariables> & ({ variables: AbsencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AbsencesDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AbsencesQuery, AbsencesQueryVariables>(AbsencesDocument, parser(options)));
      }
export function useAbsencesLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AbsencesQuery, AbsencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AbsencesDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AbsencesQuery, AbsencesQueryVariables>(AbsencesDocument, options));
        }

export type AbsencesQueryResult = ApolloReact.QueryResult<AbsencesQuery, AbsencesQueryVariables>;
export function refetchAbsencesQuery(variables: AbsencesQueryVariables) {
      return { query: AbsencesDocument, variables: variables }
    }
export const AbsencesInfoDocument = /*#__PURE__*/ gql`
    query Absences_Info {
  absenceTypeDetails {
    key
    value {
      canBeReportedOnHoliday
      applicableFor
      canTakeCustomNumberOfHours
      limit
    }
  }
  profile {
    ...NfsError
    ... on User {
      id
      directReporting {
        assignedProjects(status_oneOf: [Live], orderByFirstPositionStartDate: Desc) {
          project {
            id
            name
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useAbsencesInfoQuery__
 *
 * To run a query within a React component, call `useAbsencesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsencesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsencesInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAbsencesInfoQuery(baseOptions?: ApolloReact.QueryHookOptions<AbsencesInfoQuery, AbsencesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(AbsencesInfoDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<AbsencesInfoQuery, AbsencesInfoQueryVariables>(AbsencesInfoDocument, parser(options)));
      }
export function useAbsencesInfoLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<AbsencesInfoQuery, AbsencesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(AbsencesInfoDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<AbsencesInfoQuery, AbsencesInfoQueryVariables>(AbsencesInfoDocument, options));
        }

export type AbsencesInfoQueryResult = ApolloReact.QueryResult<AbsencesInfoQuery, AbsencesInfoQueryVariables>;
export function refetchAbsencesInfoQuery(variables?: AbsencesInfoQueryVariables) {
      return { query: AbsencesInfoDocument, variables: variables }
    }
export const DirectReportingAssignedProjectsDocument = /*#__PURE__*/ gql`
    query DirectReporting_AssignedProjects {
  profile {
    ...NfsError
    ... on User {
      id
      directReporting {
        directSubordinates {
          firstName
          lastName
          email
          avatar
          role
        }
        assignedProjects {
          project {
            id
            name
            lead {
              firstName
              lastName
              email
              avatar
              role
            }
          }
          periods {
            from
            to
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useDirectReportingAssignedProjectsQuery__
 *
 * To run a query within a React component, call `useDirectReportingAssignedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectReportingAssignedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectReportingAssignedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDirectReportingAssignedProjectsQuery(baseOptions?: ApolloReact.QueryHookOptions<DirectReportingAssignedProjectsQuery, DirectReportingAssignedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DirectReportingAssignedProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DirectReportingAssignedProjectsQuery, DirectReportingAssignedProjectsQueryVariables>(DirectReportingAssignedProjectsDocument, parser(options)));
      }
export function useDirectReportingAssignedProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DirectReportingAssignedProjectsQuery, DirectReportingAssignedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DirectReportingAssignedProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DirectReportingAssignedProjectsQuery, DirectReportingAssignedProjectsQueryVariables>(DirectReportingAssignedProjectsDocument, options));
        }

export type DirectReportingAssignedProjectsQueryResult = ApolloReact.QueryResult<DirectReportingAssignedProjectsQuery, DirectReportingAssignedProjectsQueryVariables>;
export function refetchDirectReportingAssignedProjectsQuery(variables?: DirectReportingAssignedProjectsQueryVariables) {
      return { query: DirectReportingAssignedProjectsDocument, variables: variables }
    }
export const MyProfileDocument = /*#__PURE__*/ gql`
    query MyProfile {
  profile {
    ...NfsError
    ... on User {
      id
      firstName
      middleName
      lastName
      email
      contactEmail
      phoneNumber
      skillsAndCompetences
      declaredNoCertificates
      certificates {
        id
        name
        issueDate
        expirationDate
        file {
          fileName
          url
        }
      }
      areaOfExpertise
      pesel
      citizenship
      birthDate
      idType
      idNumber
      isStudent
      isStudentRevisionDate
      nextMedicalExaminationDate
      nextOhsTrainingDate
      passportExpirationDate
      revenueAdministrationOffice {
        id
        officeName
      }
      address {
        ...Address
      }
      mailingAddress {
        ...Address
      }
      paczkomat
      plateNumber
      emergencyContact
      office {
        officeId
        name
      }
      consentedForUseOfImage
      personalDataProcessingAuthorization
      socialMediaHandles {
        platform
        handle
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions?: ApolloReact.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(MyProfileDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, parser(options)));
      }
export function useMyProfileLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(MyProfileDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options));
        }

export type MyProfileQueryResult = ApolloReact.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export function refetchMyProfileQuery(variables?: MyProfileQueryVariables) {
      return { query: MyProfileDocument, variables: variables }
    }
export const OfficeDocument = /*#__PURE__*/ gql`
    query Office {
  reservableOffices {
    ...NfsError
    ... on ListOfReservableOfficeResponse {
      value {
        office {
          officeId
          name
          validFrom
          validTo
          blocked
        }
        floorMap {
          fileName
          downloadUrl
        }
        parkingMap {
          fileName
          downloadUrl
        }
        rooms {
          id
          name
          desks {
            id
            name
            monitors
            standing
          }
        }
        parkingSpots {
          id
          number
          name
          guest
        }
      }
    }
  }
  officeReservationLimits {
    ...NfsError
    ... on OfficeReservationSettings {
      deskMaxAdvanceDays
      deskMaxDays
      parkingMaxAdvanceDays
      parkingMaxDays
    }
  }
  profile {
    ...NfsError
    ... on User {
      id
      office {
        officeId
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useOfficeQuery__
 *
 * To run a query within a React component, call `useOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfficeQuery(baseOptions?: ApolloReact.QueryHookOptions<OfficeQuery, OfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeQuery, OfficeQueryVariables>(OfficeDocument, parser(options)));
      }
export function useOfficeLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeQuery, OfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeQuery, OfficeQueryVariables>(OfficeDocument, options));
        }

export type OfficeQueryResult = ApolloReact.QueryResult<OfficeQuery, OfficeQueryVariables>;
export function refetchOfficeQuery(variables?: OfficeQueryVariables) {
      return { query: OfficeDocument, variables: variables }
    }
export const OfficeAvailabilityDocument = /*#__PURE__*/ gql`
    query Office_Availability($officeId: OfficeId!, $from: LocalDate!, $to: LocalDate!) {
  officeAvailability(officeId: $officeId, range: {from: $from, to: $to}) {
    ...NfsError
    ... on OfficeAvailability {
      desks {
        resourceId
        takenDates
      }
      parkingSpots {
        resourceId
        takenDates
      }
    }
  }
  myOfficeReservations(from: $from, to: $to) {
    ...NfsError
    ... on ListOfReservationRequestResponse {
      value {
        ...OfficeReservation
      }
    }
  }
  myDeskAssignments {
    ...NfsError
    ... on ListOfDeskAssignmentResponse {
      value {
        ...OfficeDeskAssignment
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${OfficeReservationFragmentDoc}
${OfficeDeskAssignmentFragmentDoc}`;

/**
 * __useOfficeAvailabilityQuery__
 *
 * To run a query within a React component, call `useOfficeAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeAvailabilityQuery({
 *   variables: {
 *      officeId: // value for 'officeId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useOfficeAvailabilityQuery(baseOptions: ApolloReact.QueryHookOptions<OfficeAvailabilityQuery, OfficeAvailabilityQueryVariables> & ({ variables: OfficeAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeAvailabilityDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<OfficeAvailabilityQuery, OfficeAvailabilityQueryVariables>(OfficeAvailabilityDocument, parser(options)));
      }
export function useOfficeAvailabilityLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<OfficeAvailabilityQuery, OfficeAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(OfficeAvailabilityDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<OfficeAvailabilityQuery, OfficeAvailabilityQueryVariables>(OfficeAvailabilityDocument, options));
        }

export type OfficeAvailabilityQueryResult = ApolloReact.QueryResult<OfficeAvailabilityQuery, OfficeAvailabilityQueryVariables>;
export function refetchOfficeAvailabilityQuery(variables: OfficeAvailabilityQueryVariables) {
      return { query: OfficeAvailabilityDocument, variables: variables }
    }
export const OfficeCancelDocument = /*#__PURE__*/ gql`
    mutation Office_Cancel($requestId: ReservationRequestId!) {
  officeReservations {
    cancelOfficeReservation(requestId: $requestId) {
      ...NfsError
      ... on ReservationRequest {
        requestId
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;


/**
 * __useOfficeCancelMutation__
 *
 * To run a mutation, you first call `useOfficeCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfficeCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [officeCancelMutation, { data, loading, error }] = useOfficeCancelMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useOfficeCancelMutation(baseOptions?: ApolloReact.MutationHookOptions<OfficeCancelMutation, OfficeCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(OfficeCancelDocument, scalarPaths, scalarParsers), []);

    return useMutationVariables(parser, ApolloReact.useMutation<OfficeCancelMutation, OfficeCancelMutationVariables>(OfficeCancelDocument, parser(options)));
      }
export type OfficeCancelMutationHookResult = ReturnType<typeof useOfficeCancelMutation>;
export type OfficeCancelMutationResult = ApolloReact.MutationResult<OfficeCancelMutation>;
export type OfficeCancelMutationOptions = Apollo.MutationOptions<OfficeCancelMutation, OfficeCancelMutationVariables>;
export const ProgressionDocument = /*#__PURE__*/ gql`
    query Progression($contractId: ContractId!) {
  contract(contractId: $contractId) {
    ...NfsError
    ... on ContractResponse {
      value {
        ...Progression_Contract
      }
    }
  }
  profile {
    ...NfsError
    ... on User {
      ...Progression_User
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionContractFragmentDoc}
${ProgressionUserFragmentDoc}`;

/**
 * __useProgressionQuery__
 *
 * To run a query within a React component, call `useProgressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressionQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useProgressionQuery(baseOptions: ApolloReact.QueryHookOptions<ProgressionQuery, ProgressionQueryVariables> & ({ variables: ProgressionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProgressionQuery, ProgressionQueryVariables>(ProgressionDocument, parser(options)));
      }
export function useProgressionLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProgressionQuery, ProgressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProgressionDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProgressionQuery, ProgressionQueryVariables>(ProgressionDocument, options));
        }

export type ProgressionQueryResult = ApolloReact.QueryResult<ProgressionQuery, ProgressionQueryVariables>;
export function refetchProgressionQuery(variables: ProgressionQueryVariables) {
      return { query: ProgressionDocument, variables: variables }
    }
export const ProgressionMergedDocument = /*#__PURE__*/ gql`
    query ProgressionMerged {
  profile {
    ...NfsError
    ... on User {
      ...Progression_User
      contracts {
        ...Progression_Contract
      }
    }
  }
}
    ${NfsErrorFragmentDoc}
${ProgressionUserFragmentDoc}
${ProgressionContractFragmentDoc}`;

/**
 * __useProgressionMergedQuery__
 *
 * To run a query within a React component, call `useProgressionMergedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressionMergedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressionMergedQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgressionMergedQuery(baseOptions?: ApolloReact.QueryHookOptions<ProgressionMergedQuery, ProgressionMergedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProgressionMergedDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProgressionMergedQuery, ProgressionMergedQueryVariables>(ProgressionMergedDocument, parser(options)));
      }
export function useProgressionMergedLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProgressionMergedQuery, ProgressionMergedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProgressionMergedDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProgressionMergedQuery, ProgressionMergedQueryVariables>(ProgressionMergedDocument, options));
        }

export type ProgressionMergedQueryResult = ApolloReact.QueryResult<ProgressionMergedQuery, ProgressionMergedQueryVariables>;
export function refetchProgressionMergedQuery(variables?: ProgressionMergedQueryVariables) {
      return { query: ProgressionMergedDocument, variables: variables }
    }
export const ProjectsAssignedProjectsDocument = /*#__PURE__*/ gql`
    query Projects_AssignedProjects {
  profile {
    ...NfsError
    ... on User {
      id
      directReporting {
        directSubordinates {
          firstName
          lastName
          email
          avatar
          role
        }
        assignedProjects(orderByFirstPositionStartDate: Desc) {
          project {
            id
            name
            lead {
              firstName
              lastName
              email
              avatar
              role
            }
          }
          periods {
            from
            to
          }
        }
      }
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useProjectsAssignedProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsAssignedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsAssignedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsAssignedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsAssignedProjectsQuery(baseOptions?: ApolloReact.QueryHookOptions<ProjectsAssignedProjectsQuery, ProjectsAssignedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(ProjectsAssignedProjectsDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<ProjectsAssignedProjectsQuery, ProjectsAssignedProjectsQueryVariables>(ProjectsAssignedProjectsDocument, parser(options)));
      }
export function useProjectsAssignedProjectsLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<ProjectsAssignedProjectsQuery, ProjectsAssignedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(ProjectsAssignedProjectsDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<ProjectsAssignedProjectsQuery, ProjectsAssignedProjectsQueryVariables>(ProjectsAssignedProjectsDocument, options));
        }

export type ProjectsAssignedProjectsQueryResult = ApolloReact.QueryResult<ProjectsAssignedProjectsQuery, ProjectsAssignedProjectsQueryVariables>;
export function refetchProjectsAssignedProjectsQuery(variables?: ProjectsAssignedProjectsQueryVariables) {
      return { query: ProjectsAssignedProjectsDocument, variables: variables }
    }
export const TimeReportFileDocument = /*#__PURE__*/ gql`
    query TimeReport_File($yearMonth: YearMonth!, $contractId: ContractId!) {
  timeReportFile(yearMonth: $yearMonth, contractId: $contractId) {
    ...NfsError
    ... on DownloadableFileUrl {
      url
      fileName
    }
  }
}
    ${NfsErrorFragmentDoc}`;

/**
 * __useTimeReportFileQuery__
 *
 * To run a query within a React component, call `useTimeReportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportFileQuery({
 *   variables: {
 *      yearMonth: // value for 'yearMonth'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useTimeReportFileQuery(baseOptions: ApolloReact.QueryHookOptions<TimeReportFileQuery, TimeReportFileQueryVariables> & ({ variables: TimeReportFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TimeReportFileDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TimeReportFileQuery, TimeReportFileQueryVariables>(TimeReportFileDocument, parser(options)));
      }
export function useTimeReportFileLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TimeReportFileQuery, TimeReportFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TimeReportFileDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TimeReportFileQuery, TimeReportFileQueryVariables>(TimeReportFileDocument, options));
        }

export type TimeReportFileQueryResult = ApolloReact.QueryResult<TimeReportFileQuery, TimeReportFileQueryVariables>;
export function refetchTimeReportFileQuery(variables: TimeReportFileQueryVariables) {
      return { query: TimeReportFileDocument, variables: variables }
    }
export const DrawerDocument = /*#__PURE__*/ gql`
    query Drawer($id: ID!) {
  drawer(id: $id) @client {
    ...ChildLevel0
  }
}
    ${ChildLevel0FragmentDoc}`;

/**
 * __useDrawerQuery__
 *
 * To run a query within a React component, call `useDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDrawerQuery(baseOptions: ApolloReact.QueryHookOptions<DrawerQuery, DrawerQueryVariables> & ({ variables: DrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(DrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<DrawerQuery, DrawerQueryVariables>(DrawerDocument, parser(options)));
      }
export function useDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<DrawerQuery, DrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(DrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<DrawerQuery, DrawerQueryVariables>(DrawerDocument, options));
        }

export type DrawerQueryResult = ApolloReact.QueryResult<DrawerQuery, DrawerQueryVariables>;
export function refetchDrawerQuery(variables: DrawerQueryVariables) {
      return { query: DrawerDocument, variables: variables }
    }
export const RootDrawerDocument = /*#__PURE__*/ gql`
    query RootDrawer {
  rootDrawer @client {
    ...ChildLevel0
  }
}
    ${ChildLevel0FragmentDoc}`;

/**
 * __useRootDrawerQuery__
 *
 * To run a query within a React component, call `useRootDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useRootDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<RootDrawerQuery, RootDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(RootDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<RootDrawerQuery, RootDrawerQueryVariables>(RootDrawerDocument, parser(options)));
      }
export function useRootDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<RootDrawerQuery, RootDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(RootDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<RootDrawerQuery, RootDrawerQueryVariables>(RootDrawerDocument, options));
        }

export type RootDrawerQueryResult = ApolloReact.QueryResult<RootDrawerQuery, RootDrawerQueryVariables>;
export function refetchRootDrawerQuery(variables?: RootDrawerQueryVariables) {
      return { query: RootDrawerDocument, variables: variables }
    }
export const TopDrawerDocument = /*#__PURE__*/ gql`
    query TopDrawer {
  topDrawer @client {
    ...ChildLevel0
  }
}
    ${ChildLevel0FragmentDoc}`;

/**
 * __useTopDrawerQuery__
 *
 * To run a query within a React component, call `useTopDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopDrawerQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopDrawerQuery(baseOptions?: ApolloReact.QueryHookOptions<TopDrawerQuery, TopDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        
    const parser = useMemo(() => parseVariables(TopDrawerDocument, scalarPaths, scalarParsers), []);

    return useQueryVariables(parser, ApolloReact.useQuery<TopDrawerQuery, TopDrawerQueryVariables>(TopDrawerDocument, parser(options)));
      }
export function useTopDrawerLazyQuery(baseOptions?: ApolloReact.LazyQueryHookOptions<TopDrawerQuery, TopDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          
    const parser = useMemo(() => parseVariables(TopDrawerDocument, scalarPaths, scalarParsers), []);

    return useLazyQueryVariables(parser, ApolloReact.useLazyQuery<TopDrawerQuery, TopDrawerQueryVariables>(TopDrawerDocument, options));
        }

export type TopDrawerQueryResult = ApolloReact.QueryResult<TopDrawerQuery, TopDrawerQueryVariables>;
export function refetchTopDrawerQuery(variables?: TopDrawerQueryVariables) {
      return { query: TopDrawerDocument, variables: variables }
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AbsenceRecordId: { input: string; output: string; }
  ActivityId: { input: string; output: string; }
  AdminId: { input: string; output: string; }
  AlternativeBenefitsGroupId: { input: string; output: string; }
  AssignedVariantId: { input: string; output: string; }
  /** 1/100 of a Percent; e.g. 2300 BasisPoint is 23% */
  BasisPoint: { input: number; output: number; }
  BenefitId: { input: string; output: string; }
  BenefitVariantId: { input: string; output: string; }
  BenefitVariantProductId: { input: string; output: string; }
  BonusId: { input: string; output: string; }
  Cents: { input: number; output: number; }
  CertificateId: { input: string; output: string; }
  ClientPositionId: { input: string; output: string; }
  CompanyId: { input: string; output: string; }
  ContractId: { input: string; output: string; }
  /** Country code consisting of 2 uppercase letters; e.g. PL/US/UK */
  CountryCode: { input: string; output: string; }
  /** Currency code consisting of 3 uppercase letters; e.g. PLN/USD/EUR */
  Currency: { input: string; output: string; }
  Cursor: { input: string; output: string; }
  Days: { input: number; output: number; }
  DeskAssignmentId: { input: string; output: string; }
  DeskId: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  EntityVersion: { input: number; output: number; }
  ExternalBeneficiaryId: { input: string; output: string; }
  Hours: { input: any; output: any; }
  InvoiceDetailsId: { input: string; output: string; }
  InvoiceNumber: { input: string; output: string; }
  /** A date without a time-zone in the ISO-8601 calendar system using the format 1970-01-01 */
  LocalDate: { input: Date; output: Date; }
  /** A time without a time-zone in the ISO-8601 calendar system using the format 00:00:00 */
  LocalTime: { input: Date; output: Date; }
  Minutes: { input: number; output: number; }
  NfsErrorId: { input: string; output: string; }
  OfficeId: { input: string; output: string; }
  /** A date-time with an offset from UTC/Greenwich in the ISO-8601 calendar system using the format 1970-01-01T00:00:00Z */
  OffsetDateTime: { input: Date; output: Date; }
  OnCallRecordId: { input: string; output: string; }
  PESEL: { input: string; output: string; }
  ParkingSpotId: { input: string; output: string; }
  PhoneNumber: { input: string; output: string; }
  ProjectId: { input: string; output: string; }
  ReservationRequestId: { input: string; output: string; }
  RevenueAdministrationOfficeId: { input: number; output: number; }
  RoomId: { input: string; output: string; }
  SpaceId: { input: string; output: string; }
  URI: { input: string; output: string; }
  Unit: { input: Record<never, never>; output: Record<never, never>; }
  Upload: { input: FileList[number]; output: FileList[number]; }
  UserId: { input: string; output: string; }
  WorkDays: { input: number; output: number; }
  WorkHours: { input: number; output: number; }
  WorkRecordId: { input: string; output: string; }
  WorkTagId: { input: string; output: string; }
  WorkTransferProtocolId: { input: string; output: string; }
  Year: { input: number; output: number; }
  /** ISO-8601 date with only year and month */
  YearMonth: { input: Date; output: Date; }
};

export type AbsenceRecord = {
  readonly __typename?: 'AbsenceRecord';
  readonly absenceType: AbsenceType;
  readonly approval: Approval;
  readonly attachment?: Maybe<DownloadableFileUrl>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly customDurationPerDay?: Maybe<Scalars['Minutes']['output']>;
  readonly from: Scalars['LocalDate']['output'];
  readonly id: Scalars['AbsenceRecordId']['output'];
  readonly isOnDemand?: Maybe<Scalars['Boolean']['output']>;
  readonly to: Scalars['LocalDate']['output'];
};

export type AbsenceRecordApi = {
  readonly __typename?: 'AbsenceRecordApi';
  readonly create: AbsenceRecordOrNfsError;
  readonly createMany: ListOfAbsenceRecordResponseOrNfsError;
  readonly update: AbsenceRecordOrNfsError;
};


export type AbsenceRecordApiCreateArgs = {
  absenceRecord: CreateAbsenceRecordInput;
  attachment?: InputMaybe<Scalars['Upload']['input']>;
};


export type AbsenceRecordApiCreateManyArgs = {
  value: ReadonlyArray<CreateAbsenceRecordInput>;
};


export type AbsenceRecordApiUpdateArgs = {
  absenceType?: InputMaybe<AbsenceTypeInput>;
  attachment?: InputMaybe<ClearableUploadInput>;
  comment?: InputMaybe<ClearableStringInput>;
  customDurationPerDay?: InputMaybe<ClearableMinutesInput>;
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['AbsenceRecordId']['input'];
  isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AbsenceRecordOrNfsError = AbsenceRecord | NfsError;

export const AbsenceType = {
  ANNUALLEAVE: 'AnnualLeave',
  CAREGIVINGLEAVE: 'CaregivingLeave',
  CHILDCARELEAVE: 'ChildCareLeave',
  DUETOFORCEMAJEURELEAVE: 'DueToForceMajeureLeave',
  FLEXTIMELEAVE: 'FlextimeLeave',
  MATERNITYLEAVE: 'MaternityLeave',
  OUTOFOFFICE: 'OutOfOffice',
  PAIDLEAVE: 'PaidLeave',
  PARENTALLEAVE: 'ParentalLeave',
  PATERNITYLEAVE: 'PaternityLeave',
  SICKFAMILYMEMBERCARELEAVE: 'SickFamilyMemberCareLeave',
  SICKLEAVE: 'SickLeave',
  SPECIALLEAVE: 'SpecialLeave',
  UNPAIDLEAVE: 'UnpaidLeave'
} as const;

export type AbsenceType = typeof AbsenceType[keyof typeof AbsenceType];
export type AbsenceTypeDetails = {
  readonly __typename?: 'AbsenceTypeDetails';
  readonly applicableFor: ReadonlyArray<ContractType>;
  readonly canBeReportedOnHoliday: Scalars['Boolean']['output'];
  readonly canTakeCustomNumberOfHours: Scalars['Boolean']['output'];
  readonly limit?: Maybe<Scalars['WorkDays']['output']>;
};

export const AbsenceTypeInput = {
  ANNUALLEAVE: 'AnnualLeave',
  CAREGIVINGLEAVE: 'CaregivingLeave',
  CHILDCARELEAVE: 'ChildCareLeave',
  DUETOFORCEMAJEURELEAVE: 'DueToForceMajeureLeave',
  FLEXTIMELEAVE: 'FlextimeLeave',
  OUTOFOFFICE: 'OutOfOffice',
  PAIDLEAVE: 'PaidLeave',
  SICKFAMILYMEMBERCARELEAVE: 'SickFamilyMemberCareLeave',
  SICKLEAVE: 'SickLeave',
  SPECIALLEAVE: 'SpecialLeave',
  UNPAIDLEAVE: 'UnpaidLeave'
} as const;

export type AbsenceTypeInput = typeof AbsenceTypeInput[keyof typeof AbsenceTypeInput];
export type AbstractDrawer = {
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type AccountingData = {
  readonly __typename?: 'AccountingData';
  readonly maternityLeaveAllowance?: Maybe<Scalars['Cents']['output']>;
  readonly overtimePayout?: Maybe<Scalars['Cents']['output']>;
  readonly paternityLeaveAllowance?: Maybe<Scalars['Cents']['output']>;
  readonly ppkAmount?: Maybe<Scalars['Cents']['output']>;
  readonly ppkDetails?: Maybe<PpkDetails>;
  readonly sicknessBenefit?: Maybe<Scalars['Cents']['output']>;
  readonly taxPrepayment: Scalars['Cents']['output'];
  readonly taxRefund?: Maybe<Scalars['Cents']['output']>;
  readonly transferAmount: Scalars['Cents']['output'];
  readonly zusContribution: Scalars['Cents']['output'];
  readonly zusContributionDetails?: Maybe<ZusContributionDetails>;
};

export type ActiveReportingRangeError = UserError & {
  readonly __typename?: 'ActiveReportingRangeError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type AdditionalCostsDrawer = AbstractDrawer & {
  readonly __typename?: 'AdditionalCostsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const AdditionalPeopleNumber = {
  FOUR: 'Four',
  MORE: 'More',
  ONE: 'One',
  THREE: 'Three',
  TWO: 'Two'
} as const;

export type AdditionalPeopleNumber = typeof AdditionalPeopleNumber[keyof typeof AdditionalPeopleNumber];
export type Address = {
  readonly __typename?: 'Address';
  readonly city: Scalars['String']['output'];
  readonly country: Scalars['CountryCode']['output'];
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  /** format `street_name building_number[/flat_number]` where street_name = city if street_name empty */
  readonly streetLine: Scalars['String']['output'];
};

export type AddressInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['CountryCode']['input'];
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  readonly region?: InputMaybe<Scalars['String']['input']>;
  /** format `street_name building_number[/flat_number]` where street_name = city if street_name empty */
  readonly streetLine: Scalars['String']['input'];
};

export type Admin = {
  readonly __typename?: 'Admin';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['AdminId']['output'];
  readonly lastName: Scalars['String']['output'];
};

export type AggregatedValidationErrors = UserError & {
  readonly __typename?: 'AggregatedValidationErrors';
  readonly errors: ReadonlyArray<ValidationError>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type AnnualLeaveBalance = {
  readonly __typename?: 'AnnualLeaveBalance';
  readonly available: AnnualLeaveEntitlementValue;
  readonly entitlement: AnnualLeaveEntitlementValue;
  readonly used: AnnualLeaveEntitlementValue;
};

export type AnnualLeaveEntitlement = {
  readonly __typename?: 'AnnualLeaveEntitlement';
  readonly history: ReadonlyArray<AnnualLeaveEntitlementPeriod>;
  readonly withCarryOverToNextYear: Scalars['Boolean']['output'];
};

export type AnnualLeaveEntitlementPeriod = {
  readonly __typename?: 'AnnualLeaveEntitlementPeriod';
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly dateRange: LocalDateRange;
  readonly entitlement: AnnualLeaveEntitlementValue;
  readonly entitlementExplanation: Scalars['String']['output'];
};

export type AnnualLeaveEntitlementValue = {
  readonly __typename?: 'AnnualLeaveEntitlementValue';
  readonly days: Scalars['Days']['output'];
  readonly minutes: Scalars['Minutes']['output'];
};

export type AnnualLeaveSummary = {
  readonly __typename?: 'AnnualLeaveSummary';
  readonly yearlySummary: ReadonlyArray<KvYearAnnualLeaveYearSummary>;
};

export type AnnualLeaveSummaryOrNfsError = AnnualLeaveSummary | NfsError;

export type AnnualLeaveYearSummary = {
  readonly __typename?: 'AnnualLeaveYearSummary';
  readonly balanceThisYear: AnnualLeaveBalance;
  readonly carriedOverEntitlementBalance?: Maybe<AnnualLeaveBalance>;
  readonly onDemandBalance: AnnualLeaveBalance;
  readonly totalBalance: AnnualLeaveBalance;
  readonly year: Scalars['Year']['output'];
};

export type AppreciationBonus = Bonus & {
  readonly __typename?: 'AppreciationBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type Approval = Approved | NotRequired | PendingApproval;

export type Approved = {
  readonly __typename?: 'Approved';
  readonly at: Scalars['OffsetDateTime']['output'];
  readonly by: Admin;
};

export type AssignedProject = {
  readonly __typename?: 'AssignedProject';
  readonly activeReportingRange?: Maybe<ClosedEndLocalDateRange>;
  readonly assignmentPeriods: ReadonlyArray<LocalDateRange>;
  readonly projectId: Scalars['ProjectId']['output'];
  readonly projectLead?: Maybe<Person>;
  readonly projectName: Scalars['String']['output'];
  readonly reportingPeriods: ReadonlyArray<ClosedEndLocalDateRange>;
};

export type AssignedVariant = {
  readonly __typename?: 'AssignedVariant';
  readonly active: TimeBasedBoolean;
  readonly buyerType: TimeBasedBenefitBuyerType;
  readonly externalBeneficiaries: TimeBasedListOfExternalBeneficiary;
  readonly id: Scalars['AssignedVariantId']['output'];
  readonly invoiceTo: TimeBasedOptClearableExternalBeneficiary;
  readonly variant: TimeBasedBenefitVariant;
};

export type B2BContract = Contract & {
  readonly __typename?: 'B2BContract';
  readonly assignedVariants: ReadonlyArray<AssignedVariant>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: Bonuses;
  readonly conclusionDate: Scalars['LocalDate']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency: TimeBasedCurrency;
  readonly enableTrainingPackage: Scalars['Boolean']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly onCall: TimeBasedOptClearableOnCallRate;
  readonly overtimeRate: TimeBasedOptClearableNetGross;
  readonly position: TimeBasedOptClearableString;
  readonly preselectedFromTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedProject?: Maybe<PreselectedProject>;
  readonly preselectedToTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedWorkTag?: Maybe<WorkTag>;
  readonly promiseeCompany: Company;
  readonly promisor: Company;
  readonly rate: TimeBasedRate;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly vat: TimeBasedVatType;
  readonly workingTime: TimeBasedWorkingTime;
};


export type B2BContractAssignedVariantsArgs = {
  activeOnly: Scalars['Boolean']['input'];
};

export type B2BContractSalaryDetails = ContractSalaryDetails & {
  readonly __typename?: 'B2BContractSalaryDetails';
  readonly contractId: Scalars['ContractId']['output'];
  readonly invoiceDetails: ReadonlyArray<InvoiceDetails>;
  readonly isTimeReportApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportCompleted: Scalars['Boolean']['output'];
  readonly luminisServicesValue?: Maybe<NetGross>;
  readonly salaryState: SalaryState;
  readonly totalPayout?: Maybe<NetGross>;
  readonly transferAmount?: Maybe<Scalars['Cents']['output']>;
  readonly transferDeduction?: Maybe<TransferDeduction>;
  readonly yearMonth: Scalars['YearMonth']['output'];
};

/** payout = gross value with following components: hourly rate * hours + overtime + on calls + bonuses + cost of refunded benefits */
export type B2BTimeReportStats = TimeReportStats & {
  readonly __typename?: 'B2BTimeReportStats';
  readonly currentTimeBalance: TimeBalance;
  readonly incomeDetails: ReadonlyArray<IncomeDetails>;
  readonly overtime: Scalars['Minutes']['output'];
  readonly reportedDaysOff: Scalars['Days']['output'];
  readonly timeBalanceAtEndOfMonth: TimeBalance;
};

export type Benefit = BenefitCommon & {
  readonly __typename?: 'Benefit';
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly id: Scalars['BenefitId']['output'];
  readonly name: Scalars['String']['output'];
  readonly parent: BenefitGroupType;
  readonly startDate: Scalars['LocalDate']['output'];
};

export type BenefitAdditionalAdults = {
  readonly __typename?: 'BenefitAdditionalAdults';
  readonly adults: AdditionalPeopleNumber;
};

export type BenefitAdditionalFamily = {
  readonly __typename?: 'BenefitAdditionalFamily';
  readonly adults: AdditionalPeopleNumber;
  readonly kids: AdditionalPeopleNumber;
};

export type BenefitAdditionalKids = {
  readonly __typename?: 'BenefitAdditionalKids';
  readonly kids: AdditionalPeopleNumber;
};

export type BenefitAdditionalPeople = BenefitAdditionalAdults | BenefitAdditionalFamily | BenefitAdditionalKids;

export const BenefitBillingPeriod = {
  HOURLY: 'Hourly',
  MONTHLY: 'Monthly'
} as const;

export type BenefitBillingPeriod = typeof BenefitBillingPeriod[keyof typeof BenefitBillingPeriod];
export const BenefitBuyerType = {
  PROMISEE: 'Promisee',
  PROMISOR: 'Promisor',
  THIRDPARTY: 'ThirdParty'
} as const;

export type BenefitBuyerType = typeof BenefitBuyerType[keyof typeof BenefitBuyerType];
export type BenefitCommon = {
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly id: Scalars['BenefitId']['output'];
  readonly name: Scalars['String']['output'];
  readonly startDate: Scalars['LocalDate']['output'];
};

export const BenefitGroupType = {
  HEALTH: 'Health',
  OFFICE: 'Office',
  SPORT: 'Sport'
} as const;

export type BenefitGroupType = typeof BenefitGroupType[keyof typeof BenefitGroupType];
export type BenefitValue = {
  readonly __typename?: 'BenefitValue';
  readonly notRefundedValue?: Maybe<NetGross>;
  readonly refundedValue?: Maybe<NetGross>;
  readonly totalValue: NetGross;
  readonly variant: BenefitVariant;
};

export type BenefitVariant = {
  readonly __typename?: 'BenefitVariant';
  readonly additionalPeople?: Maybe<BenefitAdditionalPeople>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly buyerType: BenefitBuyerType;
  readonly contractTypes: ReadonlyArray<ContractType>;
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly id: Scalars['BenefitVariantId']['output'];
  readonly meansOfProduction: Scalars['Boolean']['output'];
  readonly parent: BenefitCommon;
  readonly productId: Scalars['BenefitVariantProductId']['output'];
  readonly productName: Scalars['String']['output'];
  readonly promiseeRate: TimeBasedOptClearableBenefitVariantRate;
  readonly promisorRate: TimeBasedOptClearableBenefitVariantRate;
  readonly startDate: Scalars['LocalDate']['output'];
};

export type BenefitVariantRate = {
  readonly __typename?: 'BenefitVariantRate';
  readonly netGross: NetGross;
  readonly period: BenefitBillingPeriod;
  readonly vat: VatType;
};

export type BenefitsValue = {
  readonly __typename?: 'BenefitsValue';
  readonly all: ReadonlyArray<BenefitValue>;
  readonly meansOfProduction: ReadonlyArray<BenefitValue>;
  readonly notRefunded: ReadonlyArray<BenefitValue>;
  readonly refunded: ReadonlyArray<BenefitValue>;
  readonly refundedHourlyRate: NetGross;
  readonly thirdParty: ReadonlyArray<BenefitValue>;
  readonly totalValueAll: NetGross;
  readonly totalValueMeansOfProduction: NetGross;
  readonly totalValueNotRefunded: NetGross;
  readonly totalValueRefunded: NetGross;
  readonly totalValueThirdParty: NetGross;
};

export type Bonus = {
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

/** requestBonus follows the upsert semantic */
export type BonusApi = {
  readonly __typename?: 'BonusApi';
  readonly bonus: BonusMutation;
  readonly requestBonus: BonusResponseOrNfsError;
};


/** requestBonus follows the upsert semantic */
export type BonusApiBonusArgs = {
  id: Scalars['BonusId']['input'];
};


/** requestBonus follows the upsert semantic */
export type BonusApiRequestBonusArgs = {
  input: BonusInput;
};

export type BonusCategoryAmount = {
  readonly __typename?: 'BonusCategoryAmount';
  readonly amount: NetGross;
  readonly bonusCategory: BonusType;
};

export type BonusInput = {
  readonly businessTravel?: InputMaybe<CreateBusinessTravelBonusInput>;
  readonly conference?: InputMaybe<CreateConferenceBonusInput>;
  readonly costRecharge?: InputMaybe<CreateCostRechargeBonusInput>;
  readonly krolWod?: InputMaybe<CreateKrolWodBonusInput>;
  readonly languageLearning?: InputMaybe<CreateLanguageLearningBonusInput>;
  readonly other?: InputMaybe<CreateOtherBonusInput>;
  readonly remoteWorkEquipment?: InputMaybe<CreateRemoteWorkEquipmentBonusInput>;
};

export type BonusMutation = {
  readonly __typename?: 'BonusMutation';
  readonly delete: UnitResponseOrNfsError;
};

export type BonusResponse = {
  readonly __typename?: 'BonusResponse';
  readonly value: Bonus;
};

export type BonusResponseOrNfsError = BonusResponse | NfsError;

export const BonusRevocationReason = {
  APPROVALREJECTED: 'ApprovalRejected',
  CONTRACTTERMINATED: 'ContractTerminated',
  REFERREDEMPLOYEECONTRACTDURATIONTOOSHORT: 'ReferredEmployeeContractDurationTooShort'
} as const;

export type BonusRevocationReason = typeof BonusRevocationReason[keyof typeof BonusRevocationReason];
export const BonusType = {
  APPRECIATION: 'Appreciation',
  BUSINESSTRAVEL: 'BusinessTravel',
  CLIENTREFERRAL: 'ClientReferral',
  CONFERENCE: 'Conference',
  COSTRECHARGE: 'CostRecharge',
  EMPLOYEEREFERRAL: 'EmployeeReferral',
  LANGUAGELEARNING: 'LanguageLearning',
  OTHER: 'Other',
  REMOTEWORKEQUIPMENT: 'RemoteWorkEquipment',
  SALESCOMMISSIONS: 'SalesCommissions',
  SEVERANCEPAY: 'SeverancePay',
  SHAREHOLDERDIVIDEND: 'ShareholderDividend',
  TRAININGPACKAGE: 'TrainingPackage',
  TRAININGPACKAGEEXTERNALDEDUCTIONVALUE: 'TrainingPackageExternalDeductionValue'
} as const;

export type BonusType = typeof BonusType[keyof typeof BonusType];
export type Bonuses = {
  readonly __typename?: 'Bonuses';
  readonly future: ReadonlyArray<Bonus>;
  readonly paidOut: ReadonlyArray<Bonus>;
};

export type BookDeskDrawer = AbstractDrawer & {
  readonly __typename?: 'BookDeskDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly prefillDeskId?: Maybe<Scalars['DeskId']['output']>;
  readonly prefillFrom?: Maybe<Scalars['LocalDate']['output']>;
  readonly prefillRoomId?: Maybe<Scalars['RoomId']['output']>;
  readonly prefillTo?: Maybe<Scalars['LocalDate']['output']>;
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BookParkingDrawer = AbstractDrawer & {
  readonly __typename?: 'BookParkingDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly prefillFrom?: Maybe<Scalars['LocalDate']['output']>;
  readonly prefillParkingSpotId?: Maybe<Scalars['ParkingSpotId']['output']>;
  readonly prefillTo?: Maybe<Scalars['LocalDate']['output']>;
  readonly requiredOfficeId: Scalars['OfficeId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type BooleanResponse = {
  readonly __typename?: 'BooleanResponse';
  readonly value: Scalars['Boolean']['output'];
};

export type BooleanResponseOrNfsError = BooleanResponse | NfsError;

export type BusinessTravelBonus = Bonus & {
  readonly __typename?: 'BusinessTravelBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type CalendarDay = {
  readonly __typename?: 'CalendarDay';
  readonly date: Scalars['LocalDate']['output'];
  readonly dayType: CalendarDayType;
};

export const CalendarDayType = {
  FREEDAYFOROTHERDAY: 'FreeDayForOtherDay',
  HOLIDAY: 'Holiday'
} as const;

export type CalendarDayType = typeof CalendarDayType[keyof typeof CalendarDayType];
export type CentsBalance = {
  readonly __typename?: 'CentsBalance';
  readonly available: Scalars['Cents']['output'];
  readonly entitlement: Scalars['Cents']['output'];
  readonly used: Scalars['Cents']['output'];
};

export type Certificate = {
  readonly __typename?: 'Certificate';
  readonly expirationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly file?: Maybe<DownloadableFileUrl>;
  readonly id: Scalars['CertificateId']['output'];
  readonly issueDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly name: Scalars['String']['output'];
};

export type CertificateApi = {
  readonly __typename?: 'CertificateApi';
  readonly createCertificate: CertificateOrNfsError;
  readonly removeCertificate: BooleanResponseOrNfsError;
  readonly updateCertificate: CertificateOrNfsError;
};


export type CertificateApiCreateCertificateArgs = {
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['CertificateId']['input'];
  issueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  name: Scalars['String']['input'];
};


export type CertificateApiRemoveCertificateArgs = {
  certificateId: Scalars['CertificateId']['input'];
};


export type CertificateApiUpdateCertificateArgs = {
  certificate: UpdateCertificateInput;
  certificateId: Scalars['CertificateId']['input'];
};

export type CertificateOrNfsError = Certificate | NfsError;

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableAddressInput = {
  readonly value?: InputMaybe<AddressInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBasisPoint = {
  readonly __typename?: 'ClearableBasisPoint';
  readonly value?: Maybe<Scalars['BasisPoint']['output']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableBenefitVariantRate = {
  readonly __typename?: 'ClearableBenefitVariantRate';
  readonly value?: Maybe<BenefitVariantRate>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableEmailAddressInput = {
  readonly value?: InputMaybe<Scalars['EmailAddress']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableExternalBeneficiary = {
  readonly __typename?: 'ClearableExternalBeneficiary';
  readonly value?: Maybe<ExternalBeneficiary>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableInvoiceNumberInput = {
  readonly value?: InputMaybe<Scalars['InvoiceNumber']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableLocalDateInput = {
  readonly value?: InputMaybe<Scalars['LocalDate']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableLocalTimeInput = {
  readonly value?: InputMaybe<Scalars['LocalTime']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableMinutesInput = {
  readonly value?: InputMaybe<Scalars['Minutes']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableNetGross = {
  readonly __typename?: 'ClearableNetGross';
  readonly value?: Maybe<NetGross>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableOnCallRate = {
  readonly __typename?: 'ClearableOnCallRate';
  readonly value?: Maybe<OnCallRate>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearablePerson = {
  readonly __typename?: 'ClearablePerson';
  readonly value?: Maybe<Person>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearablePhoneNumberInput = {
  readonly value?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearablePreselectedProjectIdInput = {
  readonly value?: InputMaybe<PreselectedProjectIdInput>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProgressionLevel = {
  readonly __typename?: 'ClearableProgressionLevel';
  readonly value?: Maybe<ProgressionLevel>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProjectId = {
  readonly __typename?: 'ClearableProjectId';
  readonly value?: Maybe<Scalars['ProjectId']['output']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableProjectIdInput = {
  readonly value?: InputMaybe<Scalars['ProjectId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableString = {
  readonly __typename?: 'ClearableString';
  readonly value?: Maybe<Scalars['String']['output']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableStringInput = {
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableUploadInput = {
  readonly value?: InputMaybe<Scalars['Upload']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableWorkTagIdInput = {
  readonly value?: InputMaybe<Scalars['WorkTagId']['input']>;
};

/**
 * It is commonly used during a partial update.
 * When outer option (`field: Clearable*Input`) is set to `null` (ie. `field: null`), a field in target record is left unchanged.
 * When Clearable is present with `value: null` then a field in target record is cleared.
 * When Clearable is present and has defined value it will be used to update target record field.
 */
export type ClearableWorkTimeInput = {
  readonly value?: InputMaybe<WorkTimeInput>;
};

export type ClientReferralBonus = Bonus & {
  readonly __typename?: 'ClientReferralBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type ClosedEndLocalDateRange = {
  readonly __typename?: 'ClosedEndLocalDateRange';
  readonly from: Scalars['LocalDate']['output'];
  readonly to: Scalars['LocalDate']['output'];
};

export type ClosedEndLocalDateRangeInput = {
  readonly from: Scalars['LocalDate']['input'];
  readonly to: Scalars['LocalDate']['input'];
};

export type ClosedEndLocalDateRangeOrNfsError = ClosedEndLocalDateRange | NfsError;

export type ClosedEndMonthRange = {
  readonly __typename?: 'ClosedEndMonthRange';
  readonly from: Scalars['YearMonth']['output'];
  readonly to: Scalars['YearMonth']['output'];
};

export type Company = {
  readonly __typename?: 'Company';
  readonly countryOfRegistration: Scalars['CountryCode']['output'];
  readonly logo?: Maybe<Scalars['URI']['output']>;
  readonly name: Scalars['String']['output'];
};

export const CompanyRole = {
  CHIEFOFFICER: 'ChiefOfficer',
  DIRECTOR: 'Director',
  HEAD: 'Head',
  LEAD: 'Lead',
  MANAGER: 'Manager',
  PERSONNEL: 'Personnel'
} as const;

export type CompanyRole = typeof CompanyRole[keyof typeof CompanyRole];
export const CompanyType = {
  B2B: 'B2B',
  CAPITALGROUP: 'CapitalGroup',
  CLIENT: 'Client',
  GROUP: 'Group',
  SUPPLIER: 'Supplier'
} as const;

export type CompanyType = typeof CompanyType[keyof typeof CompanyType];
export type ConferenceBonus = Bonus & {
  readonly __typename?: 'ConferenceBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type Contract = {
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: Bonuses;
  readonly conclusionDate: Scalars['LocalDate']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly preselectedFromTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedProject?: Maybe<PreselectedProject>;
  readonly preselectedToTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedWorkTag?: Maybe<WorkTag>;
  readonly promisor: Company;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly workingTime: TimeBasedWorkingTime;
};

export type ContractResponse = {
  readonly __typename?: 'ContractResponse';
  readonly value: Contract;
};

export type ContractResponseOrNfsError = ContractResponse | NfsError;

export type ContractSalaryDetails = {
  readonly contractId: Scalars['ContractId']['output'];
  readonly isTimeReportApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportCompleted: Scalars['Boolean']['output'];
  readonly salaryState: SalaryState;
  readonly totalPayout?: Maybe<NetGross>;
  readonly transferAmount?: Maybe<Scalars['Cents']['output']>;
  readonly transferDeduction?: Maybe<TransferDeduction>;
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export type ContractSalaryDetailsId = {
  readonly __typename?: 'ContractSalaryDetailsId';
  readonly contractId: Scalars['ContractId']['output'];
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export type ContractSalaryDetailsIdInput = {
  readonly contractId: Scalars['ContractId']['input'];
  readonly yearMonth: Scalars['YearMonth']['input'];
};

export type ContractSalaryDetailsResponse = {
  readonly __typename?: 'ContractSalaryDetailsResponse';
  readonly value: ContractSalaryDetails;
};

export type ContractSalaryDetailsResponseOrNfsError = ContractSalaryDetailsResponse | NfsError;

export const ContractStatus = {
  ACTIVE: 'Active',
  CONCLUDED: 'Concluded',
  TERMINATED: 'Terminated'
} as const;

export type ContractStatus = typeof ContractStatus[keyof typeof ContractStatus];
export const ContractType = {
  B2B: 'B2B',
  MANAGEMENT: 'Management',
  SUBCONTRACT: 'Subcontract',
  UZ: 'UZ',
  UOD: 'UoD',
  UOP: 'UoP'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];
export type CopyrightsDrawer = AbstractDrawer & {
  readonly __typename?: 'CopyrightsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type CostRechargeBonus = Bonus & {
  readonly __typename?: 'CostRechargeBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type CreateAbsenceRecordInput = {
  readonly absenceType: AbsenceTypeInput;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly contractId: Scalars['ContractId']['input'];
  readonly customDurationPerDay?: InputMaybe<Scalars['Minutes']['input']>;
  readonly from: Scalars['LocalDate']['input'];
  readonly id: Scalars['AbsenceRecordId']['input'];
  readonly isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  readonly to: Scalars['LocalDate']['input'];
};

export type CreateBusinessTravelBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly contractId: Scalars['ContractId']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConferenceBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly contractId: Scalars['ContractId']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCostRechargeBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly contractId: Scalars['ContractId']['input'];
  readonly description: Scalars['String']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDetailsInput = {
  readonly file?: InputMaybe<Scalars['Upload']['input']>;
  readonly id: Scalars['InvoiceDetailsId']['input'];
  readonly number?: InputMaybe<Scalars['InvoiceNumber']['input']>;
  readonly userNote?: InputMaybe<Scalars['String']['input']>;
};

export type CreateKrolWodBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly contractId: Scalars['ContractId']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly level: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLanguageLearningBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly contractId: Scalars['ContractId']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly language: Language;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly quarterYear: QuarterYearInput;
};

export type CreateOnCallRecordInput = {
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly contractId: Scalars['ContractId']['input'];
  readonly date: Scalars['LocalDate']['input'];
  readonly dayShift: Scalars['Boolean']['input'];
  readonly id: Scalars['OnCallRecordId']['input'];
  readonly nightShift: Scalars['Boolean']['input'];
  readonly projectId: Scalars['ProjectId']['input'];
};

export type CreateOtherBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly contractId: Scalars['ContractId']['input'];
  readonly description: Scalars['String']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRemoteWorkEquipmentBonusInput = {
  readonly allocateCostToProjectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly amount: NetGrossInput;
  readonly applyAt: Scalars['YearMonth']['input'];
  readonly contractId: Scalars['ContractId']['input'];
  readonly id: Scalars['BonusId']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkRecordInput = {
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly contractId: Scalars['ContractId']['input'];
  readonly date: Scalars['LocalDate']['input'];
  readonly duration?: InputMaybe<Scalars['Minutes']['input']>;
  readonly id: Scalars['WorkRecordId']['input'];
  readonly overtime: Scalars['Boolean']['input'];
  readonly projectId?: InputMaybe<Scalars['ProjectId']['input']>;
  readonly remoteWork: Scalars['Boolean']['input'];
  readonly workTagId: Scalars['WorkTagId']['input'];
  readonly workTime?: InputMaybe<WorkTimeInput>;
};

export type DailyIncomeRow = {
  readonly __typename?: 'DailyIncomeRow';
  readonly rateAmount: NetGross;
  readonly value: NetGross;
  readonly workDays: Scalars['WorkDays']['output'];
};

export type DaysBalance = {
  readonly __typename?: 'DaysBalance';
  readonly available: Scalars['Days']['output'];
  readonly entitlement: Scalars['Days']['output'];
  readonly used: Scalars['Days']['output'];
};

export type DaysBalanceOrNfsError = DaysBalance | NfsError;

export type DeskAssignment = {
  readonly __typename?: 'DeskAssignment';
  readonly desk: ReservedResource;
  readonly from: Scalars['LocalDate']['output'];
  readonly id: Scalars['DeskAssignmentId']['output'];
  readonly office: Office;
  readonly to?: Maybe<Scalars['LocalDate']['output']>;
};

export type DirectReporting = {
  readonly __typename?: 'DirectReporting';
  readonly assignedProjects: ReadonlyArray<ProjectAssignment>;
  readonly directSubordinates: ReadonlyArray<Person>;
  readonly operationalLead: TimeBasedOptClearablePerson;
  readonly practiceLead: TimeBasedOptClearablePerson;
  readonly primaryProjectId: TimeBasedOptClearableProjectId;
  readonly space: TimeBasedSpace;
};


export type DirectReportingAssignedProjectsArgs = {
  orderByFirstPositionStartDate?: InputMaybe<SortOrder>;
  status_oneOf?: InputMaybe<ReadonlyArray<ProjectAssignmentStatus>>;
};

export type DownloadableExternallyHostedFileUrl = {
  readonly __typename?: 'DownloadableExternallyHostedFileUrl';
  readonly downloadUrl: Scalars['URI']['output'];
  readonly fileName: Scalars['String']['output'];
  readonly openUrl: Scalars['URI']['output'];
};

export type DownloadableFileUrl = {
  readonly __typename?: 'DownloadableFileUrl';
  readonly fileName: Scalars['String']['output'];
  readonly url: Scalars['URI']['output'];
};

export type DownloadableFileUrlOrNfsError = DownloadableFileUrl | NfsError;

export type DuplicatedEntityError = UserError & {
  readonly __typename?: 'DuplicatedEntityError';
  readonly desc?: Maybe<Scalars['String']['output']>;
  readonly itemId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName: Scalars['String']['output'];
};

export type EditAdditionalDataDrawer = AbstractDrawer & {
  readonly __typename?: 'EditAdditionalDataDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditAddressDrawer = AbstractDrawer & {
  readonly __typename?: 'EditAddressDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditProfileDetailsDrawer = AbstractDrawer & {
  readonly __typename?: 'EditProfileDetailsDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditSkillsAndCertificatesDrawer = AbstractDrawer & {
  readonly __typename?: 'EditSkillsAndCertificatesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EditSocialMediaHandlesDrawer = AbstractDrawer & {
  readonly __typename?: 'EditSocialMediaHandlesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type EmployeeReferralBonus = Bonus & {
  readonly __typename?: 'EmployeeReferralBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type EmploymentContract = Contract & {
  readonly __typename?: 'EmploymentContract';
  readonly annualLeaveEntitlement?: Maybe<AnnualLeaveEntitlement>;
  readonly assignedVariants: ReadonlyArray<AssignedVariant>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: Bonuses;
  readonly conclusionDate: Scalars['LocalDate']['output'];
  readonly copyrightCosts: TimeBasedOptClearableBasisPoint;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly currency: TimeBasedCurrency;
  readonly enableTrainingPackage: Scalars['Boolean']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly onCall: TimeBasedOptClearableOnCallRate;
  readonly overtimeRate: TimeBasedOptClearableNetGross;
  readonly position: TimeBasedOptClearableString;
  readonly preselectedFromTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedIsRemoteWork?: Maybe<Scalars['Boolean']['output']>;
  readonly preselectedProject?: Maybe<PreselectedProject>;
  readonly preselectedToTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedWorkTag?: Maybe<WorkTag>;
  readonly promisor: Company;
  readonly rate: TimeBasedRate;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: EmploymentContractType;
  readonly workingTime: TimeBasedWorkingTime;
};


export type EmploymentContractAssignedVariantsArgs = {
  activeOnly: Scalars['Boolean']['input'];
};

export type EmploymentContractSalaryDetails = ContractSalaryDetails & {
  readonly __typename?: 'EmploymentContractSalaryDetails';
  readonly accountingData?: Maybe<AccountingData>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly isTimeReportApprovalRequired: Scalars['Boolean']['output'];
  readonly isTimeReportCompleted: Scalars['Boolean']['output'];
  readonly salaryState: SalaryState;
  readonly totalPayout?: Maybe<NetGross>;
  readonly transferAmount?: Maybe<Scalars['Cents']['output']>;
  readonly transferDeduction?: Maybe<TransferDeduction>;
  readonly workTransferProtocols: ReadonlyArray<WorkTransferProtocol>;
  readonly yearMonth: Scalars['YearMonth']['output'];
};

export const EmploymentContractType = {
  MANAGEMENT: 'Management',
  UZ: 'UZ',
  UOD: 'UoD',
  UOP: 'UoP'
} as const;

export type EmploymentContractType = typeof EmploymentContractType[keyof typeof EmploymentContractType];
/** payout = gross value with following components: hourly rate * hours/monthly rate + overtime + on calls + bonuses */
export type EmploymentTimeReportStats = TimeReportStats & {
  readonly __typename?: 'EmploymentTimeReportStats';
  readonly currentTimeBalance: TimeBalance;
  /** calculate only when from-to is included in exactly one flex period and contract type is UoP */
  readonly flexTime?: Maybe<TimeBalance>;
  readonly incomeDetails: ReadonlyArray<IncomeDetails>;
  readonly overtime: Scalars['Minutes']['output'];
  readonly reportedLeaveDays: ReportedLeaveDays;
  readonly timeBalanceAtEndOfMonth: TimeBalance;
};

export type EmptyRequestInputError = UserError & {
  readonly __typename?: 'EmptyRequestInputError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type EntitiesNotFoundError = UserError & {
  readonly __typename?: 'EntitiesNotFoundError';
  readonly items: ReadonlyArray<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName?: Maybe<Scalars['String']['output']>;
};

export type EntityNotFoundError = UserError & {
  readonly __typename?: 'EntityNotFoundError';
  readonly item?: Maybe<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName?: Maybe<Scalars['String']['output']>;
};

export type EntityVersionMismatched = UserError & {
  readonly __typename?: 'EntityVersionMismatched';
  readonly currentVersion: Scalars['EntityVersion']['output'];
  readonly entityId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly receivedVersion: Scalars['EntityVersion']['output'];
};

export type ExternalBeneficiary = {
  readonly __typename?: 'ExternalBeneficiary';
  readonly address: Address;
  readonly assignedVariants: ReadonlyArray<AssignedVariant>;
  readonly email: Scalars['EmailAddress']['output'];
  readonly employeeId: Scalars['UserId']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ExternalBeneficiaryId']['output'];
  readonly lastName: Scalars['String']['output'];
};

export type File = {
  readonly __typename?: 'File';
  readonly value: DownloadableFileUrl;
};

export type ForeignKeyConstraintError = UserError & {
  readonly __typename?: 'ForeignKeyConstraintError';
  readonly dependentType: Scalars['String']['output'];
  readonly itemId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly typeName: Scalars['String']['output'];
};

export type Highlight = {
  readonly id?: Maybe<Scalars['ID']['output']>;
};

export type HolidayCalendar = {
  readonly __typename?: 'HolidayCalendar';
  readonly calendarDays: ReadonlyArray<CalendarDay>;
  readonly id: HolidayCalendarId;
};

export type HolidayCalendarDetails = {
  readonly __typename?: 'HolidayCalendarDetails';
  readonly id: HolidayCalendarId;
  readonly isUop: Scalars['Boolean']['output'];
};

export const HolidayCalendarId = {
  CH_BERN: 'CH_BERN',
  CH_ZURYCH: 'CH_ZURYCH',
  DE_BW: 'DE_BW',
  DE_HE: 'DE_HE',
  PL: 'PL',
  SE: 'SE',
  UK_ENG: 'UK_ENG'
} as const;

export type HolidayCalendarId = typeof HolidayCalendarId[keyof typeof HolidayCalendarId];
export type HolidayMultipliers = {
  readonly __typename?: 'HolidayMultipliers';
  readonly beforeHolidayNight: OnCallMultiplier;
  readonly holidayDay: OnCallMultiplier;
  readonly holidayNight: OnCallMultiplier;
};

export type HourlyIncomeRow = {
  readonly __typename?: 'HourlyIncomeRow';
  readonly rateAmount: NetGross;
  readonly rateIncreaseDueToRefundedBenefits?: Maybe<NetGross>;
  readonly valueIncludingRateIncrease: NetGross;
  readonly valueWithoutRateIncrease: NetGross;
  readonly workHours: Scalars['WorkHours']['output'];
};

export const IdType = {
  IDCARD: 'IDCard',
  PASSPORT: 'Passport'
} as const;

export type IdType = typeof IdType[keyof typeof IdType];
export type IllegalPositionRemovalError = UserError & {
  readonly __typename?: 'IllegalPositionRemovalError';
  readonly activeAssignments: ReadonlyArray<ProjectAssignmentId>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type IncomeDetails = {
  readonly __typename?: 'IncomeDetails';
  readonly benefitsValue: BenefitsValue;
  readonly bonuses: ReadonlyArray<Bonus>;
  readonly bonusesValueByCategory: ReadonlyArray<BonusCategoryAmount>;
  readonly from: Scalars['LocalDate']['output'];
  readonly onCallLogs: ReadonlyArray<OnCallLog>;
  readonly overtimeIncome: ReadonlyArray<HourlyIncomeRow>;
  readonly overtimeWorkTime: Scalars['Minutes']['output'];
  readonly paidLeaveIncome: ReadonlyArray<IncomeRow>;
  readonly payoutWithoutBenefits: NetGross;
  readonly rateDetails?: Maybe<RateDetails>;
  readonly remoteWorkReimbursement?: Maybe<RemoteWorkReimbursement>;
  readonly standardTimeIncome: ReadonlyArray<IncomeRow>;
  readonly standardWorkTime: Scalars['Minutes']['output'];
  readonly to: Scalars['LocalDate']['output'];
  readonly totalPayout: NetGross;
  readonly totalValueBonuses: NetGross;
  readonly totalValueOnCalls: NetGross;
  readonly totalValueOvertimeIncome: NetGross;
  readonly totalValueOvertimeIncomeIncludingBenefits: NetGross;
  readonly totalValuePaidLeaveIncome: NetGross;
  readonly totalValuePaidLeaveIncomeIncludingBenefits: NetGross;
  readonly totalValueStandardTimeIncome: NetGross;
  readonly totalValueStandardTimeIncomeIncludingBenefits: NetGross;
  readonly totalWorkTime: Scalars['Minutes']['output'];
};

export type IncomeRow = DailyIncomeRow | HourlyIncomeRow | MonthlyIncomeRow;

export type IncompleteArgumentError = UserError & {
  readonly __typename?: 'IncompleteArgumentError';
  readonly missingField: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type IncompleteArgumentsError = UserError & {
  readonly __typename?: 'IncompleteArgumentsError';
  readonly missingFields: ReadonlyArray<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type IncompleteData = {
  readonly __typename?: 'IncompleteData';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type IncompleteEntries = {
  readonly __typename?: 'IncompleteEntries';
  readonly days: ReadonlyArray<Scalars['LocalDate']['output']>;
};

export type InternalNfsError = UserError & {
  readonly __typename?: 'InternalNfsError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidApiTokenError = UserError & {
  readonly __typename?: 'InvalidApiTokenError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidArgument = {
  readonly __typename?: 'InvalidArgument';
  readonly arg: Scalars['String']['output'];
  readonly desc: Scalars['String']['output'];
};

export type InvalidArgumentsError = UserError & {
  readonly __typename?: 'InvalidArgumentsError';
  readonly invalidArguments: ReadonlyArray<InvalidArgument>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidCompanyTypeError = UserError & {
  readonly __typename?: 'InvalidCompanyTypeError';
  readonly companyId: Scalars['CompanyId']['output'];
  readonly expectedType: CompanyType;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidContentTypeError = UserError & {
  readonly __typename?: 'InvalidContentTypeError';
  readonly expectedType: Scalars['String']['output'];
  readonly fileName: Scalars['String']['output'];
  readonly fileType: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidCursorError = UserError & {
  readonly __typename?: 'InvalidCursorError';
  readonly cursor: Scalars['Cursor']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidEmailAddress = UserError & {
  readonly __typename?: 'InvalidEmailAddress';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvalidStateError = UserError & {
  readonly __typename?: 'InvalidStateError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvoiceAlreadyAcceptedError = UserError & {
  readonly __typename?: 'InvoiceAlreadyAcceptedError';
  readonly id: Scalars['InvoiceDetailsId']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvoiceDetails = {
  readonly __typename?: 'InvoiceDetails';
  readonly correct?: Maybe<Scalars['Boolean']['output']>;
  readonly currency?: Maybe<Scalars['Currency']['output']>;
  readonly file?: Maybe<DownloadableFileUrl>;
  readonly grossValue?: Maybe<Scalars['Cents']['output']>;
  readonly id: Scalars['InvoiceDetailsId']['output'];
  readonly ksefNumber?: Maybe<Scalars['String']['output']>;
  readonly number?: Maybe<Scalars['InvoiceNumber']['output']>;
  readonly userNote?: Maybe<Scalars['String']['output']>;
};

export type InvoiceDetailsApi = {
  readonly __typename?: 'InvoiceDetailsApi';
  readonly createInvoiceDetails: InvoiceDetailsOrNfsError;
  readonly removeInvoiceDetails: BooleanResponseOrNfsError;
  readonly updateInvoiceDetails: InvoiceDetailsOrNfsError;
};


export type InvoiceDetailsApiCreateInvoiceDetailsArgs = {
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  invoiceDetails: CreateInvoiceDetailsInput;
};


export type InvoiceDetailsApiRemoveInvoiceDetailsArgs = {
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
};


export type InvoiceDetailsApiUpdateInvoiceDetailsArgs = {
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  invoiceDetails: UpdateInvoiceDetailsInput;
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
};

export type InvoiceDetailsOrNfsError = InvoiceDetails | NfsError;

export type InvoiceImportedFromSaldeoError = UserError & {
  readonly __typename?: 'InvoiceImportedFromSaldeoError';
  readonly id: Scalars['InvoiceDetailsId']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type InvoicesDrawer = AbstractDrawer & {
  readonly __typename?: 'InvoicesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

/** A key-value pair of AbsenceType and AbsenceTypeDetails */
export type KvAbsenceTypeAbsenceTypeDetails = {
  readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails';
  /** Key */
  readonly key: AbsenceType;
  /** Value */
  readonly value: AbsenceTypeDetails;
};

/** A key-value pair of WorkTagId and Minutes */
export type KvWorkTagIdMinutes = {
  readonly __typename?: 'KVWorkTagIdMinutes';
  /** Key */
  readonly key: Scalars['WorkTagId']['output'];
  /** Value */
  readonly value?: Maybe<Scalars['Minutes']['output']>;
};

/** A key-value pair of Year and AnnualLeaveYearSummary */
export type KvYearAnnualLeaveYearSummary = {
  readonly __typename?: 'KVYearAnnualLeaveYearSummary';
  /** Key */
  readonly key: Scalars['Year']['output'];
  /** Value */
  readonly value: AnnualLeaveYearSummary;
};

/** A key-value pair of Year and TrainingBudgetYearSummary */
export type KvYearTrainingBudgetYearSummary = {
  readonly __typename?: 'KVYearTrainingBudgetYearSummary';
  /** Key */
  readonly key: Scalars['Year']['output'];
  /** Value */
  readonly value: TrainingBudgetYearSummary;
};

export const Language = {
  ENGLISH: 'English',
  OTHER: 'Other'
} as const;

export type Language = typeof Language[keyof typeof Language];
export type LanguageLearningBonus = Bonus & {
  readonly __typename?: 'LanguageLearningBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly language: Language;
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly quarterYear: QuarterYear;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type LeaveEntitlementExceededError = UserError & {
  readonly __typename?: 'LeaveEntitlementExceededError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type ListOfAbsenceRecordResponse = {
  readonly __typename?: 'ListOfAbsenceRecordResponse';
  readonly value: ReadonlyArray<AbsenceRecord>;
};

export type ListOfAbsenceRecordResponseOrNfsError = ListOfAbsenceRecordResponse | NfsError;

export type ListOfAssignedProjectResponse = {
  readonly __typename?: 'ListOfAssignedProjectResponse';
  readonly value: ReadonlyArray<AssignedProject>;
};

export type ListOfAssignedProjectResponseOrNfsError = ListOfAssignedProjectResponse | NfsError;

export type ListOfContractSalaryDetailsResponse = {
  readonly __typename?: 'ListOfContractSalaryDetailsResponse';
  readonly value: ReadonlyArray<ContractSalaryDetails>;
};

export type ListOfContractSalaryDetailsResponseOrNfsError = ListOfContractSalaryDetailsResponse | NfsError;

export type ListOfDeskAssignmentResponse = {
  readonly __typename?: 'ListOfDeskAssignmentResponse';
  readonly value: ReadonlyArray<DeskAssignment>;
};

export type ListOfDeskAssignmentResponseOrNfsError = ListOfDeskAssignmentResponse | NfsError;

export type ListOfKvWorkTagIdMinutesResponse = {
  readonly __typename?: 'ListOfKVWorkTagIdMinutesResponse';
  readonly value: ReadonlyArray<KvWorkTagIdMinutes>;
};

export type ListOfKvWorkTagIdMinutesResponseOrNfsError = ListOfKvWorkTagIdMinutesResponse | NfsError;

export type ListOfOnCallRecordResponse = {
  readonly __typename?: 'ListOfOnCallRecordResponse';
  readonly value: ReadonlyArray<OnCallRecord>;
};

export type ListOfOnCallRecordResponseOrNfsError = ListOfOnCallRecordResponse | NfsError;

export type ListOfProjectIdResponse = {
  readonly __typename?: 'ListOfProjectIdResponse';
  readonly value: ReadonlyArray<Scalars['ProjectId']['output']>;
};

export type ListOfProjectIdResponseOrNfsError = ListOfProjectIdResponse | NfsError;

export type ListOfProjectTimeReportsResponse = {
  readonly __typename?: 'ListOfProjectTimeReportsResponse';
  readonly value: ReadonlyArray<ProjectTimeReports>;
};

export type ListOfProjectTimeReportsResponseOrNfsError = ListOfProjectTimeReportsResponse | NfsError;

export type ListOfReservableOfficeResponse = {
  readonly __typename?: 'ListOfReservableOfficeResponse';
  readonly value: ReadonlyArray<ReservableOffice>;
};

export type ListOfReservableOfficeResponseOrNfsError = ListOfReservableOfficeResponse | NfsError;

export type ListOfReservationRequestResponse = {
  readonly __typename?: 'ListOfReservationRequestResponse';
  readonly value: ReadonlyArray<ReservationRequest>;
};

export type ListOfReservationRequestResponseOrNfsError = ListOfReservationRequestResponse | NfsError;

export type ListOfTimeReportValidationResponse = {
  readonly __typename?: 'ListOfTimeReportValidationResponse';
  readonly value: ReadonlyArray<TimeReportValidation>;
};

export type ListOfTimeReportValidationResponseOrNfsError = ListOfTimeReportValidationResponse | NfsError;

export type ListOfWorkRecordResponse = {
  readonly __typename?: 'ListOfWorkRecordResponse';
  readonly value: ReadonlyArray<WorkRecord>;
};

export type ListOfWorkRecordResponseOrNfsError = ListOfWorkRecordResponse | NfsError;

export type LocalDateRange = {
  readonly __typename?: 'LocalDateRange';
  readonly from: Scalars['LocalDate']['output'];
  readonly to?: Maybe<Scalars['LocalDate']['output']>;
};

export type MissingEntries = {
  readonly __typename?: 'MissingEntries';
  readonly days: ReadonlyArray<Scalars['LocalDate']['output']>;
};

export type MissingFileMetadataError = UserError & {
  readonly __typename?: 'MissingFileMetadataError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type MonthlyIncomeRow = {
  readonly __typename?: 'MonthlyIncomeRow';
  readonly rateAmount: NetGross;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly officeReservations: OfficeReservationsApi;
  readonly reporting: UserReportingApi;
  readonly updateProfile: UserOrNfsError;
};


export type MutationUpdateProfileArgs = {
  areaOfExpertise?: InputMaybe<ClearableStringInput>;
  contactEmail?: InputMaybe<ClearableEmailAddressInput>;
  declaredNoCertificates?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContact?: InputMaybe<ClearableStringInput>;
  mailingAddress?: InputMaybe<ClearableAddressInput>;
  paczkomat?: InputMaybe<ClearableStringInput>;
  passportExpirationDate?: InputMaybe<ClearableLocalDateInput>;
  phoneNumber?: InputMaybe<ClearablePhoneNumberInput>;
  plateNumber?: InputMaybe<ClearableStringInput>;
  skillsAndCompetences?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  socialMediaHandles?: InputMaybe<ReadonlyArray<SocialMediaHandleInput>>;
};

export type NbpBaseCurrencyError = UserError & {
  readonly __typename?: 'NBPBaseCurrencyError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type NegativeFlexTimeBalance = {
  readonly __typename?: 'NegativeFlexTimeBalance';
  readonly minutes: Scalars['Minutes']['output'];
};

export type NetGross = {
  readonly __typename?: 'NetGross';
  readonly gross: Scalars['Cents']['output'];
  readonly net: Scalars['Cents']['output'];
};

/** At least one field must be defined, the second one could be inferred */
export type NetGrossInput = {
  readonly gross?: InputMaybe<Scalars['Cents']['input']>;
  readonly net?: InputMaybe<Scalars['Cents']['input']>;
};

export type NfsError = {
  readonly __typename?: 'NfsError';
  readonly error: UserError;
};

export type NoParkingSpotAvailableError = UserError & {
  readonly __typename?: 'NoParkingSpotAvailableError';
  readonly dates: ReadonlyArray<Scalars['LocalDate']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type NoWorkToBeTransferedThisMonth = {
  readonly __typename?: 'NoWorkToBeTransferedThisMonth';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type NotRequired = {
  readonly __typename?: 'NotRequired';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type Office = {
  readonly __typename?: 'Office';
  readonly avatar?: Maybe<Scalars['URI']['output']>;
  readonly blocked: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly officeId: Scalars['OfficeId']['output'];
  readonly physical: Scalars['Boolean']['output'];
  readonly validFrom: Scalars['LocalDate']['output'];
  readonly validTo?: Maybe<Scalars['LocalDate']['output']>;
};

export type OfficeAvailability = {
  readonly __typename?: 'OfficeAvailability';
  readonly desks: ReadonlyArray<ResourceAvailability>;
  readonly parkingSpots: ReadonlyArray<ResourceAvailability>;
};

export type OfficeAvailabilityOrNfsError = NfsError | OfficeAvailability;

export type OfficeReservationSettings = {
  readonly __typename?: 'OfficeReservationSettings';
  readonly deskMaxAdvanceDays: Scalars['Int']['output'];
  readonly deskMaxDays: Scalars['Int']['output'];
  readonly deskMaxUpcomingDays: Scalars['Int']['output'];
  readonly parkingMaxAdvanceDays: Scalars['Int']['output'];
  readonly parkingMaxDays: Scalars['Int']['output'];
  readonly parkingMaxUpcomingDays: Scalars['Int']['output'];
};

export type OfficeReservationSettingsOrNfsError = NfsError | OfficeReservationSettings;

export type OfficeReservationsApi = {
  readonly __typename?: 'OfficeReservationsApi';
  readonly cancelOfficeReservation: ReservationRequestOrNfsError;
  readonly reserveDesks: ReservationRequestOrNfsError;
  readonly reserveParking: ReservationRequestOrNfsError;
};


export type OfficeReservationsApiCancelOfficeReservationArgs = {
  requestId: Scalars['ReservationRequestId']['input'];
};


export type OfficeReservationsApiReserveDesksArgs = {
  deskIds: ReadonlyArray<Scalars['DeskId']['input']>;
  guestEmails: ReadonlyArray<Scalars['EmailAddress']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  range: ClosedEndLocalDateRangeInput;
  requestId: Scalars['ReservationRequestId']['input'];
  roomId: Scalars['RoomId']['input'];
};


export type OfficeReservationsApiReserveParkingArgs = {
  guestEmails: ReadonlyArray<Scalars['EmailAddress']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  officeId: Scalars['OfficeId']['input'];
  parkingSpotId?: InputMaybe<Scalars['ParkingSpotId']['input']>;
  plateNumber?: InputMaybe<Scalars['String']['input']>;
  range: ClosedEndLocalDateRangeInput;
  requestId: Scalars['ReservationRequestId']['input'];
};

export type OnCallLog = {
  readonly __typename?: 'OnCallLog';
  readonly dates: ReadonlyArray<Scalars['LocalDate']['output']>;
  readonly multiplier: OnCallMultiplier;
  readonly multiplierRate: NetGross;
  readonly shift: Shift;
  readonly shifts: Scalars['Days']['output'];
  readonly totalValue: NetGross;
};

export const OnCallMultiplier = {
  ONE: 'One',
  ONEANDHALF: 'OneAndHalf',
  THREE: 'Three'
} as const;

export type OnCallMultiplier = typeof OnCallMultiplier[keyof typeof OnCallMultiplier];
export type OnCallMultipliers = {
  readonly __typename?: 'OnCallMultipliers';
  readonly holidays: HolidayMultipliers;
  readonly weekdays: WeekdayDayAndNightMultipliers;
};

export type OnCallMultipliersOrNfsError = NfsError | OnCallMultipliers;

export type OnCallRate = {
  readonly __typename?: 'OnCallRate';
  readonly holiday: NetGross;
  readonly night: NetGross;
  readonly weekend: NetGross;
};

export type OnCallRecord = {
  readonly __typename?: 'OnCallRecord';
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly date: Scalars['LocalDate']['output'];
  readonly dayShift: Scalars['Boolean']['output'];
  readonly id: Scalars['OnCallRecordId']['output'];
  readonly nightShift: Scalars['Boolean']['output'];
  readonly project: Project;
};

export type OnCallRecordApi = {
  readonly __typename?: 'OnCallRecordApi';
  readonly createMany: ListOfOnCallRecordResponseOrNfsError;
  readonly update: OnCallRecordOrNfsError;
};


export type OnCallRecordApiCreateManyArgs = {
  value: ReadonlyArray<CreateOnCallRecordInput>;
};


export type OnCallRecordApiUpdateArgs = {
  comment?: InputMaybe<ClearableStringInput>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  dayShift?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['OnCallRecordId']['input'];
  nightShift?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['ProjectId']['input']>;
};

export type OnCallRecordOrNfsError = NfsError | OnCallRecord;

export type OperationAlreadyInProgressError = UserError & {
  readonly __typename?: 'OperationAlreadyInProgressError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type OperationNotAvailableError = UserError & {
  readonly __typename?: 'OperationNotAvailableError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type OtherBonus = Bonus & {
  readonly __typename?: 'OtherBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type OtherInvalidRequestError = UserError & {
  readonly __typename?: 'OtherInvalidRequestError';
  readonly key: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type PaymentCouldNotBeChangedError = UserError & {
  readonly __typename?: 'PaymentCouldNotBeChangedError';
  readonly csdIds: ReadonlyArray<ContractSalaryDetailsId>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type PaymentDisbursed = {
  readonly __typename?: 'PaymentDisbursed';
  readonly disbursedAt: Scalars['OffsetDateTime']['output'];
  readonly transferState: TransferState;
};

export type PendingApproval = {
  readonly __typename?: 'PendingApproval';
  readonly isCurrentUserAllowedToApprove: Scalars['Boolean']['output'];
};

export type Person = {
  readonly __typename?: 'Person';
  readonly avatar?: Maybe<Scalars['URI']['output']>;
  readonly email: Scalars['EmailAddress']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly role: CompanyRole;
};

export type PositionInactiveError = UserError & {
  readonly __typename?: 'PositionInactiveError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly positionId: Scalars['ClientPositionId']['output'];
};

export type PpkDetails = {
  readonly __typename?: 'PpkDetails';
  readonly employee: Scalars['Cents']['output'];
  readonly employer: Scalars['Cents']['output'];
};

export type PreselectedProject = {
  readonly __typename?: 'PreselectedProject';
  /** null means prefer 'no project' */
  readonly value?: Maybe<Project>;
};

export type PreselectedProjectIdInput = {
  /** null means prefer 'no project' */
  readonly value?: InputMaybe<Scalars['ProjectId']['input']>;
};

export const ProgressionLevel = {
  ENGINEERE1: 'EngineerE1',
  ENGINEERE2: 'EngineerE2',
  ENGINEERINTERN: 'EngineerIntern',
  ENGINEERJ1: 'EngineerJ1',
  ENGINEERJ2: 'EngineerJ2',
  ENGINEERJ3: 'EngineerJ3',
  ENGINEERJUNIOR: 'EngineerJunior',
  ENGINEERM1: 'EngineerM1',
  ENGINEERM2: 'EngineerM2',
  ENGINEERM3: 'EngineerM3',
  ENGINEERM4: 'EngineerM4',
  ENGINEERMID: 'EngineerMid',
  ENGINEERPRINCIPAL: 'EngineerPrincipal',
  ENGINEERS1: 'EngineerS1',
  ENGINEERS2: 'EngineerS2',
  ENGINEERS3: 'EngineerS3',
  ENGINEERS4: 'EngineerS4',
  ENGINEERS5: 'EngineerS5',
  ENGINEERSENIOR: 'EngineerSenior',
  ENGINEERSTAFF: 'EngineerStaff',
  NONENGINEERE1: 'NonEngineerE1',
  NONENGINEERE2: 'NonEngineerE2',
  NONENGINEEREXPERT: 'NonEngineerExpert',
  NONENGINEERINTERN: 'NonEngineerIntern',
  NONENGINEERJ1: 'NonEngineerJ1',
  NONENGINEERJ2: 'NonEngineerJ2',
  NONENGINEERJ3: 'NonEngineerJ3',
  NONENGINEERJUNIOR: 'NonEngineerJunior',
  NONENGINEERM1: 'NonEngineerM1',
  NONENGINEERM2: 'NonEngineerM2',
  NONENGINEERM3: 'NonEngineerM3',
  NONENGINEERM4: 'NonEngineerM4',
  NONENGINEERREGULAR: 'NonEngineerRegular',
  NONENGINEERS1: 'NonEngineerS1',
  NONENGINEERS2: 'NonEngineerS2',
  NONENGINEERS3: 'NonEngineerS3',
  NONENGINEERS4: 'NonEngineerS4',
  NONENGINEERSENIOR: 'NonEngineerSenior'
} as const;

export type ProgressionLevel = typeof ProgressionLevel[keyof typeof ProgressionLevel];
export type Project = {
  readonly __typename?: 'Project';
  readonly id: Scalars['ProjectId']['output'];
  readonly lead?: Maybe<Person>;
  readonly name: Scalars['String']['output'];
};

export type ProjectAssignment = {
  readonly __typename?: 'ProjectAssignment';
  readonly periods: ReadonlyArray<LocalDateRange>;
  readonly project: Project;
};

export type ProjectAssignmentId = {
  readonly __typename?: 'ProjectAssignmentId';
  readonly projectId: Scalars['ProjectId']['output'];
  readonly userId: Scalars['UserId']['output'];
};

export const ProjectAssignmentStatus = {
  LIVE: 'Live',
  PLANNED: 'Planned',
  TERMINATED: 'Terminated'
} as const;

export type ProjectAssignmentStatus = typeof ProjectAssignmentStatus[keyof typeof ProjectAssignmentStatus];
export type ProjectMemberTimeReports = {
  readonly __typename?: 'ProjectMemberTimeReports';
  readonly absenceRecords: ReadonlyArray<ClosedEndLocalDateRange>;
  readonly holidayCalendar: HolidayCalendarDetails;
  readonly person: Person;
};


export type ProjectMemberTimeReportsAbsenceRecordsArgs = {
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
};

export type ProjectTimeReports = {
  readonly __typename?: 'ProjectTimeReports';
  readonly membersTimeReports: ReadonlyArray<ProjectMemberTimeReports>;
  readonly project: Project;
};

export const Quarter = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const;

export type Quarter = typeof Quarter[keyof typeof Quarter];
export type QuarterYear = {
  readonly __typename?: 'QuarterYear';
  readonly quarter: Quarter;
  readonly year: Scalars['Year']['output'];
};

export type QuarterYearInput = {
  readonly quarter: Quarter;
  readonly year: Scalars['Year']['input'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly absenceReportingRange?: Maybe<ClosedEndLocalDateRangeOrNfsError>;
  readonly absenceTypeDetails: ReadonlyArray<KvAbsenceTypeAbsenceTypeDetails>;
  readonly annualLeaveSummary: AnnualLeaveSummaryOrNfsError;
  /** default value for `from` is the beginning of the previous month */
  readonly assignedProjects: ListOfAssignedProjectResponseOrNfsError;
  readonly contract: ContractResponseOrNfsError;
  readonly contractSalaryDetails: ContractSalaryDetailsResponseOrNfsError;
  readonly contractSalaryDetailsInRange: ListOfContractSalaryDetailsResponseOrNfsError;
  readonly defaultActiveReportingRange?: Maybe<ClosedEndLocalDateRangeOrNfsError>;
  readonly drawer?: Maybe<AbstractDrawer>;
  readonly holidayCalendars: ReadonlyArray<HolidayCalendar>;
  readonly myDeskAssignments: ListOfDeskAssignmentResponseOrNfsError;
  readonly myOfficeReservations: ListOfReservationRequestResponseOrNfsError;
  /** default range is from today to the last bookable day */
  readonly officeAvailability: OfficeAvailabilityOrNfsError;
  readonly officeReservationLimits: OfficeReservationSettingsOrNfsError;
  readonly onCallMultipliers: OnCallMultipliersOrNfsError;
  readonly paidLeaveBalanceYearlySummary?: Maybe<DaysBalanceOrNfsError>;
  readonly profile: UserOrNfsError;
  /** For fetching all projects related to User for color assignment */
  readonly projects: ListOfProjectIdResponseOrNfsError;
  readonly projectsTimeReports: ListOfProjectTimeReportsResponseOrNfsError;
  readonly remainingWorkTagReportingLimit: ListOfKvWorkTagIdMinutesResponseOrNfsError;
  readonly remoteWorkReimbursementRate?: Maybe<Scalars['Cents']['output']>;
  readonly reservableOffices: ListOfReservableOfficeResponseOrNfsError;
  readonly rootDrawer?: Maybe<AbstractDrawer>;
  readonly timeReport: TimeReportOrNfsError;
  readonly timeReportFile: DownloadableFileUrlOrNfsError;
  readonly timeReportValidations: ListOfTimeReportValidationResponseOrNfsError;
  readonly topDrawer?: Maybe<AbstractDrawer>;
  readonly trainingBudgetSummary: TrainingBudgetSummaryOrNfsError;
};


export type QueryAbsenceReportingRangeArgs = {
  contractId: Scalars['ContractId']['input'];
};


export type QueryAnnualLeaveSummaryArgs = {
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
};


export type QueryAssignedProjectsArgs = {
  contractId: Scalars['ContractId']['input'];
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


export type QueryContractArgs = {
  at?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  contractId: Scalars['ContractId']['input'];
};


export type QueryContractSalaryDetailsArgs = {
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
};


export type QueryContractSalaryDetailsInRangeArgs = {
  contractId: Scalars['ContractId']['input'];
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
};


export type QueryDefaultActiveReportingRangeArgs = {
  contractId: Scalars['ContractId']['input'];
};


export type QueryDrawerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyOfficeReservationsArgs = {
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryOfficeAvailabilityArgs = {
  officeId: Scalars['OfficeId']['input'];
  range?: InputMaybe<ClosedEndLocalDateRangeInput>;
};


export type QueryPaidLeaveBalanceYearlySummaryArgs = {
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
};


export type QueryProjectsTimeReportsArgs = {
  projectId_in?: InputMaybe<ReadonlyArray<Scalars['ProjectId']['input']>>;
};


export type QueryRemainingWorkTagReportingLimitArgs = {
  year: Scalars['Year']['input'];
};


export type QueryRemoteWorkReimbursementRateArgs = {
  value: Scalars['YearMonth']['input'];
};


export type QueryTimeReportArgs = {
  contractId: Scalars['ContractId']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryTimeReportFileArgs = {
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryTimeReportValidationsArgs = {
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
};


export type QueryTrainingBudgetSummaryArgs = {
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
};

export type RaiseNoLongerDueError = UserError & {
  readonly __typename?: 'RaiseNoLongerDueError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type Rate = {
  readonly __typename?: 'Rate';
  readonly amount: NetGross;
  readonly settlement: Settlement;
};

export type RateDetails = {
  readonly __typename?: 'RateDetails';
  readonly currency: Scalars['Currency']['output'];
  readonly overtimeRate?: Maybe<NetGross>;
  readonly rate: Rate;
  readonly rateIncreaseDueToRefundedBenefits?: Maybe<NetGross>;
  readonly vat?: Maybe<Scalars['BasisPoint']['output']>;
};

export type Ready = {
  readonly __typename?: 'Ready';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  readonly _?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoteWorkEquipmentBonus = Bonus & {
  readonly __typename?: 'RemoteWorkEquipmentBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type RemoteWorkReimbursement = {
  readonly __typename?: 'RemoteWorkReimbursement';
  readonly rate: Scalars['Cents']['output'];
  readonly time: Scalars['Minutes']['output'];
  readonly totalValue: NetGross;
};

export type ReportedLeaveDays = {
  readonly __typename?: 'ReportedLeaveDays';
  readonly annual: AnnualLeaveEntitlementValue;
  readonly caregiving: Scalars['WorkDays']['output'];
  readonly childCare: Scalars['WorkDays']['output'];
  readonly dueToForceMajeure: Scalars['WorkDays']['output'];
  readonly maternity: Scalars['WorkDays']['output'];
  readonly outOfOffice: Scalars['WorkDays']['output'];
  readonly paid: Scalars['WorkDays']['output'];
  readonly parental: Scalars['WorkDays']['output'];
  readonly paternity: Scalars['WorkDays']['output'];
  readonly sickFamilyMemberCare: Scalars['WorkDays']['output'];
  readonly sickLeave: Scalars['WorkDays']['output'];
  readonly special: Scalars['WorkDays']['output'];
  readonly unpaid: Scalars['WorkDays']['output'];
};

export type ReservableDesk = {
  readonly __typename?: 'ReservableDesk';
  readonly id: Scalars['DeskId']['output'];
  readonly monitors: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly standing: Scalars['Boolean']['output'];
};

export type ReservableOffice = {
  readonly __typename?: 'ReservableOffice';
  readonly floorMap?: Maybe<DownloadableExternallyHostedFileUrl>;
  readonly office: Office;
  readonly parkingInformation?: Maybe<Scalars['String']['output']>;
  readonly parkingMap?: Maybe<DownloadableExternallyHostedFileUrl>;
  readonly parkingSpots: ReadonlyArray<ReservableParkingSpot>;
  readonly rooms: ReadonlyArray<ReservableRoom>;
};

export type ReservableParkingSpot = {
  readonly __typename?: 'ReservableParkingSpot';
  readonly guest: Scalars['Boolean']['output'];
  readonly id: Scalars['ParkingSpotId']['output'];
  readonly name: Scalars['String']['output'];
  readonly number: Scalars['String']['output'];
};

export type ReservableRoom = {
  readonly __typename?: 'ReservableRoom';
  readonly desks: ReadonlyArray<ReservableDesk>;
  readonly id: Scalars['RoomId']['output'];
  readonly name: Scalars['String']['output'];
};

export type ReservationNotPendingError = UserError & {
  readonly __typename?: 'ReservationNotPendingError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly requestId: Scalars['ReservationRequestId']['output'];
};

export type ReservationRequest = {
  readonly __typename?: 'ReservationRequest';
  readonly approval: Approval;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly guestEmails: ReadonlyArray<Scalars['EmailAddress']['output']>;
  readonly kind: ResourceKind;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly office: Office;
  readonly plateNumber?: Maybe<Scalars['String']['output']>;
  readonly range: ClosedEndLocalDateRange;
  readonly requestId: Scalars['ReservationRequestId']['output'];
  readonly resources: ReadonlyArray<ReservedResource>;
};

export type ReservationRequestOrNfsError = NfsError | ReservationRequest;

export type ReservationRequestStateError = UserError & {
  readonly __typename?: 'ReservationRequestStateError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly requestId: Scalars['ReservationRequestId']['output'];
};

export type ReservedResource = {
  readonly __typename?: 'ReservedResource';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type ResourceAlreadyReservedError = UserError & {
  readonly __typename?: 'ResourceAlreadyReservedError';
  readonly dates: ReadonlyArray<Scalars['LocalDate']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type ResourceAvailability = {
  readonly __typename?: 'ResourceAvailability';
  readonly resourceId: Scalars['ID']['output'];
  readonly takenDates: ReadonlyArray<Scalars['LocalDate']['output']>;
};

export const ResourceKind = {
  DESK: 'Desk',
  PARKINGSPOT: 'ParkingSpot'
} as const;

export type ResourceKind = typeof ResourceKind[keyof typeof ResourceKind];
export type RevenueAdministrationOffice = {
  readonly __typename?: 'RevenueAdministrationOffice';
  readonly city: Scalars['String']['output'];
  readonly country: Scalars['String']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly faxNumber?: Maybe<Scalars['String']['output']>;
  readonly flatNumber?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['RevenueAdministrationOfficeId']['output'];
  readonly officeName: Scalars['String']['output'];
  readonly officeType?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly postOffice?: Maybe<Scalars['String']['output']>;
  readonly postcode: Scalars['String']['output'];
  readonly street?: Maybe<Scalars['String']['output']>;
  readonly voivodeship?: Maybe<Scalars['String']['output']>;
  readonly website?: Maybe<Scalars['String']['output']>;
};

export type SalaryState = IncompleteData | PaymentDisbursed | Ready;

export type SalesCommissionsBonus = Bonus & {
  readonly __typename?: 'SalesCommissionsBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export const Settlement = {
  DAILY: 'Daily',
  HOURLY: 'Hourly',
  MONTHLY: 'Monthly'
} as const;

export type Settlement = typeof Settlement[keyof typeof Settlement];
export type SeverancePayBonus = Bonus & {
  readonly __typename?: 'SeverancePayBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type ShareholderDividendBonus = Bonus & {
  readonly __typename?: 'ShareholderDividendBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export const Shift = {
  DAYSHIFT: 'DayShift',
  NIGHTSHIFT: 'NightShift'
} as const;

export type Shift = typeof Shift[keyof typeof Shift];
export type SocialMediaHandle = {
  readonly __typename?: 'SocialMediaHandle';
  readonly handle: Scalars['String']['output'];
  readonly platform: Scalars['String']['output'];
};

export type SocialMediaHandleInput = {
  readonly handle: Scalars['String']['input'];
  readonly platform: Scalars['String']['input'];
};

export const SortOrder = {
  ASC: 'Asc',
  DESC: 'Desc'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type Space = {
  readonly __typename?: 'Space';
  readonly id: Scalars['SpaceId']['output'];
  readonly name: Scalars['String']['output'];
  readonly owner: Person;
};

export type SubBenefit = BenefitCommon & {
  readonly __typename?: 'SubBenefit';
  readonly alternativeBenefitsGroupId: Scalars['AlternativeBenefitsGroupId']['output'];
  readonly endDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly id: Scalars['BenefitId']['output'];
  readonly name: Scalars['String']['output'];
  readonly parent: Benefit;
  readonly startDate: Scalars['LocalDate']['output'];
};

export type Subcontract = Contract & {
  readonly __typename?: 'Subcontract';
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly bonuses: Bonuses;
  readonly conclusionDate: Scalars['LocalDate']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly expectedEndDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly holidayCalendar: HolidayCalendar;
  readonly id: Scalars['ContractId']['output'];
  readonly name: Scalars['String']['output'];
  readonly preselectedFromTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedProject?: Maybe<PreselectedProject>;
  readonly preselectedToTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly preselectedWorkTag?: Maybe<WorkTag>;
  readonly promisor: Company;
  readonly startDate: Scalars['LocalDate']['output'];
  readonly status: ContractStatus;
  readonly terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly workingTime: TimeBasedWorkingTime;
};

export type TimeBalance = {
  readonly __typename?: 'TimeBalance';
  readonly absenceTime: Scalars['Minutes']['output'];
  readonly at: Scalars['LocalDate']['output'];
  readonly balance: Scalars['Minutes']['output'];
  readonly currentTimeRequirement: Scalars['Minutes']['output'];
  readonly currentTimeRequirementWithAbsenceTimeSubtracted: Scalars['Minutes']['output'];
  readonly period: ClosedEndMonthRange;
  readonly reportedStandardWorkTime: Scalars['Minutes']['output'];
  readonly totalTimeInPeriod: Scalars['Minutes']['output'];
};

export type TimeBasedActivityOverlapError = UserError & {
  readonly __typename?: 'TimeBasedActivityOverlapError';
  readonly date: Scalars['OffsetDateTime']['output'];
  readonly entityId: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type TimeBasedBenefitBuyerType = {
  readonly __typename?: 'TimeBasedBenefitBuyerType';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantBenefitBuyerType>;
  readonly history: ReadonlyArray<TimeBasedInstantBenefitBuyerType>;
  readonly value: BenefitBuyerType;
};

export type TimeBasedBenefitVariant = {
  readonly __typename?: 'TimeBasedBenefitVariant';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantBenefitVariant>;
  readonly history: ReadonlyArray<TimeBasedInstantBenefitVariant>;
  readonly value: BenefitVariant;
};

export type TimeBasedBoolean = {
  readonly __typename?: 'TimeBasedBoolean';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantBoolean>;
  readonly history: ReadonlyArray<TimeBasedInstantBoolean>;
  readonly value: Scalars['Boolean']['output'];
};

export type TimeBasedCompanyRole = {
  readonly __typename?: 'TimeBasedCompanyRole';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantCompanyRole>;
  readonly history: ReadonlyArray<TimeBasedInstantCompanyRole>;
  readonly value: CompanyRole;
};

export type TimeBasedCurrency = {
  readonly __typename?: 'TimeBasedCurrency';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantCurrency>;
  readonly history: ReadonlyArray<TimeBasedInstantCurrency>;
  readonly value: Scalars['Currency']['output'];
};

export type TimeBasedEffectiveFromInPastError = UserError & {
  readonly __typename?: 'TimeBasedEffectiveFromInPastError';
  readonly activityDate: Scalars['OffsetDateTime']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
  readonly now: Scalars['OffsetDateTime']['output'];
};

export type TimeBasedInstantBenefitBuyerType = {
  readonly __typename?: 'TimeBasedInstantBenefitBuyerType';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: BenefitBuyerType;
};

export type TimeBasedInstantBenefitVariant = {
  readonly __typename?: 'TimeBasedInstantBenefitVariant';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: BenefitVariant;
};

export type TimeBasedInstantBoolean = {
  readonly __typename?: 'TimeBasedInstantBoolean';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Scalars['Boolean']['output'];
};

export type TimeBasedInstantClearableBasisPoint = {
  readonly __typename?: 'TimeBasedInstantClearableBasisPoint';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableBasisPoint;
};

export type TimeBasedInstantClearableBenefitVariantRate = {
  readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableBenefitVariantRate;
};

export type TimeBasedInstantClearableExternalBeneficiary = {
  readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableExternalBeneficiary;
};

export type TimeBasedInstantClearableNetGross = {
  readonly __typename?: 'TimeBasedInstantClearableNetGross';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableNetGross;
};

export type TimeBasedInstantClearableOnCallRate = {
  readonly __typename?: 'TimeBasedInstantClearableOnCallRate';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableOnCallRate;
};

export type TimeBasedInstantClearablePerson = {
  readonly __typename?: 'TimeBasedInstantClearablePerson';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearablePerson;
};

export type TimeBasedInstantClearableProgressionLevel = {
  readonly __typename?: 'TimeBasedInstantClearableProgressionLevel';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableProgressionLevel;
};

export type TimeBasedInstantClearableProjectId = {
  readonly __typename?: 'TimeBasedInstantClearableProjectId';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableProjectId;
};

export type TimeBasedInstantClearableString = {
  readonly __typename?: 'TimeBasedInstantClearableString';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ClearableString;
};

export type TimeBasedInstantCompanyRole = {
  readonly __typename?: 'TimeBasedInstantCompanyRole';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: CompanyRole;
};

export type TimeBasedInstantCurrency = {
  readonly __typename?: 'TimeBasedInstantCurrency';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Scalars['Currency']['output'];
};

export type TimeBasedInstantListOfExternalBeneficiary = {
  readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: ReadonlyArray<ExternalBeneficiary>;
};

export type TimeBasedInstantRate = {
  readonly __typename?: 'TimeBasedInstantRate';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Rate;
};

export type TimeBasedInstantSpace = {
  readonly __typename?: 'TimeBasedInstantSpace';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: Space;
};

export type TimeBasedInstantVatType = {
  readonly __typename?: 'TimeBasedInstantVatType';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: VatType;
};

export type TimeBasedInstantWorkingTime = {
  readonly __typename?: 'TimeBasedInstantWorkingTime';
  readonly activityId: Scalars['ActivityId']['output'];
  readonly applyDate: Scalars['OffsetDateTime']['output'];
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly value: WorkingTime;
};

export type TimeBasedListOfExternalBeneficiary = {
  readonly __typename?: 'TimeBasedListOfExternalBeneficiary';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantListOfExternalBeneficiary>;
  readonly history: ReadonlyArray<TimeBasedInstantListOfExternalBeneficiary>;
  readonly value: ReadonlyArray<ExternalBeneficiary>;
};

export type TimeBasedOptClearableBasisPoint = {
  readonly __typename?: 'TimeBasedOptClearableBasisPoint';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableBasisPoint>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableBasisPoint>;
  readonly value?: Maybe<Scalars['BasisPoint']['output']>;
};

export type TimeBasedOptClearableBenefitVariantRate = {
  readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableBenefitVariantRate>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableBenefitVariantRate>;
  readonly value?: Maybe<BenefitVariantRate>;
};

export type TimeBasedOptClearableExternalBeneficiary = {
  readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableExternalBeneficiary>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableExternalBeneficiary>;
  readonly value?: Maybe<ExternalBeneficiary>;
};

export type TimeBasedOptClearableNetGross = {
  readonly __typename?: 'TimeBasedOptClearableNetGross';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableNetGross>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableNetGross>;
  readonly value?: Maybe<NetGross>;
};

export type TimeBasedOptClearableOnCallRate = {
  readonly __typename?: 'TimeBasedOptClearableOnCallRate';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableOnCallRate>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableOnCallRate>;
  readonly value?: Maybe<OnCallRate>;
};

export type TimeBasedOptClearablePerson = {
  readonly __typename?: 'TimeBasedOptClearablePerson';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearablePerson>;
  readonly history: ReadonlyArray<TimeBasedInstantClearablePerson>;
  readonly value?: Maybe<Person>;
};

export type TimeBasedOptClearableProgressionLevel = {
  readonly __typename?: 'TimeBasedOptClearableProgressionLevel';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableProgressionLevel>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableProgressionLevel>;
  readonly value?: Maybe<ProgressionLevel>;
};

export type TimeBasedOptClearableProjectId = {
  readonly __typename?: 'TimeBasedOptClearableProjectId';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableProjectId>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableProjectId>;
  readonly value?: Maybe<Scalars['ProjectId']['output']>;
};

export type TimeBasedOptClearableString = {
  readonly __typename?: 'TimeBasedOptClearableString';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantClearableString>;
  readonly history: ReadonlyArray<TimeBasedInstantClearableString>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

export type TimeBasedRate = {
  readonly __typename?: 'TimeBasedRate';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantRate>;
  readonly history: ReadonlyArray<TimeBasedInstantRate>;
  readonly value: Rate;
};

export type TimeBasedSpace = {
  readonly __typename?: 'TimeBasedSpace';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantSpace>;
  readonly history: ReadonlyArray<TimeBasedInstantSpace>;
  readonly value: Space;
};

export type TimeBasedVatType = {
  readonly __typename?: 'TimeBasedVatType';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantVatType>;
  readonly history: ReadonlyArray<TimeBasedInstantVatType>;
  readonly value: VatType;
};

export type TimeBasedWorkingTime = {
  readonly __typename?: 'TimeBasedWorkingTime';
  readonly futureUpdates: ReadonlyArray<TimeBasedInstantWorkingTime>;
  readonly history: ReadonlyArray<TimeBasedInstantWorkingTime>;
  readonly value: WorkingTime;
};

export type TimeReport = {
  readonly __typename?: 'TimeReport';
  readonly timeReportRecords: TimeReportRecords;
  readonly timeReportStats?: Maybe<TimeReportStats>;
};

export type TimeReportOrNfsError = NfsError | TimeReport;

export type TimeReportOverlapError = UserError & {
  readonly __typename?: 'TimeReportOverlapError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type TimeReportPreferencesDrawer = AbstractDrawer & {
  readonly __typename?: 'TimeReportPreferencesDrawer';
  readonly child?: Maybe<AbstractDrawer>;
  readonly id: Scalars['ID']['output'];
  readonly requiredContractId: Scalars['ContractId']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export type TimeReportRecordApprovalNotInPendingStateError = UserError & {
  readonly __typename?: 'TimeReportRecordApprovalNotInPendingStateError';
  readonly id: Scalars['ID']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type TimeReportRecords = {
  readonly __typename?: 'TimeReportRecords';
  readonly absence: ReadonlyArray<AbsenceRecord>;
  readonly onCall: ReadonlyArray<OnCallRecord>;
  readonly work: ReadonlyArray<WorkRecord>;
  readonly workTags: ReadonlyArray<WorkTag>;
};

export type TimeReportStats = {
  readonly currentTimeBalance: TimeBalance;
  readonly incomeDetails: ReadonlyArray<IncomeDetails>;
  readonly overtime: Scalars['Minutes']['output'];
  readonly timeBalanceAtEndOfMonth: TimeBalance;
};

export type TimeReportValidation = IncompleteEntries | MissingEntries | NegativeFlexTimeBalance;

export type TrainingBudgetSummary = {
  readonly __typename?: 'TrainingBudgetSummary';
  readonly currency: Scalars['Currency']['output'];
  readonly yearlySummary: ReadonlyArray<KvYearTrainingBudgetYearSummary>;
};

export type TrainingBudgetSummaryOrNfsError = NfsError | TrainingBudgetSummary;

export type TrainingBudgetYearSummary = {
  readonly __typename?: 'TrainingBudgetYearSummary';
  readonly balanceThisYear: CentsBalance;
  readonly carriedOverEntitlementBalance?: Maybe<CentsBalance>;
  readonly totalBalance: CentsBalance;
  readonly year: Scalars['Year']['output'];
};

export type TrainingPackageBonus = Bonus & {
  readonly __typename?: 'TrainingPackageBonus';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type TrainingPackageExternalDeductionValue = Bonus & {
  readonly __typename?: 'TrainingPackageExternalDeductionValue';
  readonly allocateCostToProject?: Maybe<Project>;
  readonly amount: NetGross;
  readonly applyAt: Scalars['YearMonth']['output'];
  readonly approval: Approval;
  readonly contractId: Scalars['ContractId']['output'];
  readonly id: Scalars['BonusId']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly paidOutAt?: Maybe<Scalars['LocalDate']['output']>;
  readonly revoked?: Maybe<BonusRevocationReason>;
};

export type TransferDeduction = {
  readonly __typename?: 'TransferDeduction';
  readonly grossValue: Scalars['Cents']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
};

export const TransferState = {
  TRANSFEREXECUTED: 'TransferExecuted',
  TRANSFERORDERED: 'TransferOrdered'
} as const;

export type TransferState = typeof TransferState[keyof typeof TransferState];
export type UnauthorizedOperationError = UserError & {
  readonly __typename?: 'UnauthorizedOperationError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UnitResponse = {
  readonly __typename?: 'UnitResponse';
  readonly value: Scalars['Unit']['output'];
};

export type UnitResponseOrNfsError = NfsError | UnitResponse;

export type UnknownContentTypeError = UserError & {
  readonly __typename?: 'UnknownContentTypeError';
  readonly fileName: Scalars['String']['output'];
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UpdateCertificateInput = {
  readonly expirationDate?: InputMaybe<ClearableLocalDateInput>;
  readonly file?: InputMaybe<ClearableUploadInput>;
  readonly issueDate?: InputMaybe<ClearableLocalDateInput>;
};

export type UpdateInvoiceDetailsInput = {
  readonly file?: InputMaybe<ClearableUploadInput>;
  readonly number?: InputMaybe<ClearableInvoiceNumberInput>;
  readonly userNote?: InputMaybe<ClearableStringInput>;
};

export type User = {
  readonly __typename?: 'User';
  readonly address?: Maybe<Address>;
  readonly areaOfExpertise?: Maybe<Scalars['String']['output']>;
  readonly at?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly avatar?: Maybe<Scalars['URI']['output']>;
  readonly birthDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly certificates: ReadonlyArray<Certificate>;
  readonly citizenship?: Maybe<Scalars['CountryCode']['output']>;
  readonly consentedForUseOfImage: Scalars['Boolean']['output'];
  readonly contactEmail?: Maybe<Scalars['EmailAddress']['output']>;
  readonly contracts: ReadonlyArray<Contract>;
  readonly declaredNoCertificates: Scalars['Boolean']['output'];
  readonly directReporting: DirectReporting;
  readonly email: Scalars['EmailAddress']['output'];
  readonly emergencyContact?: Maybe<Scalars['String']['output']>;
  readonly entityVersion: Scalars['EntityVersion']['output'];
  readonly externalBeneficiaries: ReadonlyArray<ExternalBeneficiary>;
  readonly familyName?: Maybe<Scalars['String']['output']>;
  readonly firstName: Scalars['String']['output'];
  readonly fullName: Scalars['String']['output'];
  readonly id: Scalars['UserId']['output'];
  readonly idNumber?: Maybe<Scalars['String']['output']>;
  readonly idType?: Maybe<IdType>;
  readonly isStudent: Scalars['Boolean']['output'];
  readonly isStudentRevisionDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly mailingAddress?: Maybe<Address>;
  readonly middleName?: Maybe<Scalars['String']['output']>;
  readonly newestRateChangeDate?: Maybe<Scalars['OffsetDateTime']['output']>;
  readonly nextMedicalExaminationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly nextOhsTrainingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly office?: Maybe<Office>;
  readonly paczkomat?: Maybe<Scalars['String']['output']>;
  readonly passportExpirationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly personalDataProcessingAuthorization: Scalars['Boolean']['output'];
  readonly pesel?: Maybe<Scalars['PESEL']['output']>;
  readonly phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
  readonly plateNumber?: Maybe<Scalars['String']['output']>;
  readonly progressionLevel: TimeBasedOptClearableProgressionLevel;
  readonly revenueAdministrationOffice?: Maybe<RevenueAdministrationOffice>;
  readonly role: TimeBasedCompanyRole;
  readonly skillsAndCompetences: ReadonlyArray<Scalars['String']['output']>;
  readonly socialMediaHandles: ReadonlyArray<SocialMediaHandle>;
};

export type UserError = {
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UserFacingAuthzError = UserError & {
  readonly __typename?: 'UserFacingAuthzError';
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type UserOrNfsError = NfsError | User;

export type UserReportingApi = {
  readonly __typename?: 'UserReportingApi';
  readonly absenceRecord: AbsenceRecordApi;
  readonly bonus: BonusApi;
  readonly certificateApi: CertificateApi;
  readonly deleteTimeReports: UnitResponseOrNfsError;
  readonly invoiceDetailsApi: InvoiceDetailsApi;
  readonly oncallRecord: OnCallRecordApi;
  readonly setPreselectedFields: ContractResponseOrNfsError;
  readonly workRecord: WorkRecordApi;
  readonly workTransferProtocolApi: WorkTransferProtocolApi;
};


export type UserReportingApiDeleteTimeReportsArgs = {
  absenceRecordIds: ReadonlyArray<Scalars['AbsenceRecordId']['input']>;
  onCallRecordIds: ReadonlyArray<Scalars['OnCallRecordId']['input']>;
  workRecordIds: ReadonlyArray<Scalars['WorkRecordId']['input']>;
};


export type UserReportingApiSetPreselectedFieldsArgs = {
  contractId: Scalars['ContractId']['input'];
  fromTime?: InputMaybe<ClearableLocalTimeInput>;
  isRemoteWork?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<ClearablePreselectedProjectIdInput>;
  toTime?: InputMaybe<ClearableLocalTimeInput>;
  workTagId?: InputMaybe<ClearableWorkTagIdInput>;
};

export type ValidationError = UserError & {
  readonly __typename?: 'ValidationError';
  readonly desc: Scalars['String']['output'];
  readonly fields: ReadonlyArray<Scalars['String']['output']>;
  readonly msg: Scalars['String']['output'];
  readonly nfsErrorId: Scalars['NfsErrorId']['output'];
};

export type VatApplied = {
  readonly __typename?: 'VatApplied';
  readonly value: Scalars['BasisPoint']['output'];
};

export type VatNotApplied = {
  readonly __typename?: 'VatNotApplied';
  readonly reason: VatNotAppliedReason;
};

export const VatNotAppliedReason = {
  EXEMPTFROMVAT: 'ExemptFromVAT',
  VATNOTAPPLICABLE: 'VatNotApplicable'
} as const;

export type VatNotAppliedReason = typeof VatNotAppliedReason[keyof typeof VatNotAppliedReason];
export type VatType = VatApplied | VatNotApplied;

export type WeekdayDayAndNightMultipliers = {
  readonly __typename?: 'WeekdayDayAndNightMultipliers';
  readonly day: WeekendMultipliers;
  readonly night: WeekdayMultipliers;
};

export type WeekdayMultipliers = {
  readonly __typename?: 'WeekdayMultipliers';
  readonly friday: OnCallMultiplier;
  readonly monday: OnCallMultiplier;
  readonly saturday: OnCallMultiplier;
  readonly sunday: OnCallMultiplier;
  readonly thursday: OnCallMultiplier;
  readonly tuesday: OnCallMultiplier;
  readonly wednesday: OnCallMultiplier;
};

export type WeekendMultipliers = {
  readonly __typename?: 'WeekendMultipliers';
  readonly saturday: OnCallMultiplier;
  readonly sunday: OnCallMultiplier;
};

export type WorkRecord = {
  readonly __typename?: 'WorkRecord';
  readonly approval: Approval;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly contractId: Scalars['ContractId']['output'];
  readonly date: Scalars['LocalDate']['output'];
  readonly draft: Scalars['Boolean']['output'];
  readonly duration?: Maybe<Scalars['Minutes']['output']>;
  readonly id: Scalars['WorkRecordId']['output'];
  readonly overtime: Scalars['Boolean']['output'];
  readonly project?: Maybe<Project>;
  readonly remoteWork: Scalars['Boolean']['output'];
  readonly workTag: WorkTag;
  readonly workTime?: Maybe<WorkTime>;
};

export type WorkRecordApi = {
  readonly __typename?: 'WorkRecordApi';
  readonly createMany: ListOfWorkRecordResponseOrNfsError;
  readonly update: WorkRecordOrNfsError;
};


export type WorkRecordApiCreateManyArgs = {
  value: ReadonlyArray<CreateWorkRecordInput>;
};


export type WorkRecordApiUpdateArgs = {
  comment?: InputMaybe<ClearableStringInput>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  duration?: InputMaybe<ClearableMinutesInput>;
  id: Scalars['WorkRecordId']['input'];
  overtime?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<ClearableProjectIdInput>;
  remoteWork?: InputMaybe<Scalars['Boolean']['input']>;
  workTagId?: InputMaybe<Scalars['WorkTagId']['input']>;
  workTime?: InputMaybe<ClearableWorkTimeInput>;
};

export type WorkRecordOrNfsError = NfsError | WorkRecord;

export type WorkTag = {
  readonly __typename?: 'WorkTag';
  readonly canBeOvertime: Scalars['Boolean']['output'];
  readonly canHaveProjectSelected: Scalars['Boolean']['output'];
  readonly canHaveRecurringWorkRecords: Scalars['Boolean']['output'];
  readonly id: Scalars['WorkTagId']['output'];
  readonly name: Scalars['String']['output'];
  readonly yearlyHoursLimit?: Maybe<Scalars['Hours']['output']>;
};

export type WorkTime = {
  readonly __typename?: 'WorkTime';
  readonly break?: Maybe<Scalars['Minutes']['output']>;
  readonly timeFrom: Scalars['LocalTime']['output'];
  readonly timeTo?: Maybe<Scalars['LocalTime']['output']>;
};

export type WorkTimeInput = {
  readonly break?: InputMaybe<Scalars['Minutes']['input']>;
  readonly timeFrom: Scalars['LocalTime']['input'];
  readonly timeTo?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type WorkTransferProtocol = {
  readonly __typename?: 'WorkTransferProtocol';
  readonly approval: Approval;
  readonly contractSalaryDetailsId: ContractSalaryDetailsId;
  readonly createdAt: Scalars['OffsetDateTime']['output'];
  readonly createdBy: Scalars['EmailAddress']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['WorkTransferProtocolId']['output'];
  readonly payload: WorkTransferProtocolPayload;
};

export type WorkTransferProtocolApi = {
  readonly __typename?: 'WorkTransferProtocolApi';
  readonly create: WorkTransferProtocolOrNfsError;
  readonly markNoWorkToBeTransferedThisMonth: WorkTransferProtocolOrNfsError;
  readonly remove: BooleanResponseOrNfsError;
  readonly update: WorkTransferProtocolOrNfsError;
};


export type WorkTransferProtocolApiCreateArgs = {
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['WorkTransferProtocolId']['input'];
  payload: Scalars['Upload']['input'];
};


export type WorkTransferProtocolApiMarkNoWorkToBeTransferedThisMonthArgs = {
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
};


export type WorkTransferProtocolApiRemoveArgs = {
  id: Scalars['WorkTransferProtocolId']['input'];
};


export type WorkTransferProtocolApiUpdateArgs = {
  description?: InputMaybe<ClearableStringInput>;
  id: Scalars['WorkTransferProtocolId']['input'];
  payload?: InputMaybe<Scalars['Upload']['input']>;
};

export type WorkTransferProtocolOrNfsError = NfsError | WorkTransferProtocol;

export type WorkTransferProtocolPayload = File | NoWorkToBeTransferedThisMonth;

export type WorkingTime = {
  readonly __typename?: 'WorkingTime';
  readonly denominator: Scalars['Int']['output'];
  readonly friday?: Maybe<Scalars['Minutes']['output']>;
  readonly monday?: Maybe<Scalars['Minutes']['output']>;
  readonly numerator: Scalars['Int']['output'];
  readonly saturday?: Maybe<Scalars['Minutes']['output']>;
  readonly thursday?: Maybe<Scalars['Minutes']['output']>;
  readonly tuesday?: Maybe<Scalars['Minutes']['output']>;
  readonly wednesday?: Maybe<Scalars['Minutes']['output']>;
};

export type ZusContributionDetails = {
  readonly __typename?: 'ZusContributionDetails';
  readonly employeeSocialContribution: Scalars['Cents']['output'];
  readonly employerSocialContribution: Scalars['Cents']['output'];
  readonly healthInsuranceContribution: Scalars['Cents']['output'];
};

export type AdditionalCostDrawerBonusAppreciationBonusFragment = { readonly __typename?: 'AppreciationBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusBusinessTravelBonusFragment = { readonly __typename?: 'BusinessTravelBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusClientReferralBonusFragment = { readonly __typename?: 'ClientReferralBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusConferenceBonusFragment = { readonly __typename?: 'ConferenceBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusCostRechargeBonusFragment = { readonly __typename?: 'CostRechargeBonus', readonly description: string, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusEmployeeReferralBonusFragment = { readonly __typename?: 'EmployeeReferralBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusLanguageLearningBonusFragment = { readonly __typename?: 'LanguageLearningBonus', readonly language: Language, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly quarterYear: { readonly __typename?: 'QuarterYear', readonly quarter: Quarter, readonly year: number }, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusOtherBonusFragment = { readonly __typename?: 'OtherBonus', readonly description: string, readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment = { readonly __typename?: 'RemoteWorkEquipmentBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusSalesCommissionsBonusFragment = { readonly __typename?: 'SalesCommissionsBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusSeverancePayBonusFragment = { readonly __typename?: 'SeverancePayBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusShareholderDividendBonusFragment = { readonly __typename?: 'ShareholderDividendBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusTrainingPackageBonusFragment = { readonly __typename?: 'TrainingPackageBonus', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment = { readonly __typename?: 'TrainingPackageExternalDeductionValue', readonly applyAt: Date, readonly id: string, readonly note?: string | null, readonly revoked?: BonusRevocationReason | null, readonly paidOutAt?: Date | null, readonly allocateCostToProject?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type AdditionalCostDrawerBonusFragment =
  | AdditionalCostDrawerBonusAppreciationBonusFragment
  | AdditionalCostDrawerBonusBusinessTravelBonusFragment
  | AdditionalCostDrawerBonusClientReferralBonusFragment
  | AdditionalCostDrawerBonusConferenceBonusFragment
  | AdditionalCostDrawerBonusCostRechargeBonusFragment
  | AdditionalCostDrawerBonusEmployeeReferralBonusFragment
  | AdditionalCostDrawerBonusLanguageLearningBonusFragment
  | AdditionalCostDrawerBonusOtherBonusFragment
  | AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
  | AdditionalCostDrawerBonusSalesCommissionsBonusFragment
  | AdditionalCostDrawerBonusSeverancePayBonusFragment
  | AdditionalCostDrawerBonusShareholderDividendBonusFragment
  | AdditionalCostDrawerBonusTrainingPackageBonusFragment
  | AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
;

export type UserAdditionalCostsDrawerQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type UserAdditionalCostsDrawerQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly bonuses: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
              | (
                { readonly __typename?: 'AppreciationBonus' }
                & AdditionalCostDrawerBonusAppreciationBonusFragment
              )
              | (
                { readonly __typename?: 'BusinessTravelBonus' }
                & AdditionalCostDrawerBonusBusinessTravelBonusFragment
              )
              | (
                { readonly __typename?: 'ClientReferralBonus' }
                & AdditionalCostDrawerBonusClientReferralBonusFragment
              )
              | (
                { readonly __typename?: 'ConferenceBonus' }
                & AdditionalCostDrawerBonusConferenceBonusFragment
              )
              | (
                { readonly __typename?: 'CostRechargeBonus' }
                & AdditionalCostDrawerBonusCostRechargeBonusFragment
              )
              | (
                { readonly __typename?: 'EmployeeReferralBonus' }
                & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
              )
              | (
                { readonly __typename?: 'LanguageLearningBonus' }
                & AdditionalCostDrawerBonusLanguageLearningBonusFragment
              )
              | (
                { readonly __typename?: 'OtherBonus' }
                & AdditionalCostDrawerBonusOtherBonusFragment
              )
              | (
                { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
              )
              | (
                { readonly __typename?: 'SalesCommissionsBonus' }
                & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
              )
              | (
                { readonly __typename?: 'SeverancePayBonus' }
                & AdditionalCostDrawerBonusSeverancePayBonusFragment
              )
              | (
                { readonly __typename?: 'ShareholderDividendBonus' }
                & AdditionalCostDrawerBonusShareholderDividendBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageBonus' }
                & AdditionalCostDrawerBonusTrainingPackageBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
              )
            >, readonly future: ReadonlyArray<
              | (
                { readonly __typename?: 'AppreciationBonus' }
                & AdditionalCostDrawerBonusAppreciationBonusFragment
              )
              | (
                { readonly __typename?: 'BusinessTravelBonus' }
                & AdditionalCostDrawerBonusBusinessTravelBonusFragment
              )
              | (
                { readonly __typename?: 'ClientReferralBonus' }
                & AdditionalCostDrawerBonusClientReferralBonusFragment
              )
              | (
                { readonly __typename?: 'ConferenceBonus' }
                & AdditionalCostDrawerBonusConferenceBonusFragment
              )
              | (
                { readonly __typename?: 'CostRechargeBonus' }
                & AdditionalCostDrawerBonusCostRechargeBonusFragment
              )
              | (
                { readonly __typename?: 'EmployeeReferralBonus' }
                & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
              )
              | (
                { readonly __typename?: 'LanguageLearningBonus' }
                & AdditionalCostDrawerBonusLanguageLearningBonusFragment
              )
              | (
                { readonly __typename?: 'OtherBonus' }
                & AdditionalCostDrawerBonusOtherBonusFragment
              )
              | (
                { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
              )
              | (
                { readonly __typename?: 'SalesCommissionsBonus' }
                & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
              )
              | (
                { readonly __typename?: 'SeverancePayBonus' }
                & AdditionalCostDrawerBonusSeverancePayBonusFragment
              )
              | (
                { readonly __typename?: 'ShareholderDividendBonus' }
                & AdditionalCostDrawerBonusShareholderDividendBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageBonus' }
                & AdditionalCostDrawerBonusTrainingPackageBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
              )
            > } }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly bonuses: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
              | (
                { readonly __typename?: 'AppreciationBonus' }
                & AdditionalCostDrawerBonusAppreciationBonusFragment
              )
              | (
                { readonly __typename?: 'BusinessTravelBonus' }
                & AdditionalCostDrawerBonusBusinessTravelBonusFragment
              )
              | (
                { readonly __typename?: 'ClientReferralBonus' }
                & AdditionalCostDrawerBonusClientReferralBonusFragment
              )
              | (
                { readonly __typename?: 'ConferenceBonus' }
                & AdditionalCostDrawerBonusConferenceBonusFragment
              )
              | (
                { readonly __typename?: 'CostRechargeBonus' }
                & AdditionalCostDrawerBonusCostRechargeBonusFragment
              )
              | (
                { readonly __typename?: 'EmployeeReferralBonus' }
                & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
              )
              | (
                { readonly __typename?: 'LanguageLearningBonus' }
                & AdditionalCostDrawerBonusLanguageLearningBonusFragment
              )
              | (
                { readonly __typename?: 'OtherBonus' }
                & AdditionalCostDrawerBonusOtherBonusFragment
              )
              | (
                { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
              )
              | (
                { readonly __typename?: 'SalesCommissionsBonus' }
                & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
              )
              | (
                { readonly __typename?: 'SeverancePayBonus' }
                & AdditionalCostDrawerBonusSeverancePayBonusFragment
              )
              | (
                { readonly __typename?: 'ShareholderDividendBonus' }
                & AdditionalCostDrawerBonusShareholderDividendBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageBonus' }
                & AdditionalCostDrawerBonusTrainingPackageBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
              )
            >, readonly future: ReadonlyArray<
              | (
                { readonly __typename?: 'AppreciationBonus' }
                & AdditionalCostDrawerBonusAppreciationBonusFragment
              )
              | (
                { readonly __typename?: 'BusinessTravelBonus' }
                & AdditionalCostDrawerBonusBusinessTravelBonusFragment
              )
              | (
                { readonly __typename?: 'ClientReferralBonus' }
                & AdditionalCostDrawerBonusClientReferralBonusFragment
              )
              | (
                { readonly __typename?: 'ConferenceBonus' }
                & AdditionalCostDrawerBonusConferenceBonusFragment
              )
              | (
                { readonly __typename?: 'CostRechargeBonus' }
                & AdditionalCostDrawerBonusCostRechargeBonusFragment
              )
              | (
                { readonly __typename?: 'EmployeeReferralBonus' }
                & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
              )
              | (
                { readonly __typename?: 'LanguageLearningBonus' }
                & AdditionalCostDrawerBonusLanguageLearningBonusFragment
              )
              | (
                { readonly __typename?: 'OtherBonus' }
                & AdditionalCostDrawerBonusOtherBonusFragment
              )
              | (
                { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
              )
              | (
                { readonly __typename?: 'SalesCommissionsBonus' }
                & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
              )
              | (
                { readonly __typename?: 'SeverancePayBonus' }
                & AdditionalCostDrawerBonusSeverancePayBonusFragment
              )
              | (
                { readonly __typename?: 'ShareholderDividendBonus' }
                & AdditionalCostDrawerBonusShareholderDividendBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageBonus' }
                & AdditionalCostDrawerBonusTrainingPackageBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
              )
            > } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly bonuses: { readonly __typename?: 'Bonuses', readonly paidOut: ReadonlyArray<
              | (
                { readonly __typename?: 'AppreciationBonus' }
                & AdditionalCostDrawerBonusAppreciationBonusFragment
              )
              | (
                { readonly __typename?: 'BusinessTravelBonus' }
                & AdditionalCostDrawerBonusBusinessTravelBonusFragment
              )
              | (
                { readonly __typename?: 'ClientReferralBonus' }
                & AdditionalCostDrawerBonusClientReferralBonusFragment
              )
              | (
                { readonly __typename?: 'ConferenceBonus' }
                & AdditionalCostDrawerBonusConferenceBonusFragment
              )
              | (
                { readonly __typename?: 'CostRechargeBonus' }
                & AdditionalCostDrawerBonusCostRechargeBonusFragment
              )
              | (
                { readonly __typename?: 'EmployeeReferralBonus' }
                & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
              )
              | (
                { readonly __typename?: 'LanguageLearningBonus' }
                & AdditionalCostDrawerBonusLanguageLearningBonusFragment
              )
              | (
                { readonly __typename?: 'OtherBonus' }
                & AdditionalCostDrawerBonusOtherBonusFragment
              )
              | (
                { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
              )
              | (
                { readonly __typename?: 'SalesCommissionsBonus' }
                & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
              )
              | (
                { readonly __typename?: 'SeverancePayBonus' }
                & AdditionalCostDrawerBonusSeverancePayBonusFragment
              )
              | (
                { readonly __typename?: 'ShareholderDividendBonus' }
                & AdditionalCostDrawerBonusShareholderDividendBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageBonus' }
                & AdditionalCostDrawerBonusTrainingPackageBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
              )
            >, readonly future: ReadonlyArray<
              | (
                { readonly __typename?: 'AppreciationBonus' }
                & AdditionalCostDrawerBonusAppreciationBonusFragment
              )
              | (
                { readonly __typename?: 'BusinessTravelBonus' }
                & AdditionalCostDrawerBonusBusinessTravelBonusFragment
              )
              | (
                { readonly __typename?: 'ClientReferralBonus' }
                & AdditionalCostDrawerBonusClientReferralBonusFragment
              )
              | (
                { readonly __typename?: 'ConferenceBonus' }
                & AdditionalCostDrawerBonusConferenceBonusFragment
              )
              | (
                { readonly __typename?: 'CostRechargeBonus' }
                & AdditionalCostDrawerBonusCostRechargeBonusFragment
              )
              | (
                { readonly __typename?: 'EmployeeReferralBonus' }
                & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
              )
              | (
                { readonly __typename?: 'LanguageLearningBonus' }
                & AdditionalCostDrawerBonusLanguageLearningBonusFragment
              )
              | (
                { readonly __typename?: 'OtherBonus' }
                & AdditionalCostDrawerBonusOtherBonusFragment
              )
              | (
                { readonly __typename?: 'RemoteWorkEquipmentBonus' }
                & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
              )
              | (
                { readonly __typename?: 'SalesCommissionsBonus' }
                & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
              )
              | (
                { readonly __typename?: 'SeverancePayBonus' }
                & AdditionalCostDrawerBonusSeverancePayBonusFragment
              )
              | (
                { readonly __typename?: 'ShareholderDividendBonus' }
                & AdditionalCostDrawerBonusShareholderDividendBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageBonus' }
                & AdditionalCostDrawerBonusTrainingPackageBonusFragment
              )
              | (
                { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
                & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
              )
            > } }
       }
    | { readonly __typename?: 'NfsError' }
   };

export type UserAdditionalCostDrawerRequestBonusMutationVariables = Exact<{
  input: BonusInput;
}>;


export type UserAdditionalCostDrawerRequestBonusMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly bonus: { readonly __typename?: 'BonusApi', readonly requestBonus:
        | { readonly __typename?: 'BonusResponse', readonly value:
            | (
              { readonly __typename?: 'AppreciationBonus' }
              & AdditionalCostDrawerBonusAppreciationBonusFragment
            )
            | (
              { readonly __typename?: 'BusinessTravelBonus' }
              & AdditionalCostDrawerBonusBusinessTravelBonusFragment
            )
            | (
              { readonly __typename?: 'ClientReferralBonus' }
              & AdditionalCostDrawerBonusClientReferralBonusFragment
            )
            | (
              { readonly __typename?: 'ConferenceBonus' }
              & AdditionalCostDrawerBonusConferenceBonusFragment
            )
            | (
              { readonly __typename?: 'CostRechargeBonus' }
              & AdditionalCostDrawerBonusCostRechargeBonusFragment
            )
            | (
              { readonly __typename?: 'EmployeeReferralBonus' }
              & AdditionalCostDrawerBonusEmployeeReferralBonusFragment
            )
            | (
              { readonly __typename?: 'LanguageLearningBonus' }
              & AdditionalCostDrawerBonusLanguageLearningBonusFragment
            )
            | (
              { readonly __typename?: 'OtherBonus' }
              & AdditionalCostDrawerBonusOtherBonusFragment
            )
            | (
              { readonly __typename?: 'RemoteWorkEquipmentBonus' }
              & AdditionalCostDrawerBonusRemoteWorkEquipmentBonusFragment
            )
            | (
              { readonly __typename?: 'SalesCommissionsBonus' }
              & AdditionalCostDrawerBonusSalesCommissionsBonusFragment
            )
            | (
              { readonly __typename?: 'SeverancePayBonus' }
              & AdditionalCostDrawerBonusSeverancePayBonusFragment
            )
            | (
              { readonly __typename?: 'ShareholderDividendBonus' }
              & AdditionalCostDrawerBonusShareholderDividendBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageBonus' }
              & AdditionalCostDrawerBonusTrainingPackageBonusFragment
            )
            | (
              { readonly __typename?: 'TrainingPackageExternalDeductionValue' }
              & AdditionalCostDrawerBonusTrainingPackageExternalDeductionValueFragment
            )
           }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserAdditionalCostDrawerDeleteMutationVariables = Exact<{
  id: Scalars['BonusId']['input'];
}>;


export type UserAdditionalCostDrawerDeleteMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly bonus: { readonly __typename?: 'BonusApi', readonly bonus: { readonly __typename?: 'BonusMutation', readonly delete:
          | (
            { readonly __typename?: 'NfsError' }
            & NfsErrorFragment
          )
          | { readonly __typename?: 'UnitResponse' }
         } } } };

export type BenefitSectionsExternalBeneficiaryFragment = { readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) };

export type UserBenefitSectionsBenefitVariantFragment = { readonly __typename?: 'BenefitVariant', readonly id: string, readonly productId: string, readonly startDate: Date, readonly endDate?: Date | null, readonly buyerType: BenefitBuyerType, readonly contractTypes: ReadonlyArray<ContractType>, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
      { readonly __typename?: 'BenefitVariantRate' }
      & BenefitVariantRateFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBenefitVariantRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBenefitVariantRate', readonly value?: (
          { readonly __typename?: 'BenefitVariantRate' }
          & BenefitVariantRateFragment
        ) | null } }> }, readonly parent:
    | { readonly __typename?: 'Benefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string, readonly benefitParent: BenefitGroupType }
    | { readonly __typename?: 'SubBenefit', readonly id: string, readonly name: string, readonly alternativeBenefitsGroupId: string }
  , readonly additionalPeople?:
    | (
      { readonly __typename?: 'BenefitAdditionalAdults' }
      & BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalFamily' }
      & BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
    )
    | (
      { readonly __typename?: 'BenefitAdditionalKids' }
      & BenefitAdditionalPeopleBenefitAdditionalKidsFragment
    )
   | null };

export type UserBenefitSectionsAssignedVariantFragment = { readonly __typename?: 'AssignedVariant', readonly id: string, readonly invoiceTo: { readonly __typename?: 'TimeBasedOptClearableExternalBeneficiary', readonly value?: (
      { readonly __typename?: 'ExternalBeneficiary' }
      & ExternalBeneficiaryFragment
    ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
          { readonly __typename?: 'ExternalBeneficiary' }
          & ExternalBeneficiaryFragment
        ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableExternalBeneficiary', readonly value?: (
          { readonly __typename?: 'ExternalBeneficiary' }
          & ExternalBeneficiaryFragment
        ) | null } }> }, readonly externalBeneficiaries: { readonly __typename?: 'TimeBasedListOfExternalBeneficiary', readonly value: ReadonlyArray<(
      { readonly __typename?: 'ExternalBeneficiary' }
      & ExternalBeneficiaryFragment
    )>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
        { readonly __typename?: 'ExternalBeneficiary' }
        & ExternalBeneficiaryFragment
      )> }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantListOfExternalBeneficiary', readonly applyDate: Date, readonly activityId: string, readonly value: ReadonlyArray<(
        { readonly __typename?: 'ExternalBeneficiary' }
        & ExternalBeneficiaryFragment
      )> }> }, readonly buyerType: { readonly __typename?: 'TimeBasedBenefitBuyerType', readonly value: BenefitBuyerType, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date, readonly activityId: string, readonly value: BenefitBuyerType }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitBuyerType', readonly applyDate: Date }> }, readonly active: { readonly __typename?: 'TimeBasedBoolean', readonly value: boolean, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBoolean', readonly applyDate: Date, readonly activityId: string, readonly value: boolean }> }, readonly variant: { readonly __typename?: 'TimeBasedBenefitVariant', readonly value: (
      { readonly __typename?: 'BenefitVariant' }
      & UserBenefitSectionsBenefitVariantFragment
    ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
        { readonly __typename?: 'BenefitVariant' }
        & UserBenefitSectionsBenefitVariantFragment
      ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantBenefitVariant', readonly applyDate: Date, readonly activityId: string, readonly value: (
        { readonly __typename?: 'BenefitVariant' }
        & UserBenefitSectionsBenefitVariantFragment
      ) }> } };

export type UserBenefitSectionsAssignedBenefitVariantsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type UserBenefitSectionsAssignedBenefitVariantsQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly startDate: Date, readonly conclusionDate: Date, readonly terminationDate?: Date | null, readonly assignedVariants: ReadonlyArray<(
            { readonly __typename?: 'AssignedVariant' }
            & UserBenefitSectionsAssignedVariantFragment
          )> }
        | { readonly __typename?: 'EmploymentContract', readonly id: string, readonly startDate: Date, readonly conclusionDate: Date, readonly terminationDate?: Date | null, readonly assignedVariants: ReadonlyArray<(
            { readonly __typename?: 'AssignedVariant' }
            & UserBenefitSectionsAssignedVariantFragment
          )> }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date, readonly conclusionDate: Date, readonly terminationDate?: Date | null }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CopyrightsDrawerSalaryFragment = { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly workTransferProtocols: ReadonlyArray<(
    { readonly __typename?: 'WorkTransferProtocol' }
    & CopyrightsDrawerWorkTransferFragment
  )> };

export type CopyrightsDrawerCopyrightsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type CopyrightsDrawerCopyrightsQuery = { readonly __typename?: 'Query', readonly contractSalaryDetailsInRange:
    | { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
        | { readonly __typename?: 'B2BContractSalaryDetails' }
        | (
          { readonly __typename?: 'EmploymentContractSalaryDetails' }
          & CopyrightsDrawerSalaryFragment
        )
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CopyrightsDrawerWorkTransferFragment = { readonly __typename?: 'WorkTransferProtocol', readonly id: string, readonly description?: string | null, readonly payload:
    | { readonly __typename?: 'File', readonly value: { readonly __typename?: 'DownloadableFileUrl', readonly url: string, readonly fileName: string } }
    | { readonly __typename?: 'NoWorkToBeTransferedThisMonth' }
  , readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
   };

export type UserCopyrightsDrawerUpdateWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<ClearableStringInput>;
  payload?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UserCopyrightsDrawerUpdateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly workTransferProtocolApi: { readonly __typename?: 'WorkTransferProtocolApi', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type UserCopyrightsDrawerCreateWorkTransferMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
  id: Scalars['WorkTransferProtocolId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['Upload']['input'];
}>;


export type UserCopyrightsDrawerCreateWorkTransferMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly workTransferProtocolApi: { readonly __typename?: 'WorkTransferProtocolApi', readonly create:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type UserCopyrightsDrawerRemoveWorkTransferMutationVariables = Exact<{
  id: Scalars['WorkTransferProtocolId']['input'];
}>;


export type UserCopyrightsDrawerRemoveWorkTransferMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly workTransferProtocolApi: { readonly __typename?: 'WorkTransferProtocolApi', readonly remove:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserCopyrightsDrawerMarkNoWorkMutationVariables = Exact<{
  contractSalaryDetailsId: ContractSalaryDetailsIdInput;
}>;


export type UserCopyrightsDrawerMarkNoWorkMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly workTransferProtocolApi: { readonly __typename?: 'WorkTransferProtocolApi', readonly markNoWorkToBeTransferedThisMonth:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkTransferProtocol' }
          & CopyrightsDrawerWorkTransferFragment
        )
       } } };

export type CopyrightsTrButtonQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type CopyrightsTrButtonQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & CopyrightTrButtonContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & CopyrightTrButtonContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & CopyrightTrButtonContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type CopyrightTrButtonContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string };

export type CopyrightTrButtonContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly copyrightCosts: { readonly __typename?: 'TimeBasedOptClearableBasisPoint', readonly value?: number | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableBasisPoint', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableBasisPoint', readonly value?: number | null } }> } };

export type CopyrightTrButtonContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string };

export type CopyrightTrButtonContractFragment =
  | CopyrightTrButtonContractB2BContractFragment
  | CopyrightTrButtonContractEmploymentContractFragment
  | CopyrightTrButtonContractSubcontractFragment
;

export type DirectReportingStructureUserFragment = { readonly __typename?: 'Person', readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: CompanyRole };

export type UserDirectReportingStructureQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDirectReportingStructureQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly role: { readonly __typename?: 'TimeBasedCompanyRole', readonly value: CompanyRole, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCompanyRole', readonly activityId: string, readonly applyDate: Date, readonly value: CompanyRole }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCompanyRole', readonly activityId: string, readonly applyDate: Date, readonly value: CompanyRole }> }, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly activeProjects: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }>, readonly primaryProjectId: { readonly __typename?: 'TimeBasedOptClearableProjectId', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProjectId', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProjectId', readonly value?: string | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProjectId', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableProjectId', readonly value?: string | null } }> }, readonly operationalLead: { readonly __typename?: 'TimeBasedOptClearablePerson', readonly value?: (
            { readonly __typename?: 'Person' }
            & DirectReportingStructureUserFragment
          ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearablePerson', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearablePerson', readonly value?: (
                { readonly __typename?: 'Person' }
                & DirectReportingStructureUserFragment
              ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearablePerson', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearablePerson', readonly value?: (
                { readonly __typename?: 'Person' }
                & DirectReportingStructureUserFragment
              ) | null } }> }, readonly practiceLead: { readonly __typename?: 'TimeBasedOptClearablePerson', readonly value?: (
            { readonly __typename?: 'Person' }
            & DirectReportingStructureUserFragment
          ) | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearablePerson', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearablePerson', readonly value?: (
                { readonly __typename?: 'Person' }
                & DirectReportingStructureUserFragment
              ) | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearablePerson', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearablePerson', readonly value?: (
                { readonly __typename?: 'Person' }
                & DirectReportingStructureUserFragment
              ) | null } }> }, readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: (
              { readonly __typename?: 'Person' }
              & DirectReportingStructureUserFragment
            ) }, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: (
                { readonly __typename?: 'Person' }
                & DirectReportingStructureUserFragment
              ) } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantSpace', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'Space', readonly id: string, readonly name: string, readonly owner: (
                { readonly __typename?: 'Person' }
                & DirectReportingStructureUserFragment
              ) } }> } } }
   };

export type InvoicesDrawerSalaryFragment = { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
    | (
      { readonly __typename?: 'IncompleteData' }
      & InvoicesDrawerSalaryStateIncompleteDataFragment
    )
    | (
      { readonly __typename?: 'PaymentDisbursed' }
      & InvoicesDrawerSalaryStatePaymentDisbursedFragment
    )
    | (
      { readonly __typename?: 'Ready' }
      & InvoicesDrawerSalaryStateReadyFragment
    )
  , readonly invoiceDetails: ReadonlyArray<(
    { readonly __typename?: 'InvoiceDetails' }
    & InvoicesDrawerInvoiceDetailsFragment
  )> };

export type InvoicesDrawerInvoicesQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type InvoicesDrawerInvoicesQuery = { readonly __typename?: 'Query', readonly contractSalaryDetailsInRange:
    | { readonly __typename?: 'ListOfContractSalaryDetailsResponse', readonly value: ReadonlyArray<
        | (
          { readonly __typename?: 'B2BContractSalaryDetails' }
          & InvoicesDrawerSalaryFragment
        )
        | { readonly __typename?: 'EmploymentContractSalaryDetails' }
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type InvoicesDrawerSalaryStateIncompleteDataFragment = { readonly __typename: 'IncompleteData' };

export type InvoicesDrawerSalaryStatePaymentDisbursedFragment = { readonly __typename: 'PaymentDisbursed', readonly transferState: TransferState };

export type InvoicesDrawerSalaryStateReadyFragment = { readonly __typename: 'Ready' };

export type InvoicesDrawerSalaryStateFragment =
  | InvoicesDrawerSalaryStateIncompleteDataFragment
  | InvoicesDrawerSalaryStatePaymentDisbursedFragment
  | InvoicesDrawerSalaryStateReadyFragment
;

export type InvoicesDrawerInvoiceDetailsFragment = { readonly __typename?: 'InvoiceDetails', readonly id: string, readonly correct?: boolean | null, readonly number?: string | null, readonly userNote?: string | null, readonly ksefNumber?: string | null, readonly grossValue?: number | null, readonly currency?: string | null, readonly file?: { readonly __typename?: 'DownloadableFileUrl', readonly url: string, readonly fileName: string } | null };

export type UserInvoicesDrawerUpdateInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
  invoiceDetails: UpdateInvoiceDetailsInput;
}>;


export type UserInvoicesDrawerUpdateInvoiceMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly invoiceDetailsApi: { readonly __typename?: 'InvoiceDetailsApi', readonly updateInvoiceDetails:
        | (
          { readonly __typename?: 'InvoiceDetails' }
          & InvoicesDrawerInvoiceDetailsFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserInvoicesDrawerCreateInvoiceMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  yearMonth: Scalars['YearMonth']['input'];
  invoiceDetails: CreateInvoiceDetailsInput;
}>;


export type UserInvoicesDrawerCreateInvoiceMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly invoiceDetailsApi: { readonly __typename?: 'InvoiceDetailsApi', readonly createInvoiceDetails:
        | (
          { readonly __typename?: 'InvoiceDetails' }
          & InvoicesDrawerInvoiceDetailsFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserInvoicesDrawerRemoveInvoiceMutationVariables = Exact<{
  invoiceDetailsId: Scalars['InvoiceDetailsId']['input'];
}>;


export type UserInvoicesDrawerRemoveInvoiceMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly invoiceDetailsApi: { readonly __typename?: 'InvoiceDetailsApi', readonly removeInvoiceDetails:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserProjectsColorsProviderAllProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProjectsColorsProviderAllProjectsQuery = { readonly __typename?: 'Query', readonly projects:
    | { readonly __typename?: 'ListOfProjectIdResponse', readonly value: ReadonlyArray<string> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UserTimeReportBlockedMessageSpaceOwnerQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTimeReportBlockedMessageSpaceOwnerQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly space: { readonly __typename?: 'TimeBasedSpace', readonly value: { readonly __typename?: 'Space', readonly id: string, readonly owner: { readonly __typename?: 'Person', readonly avatar?: string | null, readonly email: string, readonly firstName: string, readonly lastName: string } } } } }
   };

export type TimeReportBulkEditToolbarDeleteSelectedMutationVariables = Exact<{
  workRecordIds: ReadonlyArray<Scalars['WorkRecordId']['input']> | Scalars['WorkRecordId']['input'];
  onCallRecordIds: ReadonlyArray<Scalars['OnCallRecordId']['input']> | Scalars['OnCallRecordId']['input'];
  absenceRecordIds: ReadonlyArray<Scalars['AbsenceRecordId']['input']> | Scalars['AbsenceRecordId']['input'];
}>;


export type TimeReportBulkEditToolbarDeleteSelectedMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type TimeReportDashBoardProviderTimeReportValidationsIncompleteEntriesFragment = { readonly __typename?: 'IncompleteEntries', readonly days: ReadonlyArray<Date> };

export type TimeReportDashBoardProviderTimeReportValidationsMissingEntriesFragment = { readonly __typename?: 'MissingEntries', readonly days: ReadonlyArray<Date> };

export type TimeReportDashBoardProviderTimeReportValidationsNegativeFlexTimeBalanceFragment = { readonly __typename?: 'NegativeFlexTimeBalance', readonly minutes: number };

export type TimeReportDashBoardProviderTimeReportValidationsFragment =
  | TimeReportDashBoardProviderTimeReportValidationsIncompleteEntriesFragment
  | TimeReportDashBoardProviderTimeReportValidationsMissingEntriesFragment
  | TimeReportDashBoardProviderTimeReportValidationsNegativeFlexTimeBalanceFragment
;

export type TimeReportDashBoardProviderAbsenceTypeDetailsFragment = { readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails', readonly key: AbsenceType, readonly value: { readonly __typename?: 'AbsenceTypeDetails', readonly canBeReportedOnHoliday: boolean, readonly applicableFor: ReadonlyArray<ContractType>, readonly canTakeCustomNumberOfHours: boolean, readonly limit?: number | null } };

export type TimeReportDashBoardProviderOnCallFragment = { readonly __typename?: 'TimeBasedOptClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly holiday: { readonly __typename?: 'NetGross', readonly net: number } } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly holiday: { readonly __typename?: 'NetGross', readonly net: number } } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly holiday: { readonly __typename?: 'NetGross', readonly net: number } } | null } }> };

export type TimeReportDashBoardProviderOvertimeRateFragment = { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: { readonly __typename?: 'NetGross', readonly net: number } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: { readonly __typename?: 'NetGross', readonly net: number } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: { readonly __typename?: 'NetGross', readonly net: number } | null } }> };

export type TimeReportDashBoardProviderTimeBasedRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement }, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly value: { readonly __typename?: 'Rate', readonly settlement: Settlement } }> };

export type TimeReportDashboardProviderValidationsQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
}>;


export type TimeReportDashboardProviderValidationsQuery = { readonly __typename?: 'Query', readonly timeReportValidations:
    | { readonly __typename?: 'ListOfTimeReportValidationResponse', readonly value: ReadonlyArray<
        | (
          { readonly __typename?: 'IncompleteEntries' }
          & TimeReportDashBoardProviderTimeReportValidationsIncompleteEntriesFragment
        )
        | (
          { readonly __typename?: 'MissingEntries' }
          & TimeReportDashBoardProviderTimeReportValidationsMissingEntriesFragment
        )
        | (
          { readonly __typename?: 'NegativeFlexTimeBalance' }
          & TimeReportDashBoardProviderTimeReportValidationsNegativeFlexTimeBalanceFragment
        )
      > }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UserTimeReportDashboardProviderContractInfoQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type UserTimeReportDashboardProviderContractInfoQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | { readonly __typename?: 'B2BContract', readonly enableTrainingPackage: boolean, readonly id: string, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly preselectedFromTime?: Date | null, readonly preselectedToTime?: Date | null, readonly overtimeRate: (
            { readonly __typename?: 'TimeBasedOptClearableNetGross' }
            & TimeReportDashBoardProviderOvertimeRateFragment
          ), readonly onCall: (
            { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
            & TimeReportDashBoardProviderOnCallFragment
          ), readonly rate: (
            { readonly __typename?: 'TimeBasedRate' }
            & TimeReportDashBoardProviderTimeBasedRateFragment
          ), readonly preselectedWorkTag?: { readonly __typename?: 'WorkTag', readonly id: string } | null, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> }, readonly preselectedProject?: { readonly __typename?: 'PreselectedProject', readonly value?: { readonly __typename?: 'Project', readonly id: string } | null } | null }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly enableTrainingPackage: boolean, readonly preselectedIsRemoteWork?: boolean | null, readonly id: string, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly preselectedFromTime?: Date | null, readonly preselectedToTime?: Date | null, readonly overtimeRate: (
            { readonly __typename?: 'TimeBasedOptClearableNetGross' }
            & TimeReportDashBoardProviderOvertimeRateFragment
          ), readonly onCall: (
            { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
            & TimeReportDashBoardProviderOnCallFragment
          ), readonly rate: (
            { readonly __typename?: 'TimeBasedRate' }
            & TimeReportDashBoardProviderTimeBasedRateFragment
          ), readonly workingTime: { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
              { readonly __typename?: 'WorkingTime' }
              & WorkingTimeFragment
            ), readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
                { readonly __typename?: 'WorkingTime' }
                & WorkingTimeFragment
              ) }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
                { readonly __typename?: 'WorkingTime' }
                & WorkingTimeFragment
              ) }> }, readonly preselectedWorkTag?: { readonly __typename?: 'WorkTag', readonly id: string } | null, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> }, readonly preselectedProject?: { readonly __typename?: 'PreselectedProject', readonly value?: { readonly __typename?: 'Project', readonly id: string } | null } | null }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly preselectedFromTime?: Date | null, readonly preselectedToTime?: Date | null, readonly preselectedWorkTag?: { readonly __typename?: 'WorkTag', readonly id: string } | null, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendar', readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> }, readonly preselectedProject?: { readonly __typename?: 'PreselectedProject', readonly value?: { readonly __typename?: 'Project', readonly id: string } | null } | null }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type UserTimeReportDashboardProviderQueryVariables = Exact<{
  dashboardFrom: Scalars['LocalDate']['input'];
  dashboardTo: Scalars['LocalDate']['input'];
  projectsFrom: Scalars['OffsetDateTime']['input'];
  projectsTo: Scalars['OffsetDateTime']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type UserTimeReportDashboardProviderQuery = { readonly __typename?: 'Query', readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportRecords: { readonly __typename?: 'TimeReportRecords', readonly workTags: ReadonlyArray<(
          { readonly __typename?: 'WorkTag' }
          & WorkTagFragment
        )>, readonly work: ReadonlyArray<(
          { readonly __typename?: 'WorkRecord' }
          & WorkRecordFragment
        )>, readonly absence: ReadonlyArray<(
          { readonly __typename?: 'AbsenceRecord' }
          & AbsenceRecordFragment
        )>, readonly onCall: ReadonlyArray<(
          { readonly __typename?: 'OnCallRecord' }
          & OnCallRecordFragment
        )> }, readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats' }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly flexTime?: { readonly __typename?: 'TimeBalance', readonly period: { readonly __typename?: 'ClosedEndMonthRange', readonly from: Date, readonly to: Date } } | null }
       | null }
  , readonly assignedProjects:
    | { readonly __typename?: 'ListOfAssignedProjectResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'AssignedProject', readonly projectId: string, readonly projectName: string, readonly activeReportingRange?: { readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date } | null, readonly assignmentPeriods: ReadonlyArray<{ readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }>, readonly reportingPeriods: ReadonlyArray<{ readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly defaultActiveReportingRange?:
    | { readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null, readonly absenceReportingRange?:
    | { readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null, readonly absenceTypeDetails: ReadonlyArray<(
    { readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails' }
    & TimeReportDashBoardProviderAbsenceTypeDetailsFragment
  )> };

export type TimeReportEntryModalAnnualLeaveSummaryFragment = { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly onDemandBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ) } }> };

export type TimeReportEntryModalCreateWorkRecordMutationVariables = Exact<{
  workRecords: ReadonlyArray<CreateWorkRecordInput> | CreateWorkRecordInput;
}>;


export type TimeReportEntryModalCreateWorkRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly createMany:
        | { readonly __typename?: 'ListOfWorkRecordResponse', readonly value: ReadonlyArray<(
            { readonly __typename?: 'WorkRecord' }
            & WorkRecordFragment
          )> }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type TimeReportEntryModalUpdateWorkRecordMutationVariables = Exact<{
  workRecordId: Scalars['WorkRecordId']['input'];
  projectId?: InputMaybe<ClearableProjectIdInput>;
  workTagId?: InputMaybe<Scalars['WorkTagId']['input']>;
  date: Scalars['LocalDate']['input'];
  duration?: InputMaybe<ClearableMinutesInput>;
  workTime?: InputMaybe<ClearableWorkTimeInput>;
  overtime: Scalars['Boolean']['input'];
  comment?: InputMaybe<ClearableStringInput>;
  remoteWork: Scalars['Boolean']['input'];
}>;


export type TimeReportEntryModalUpdateWorkRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly workRecord: { readonly __typename?: 'WorkRecordApi', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'WorkRecord' }
          & WorkRecordFragment
        )
       } } };

export type TimeReportEntryModalDeleteWorkRecordMutationVariables = Exact<{
  workRecordId: Scalars['WorkRecordId']['input'];
}>;


export type TimeReportEntryModalDeleteWorkRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type TimeReportEntryModalCreateOnCallRecordMutationVariables = Exact<{
  onCallRecords: ReadonlyArray<CreateOnCallRecordInput> | CreateOnCallRecordInput;
}>;


export type TimeReportEntryModalCreateOnCallRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly oncallRecord: { readonly __typename?: 'OnCallRecordApi', readonly createMany:
        | { readonly __typename?: 'ListOfOnCallRecordResponse', readonly value: ReadonlyArray<(
            { readonly __typename?: 'OnCallRecord' }
            & OnCallRecordFragment
          )> }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type TimeReportEntryModalUpdateOnCallRecordMutationVariables = Exact<{
  onCallRecordId: Scalars['OnCallRecordId']['input'];
  projectId: Scalars['ProjectId']['input'];
  date: Scalars['LocalDate']['input'];
  dayShift: Scalars['Boolean']['input'];
  nightShift: Scalars['Boolean']['input'];
  comment?: InputMaybe<ClearableStringInput>;
}>;


export type TimeReportEntryModalUpdateOnCallRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly oncallRecord: { readonly __typename?: 'OnCallRecordApi', readonly update:
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
        | (
          { readonly __typename?: 'OnCallRecord' }
          & OnCallRecordFragment
        )
       } } };

export type TimeReportEntryModalDeleteOnCallRecordMutationVariables = Exact<{
  onCallRecordId: Scalars['OnCallRecordId']['input'];
}>;


export type TimeReportEntryModalDeleteOnCallRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type TimeReportEntryModalDeleteAbsenceRecordMutationVariables = Exact<{
  absenceRecordId: Scalars['AbsenceRecordId']['input'];
}>;


export type TimeReportEntryModalDeleteAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly deleteTimeReports:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'UnitResponse', readonly value: Record<never, never> }
     } };

export type UserTimeReportEntryModalLimitsQueryVariables = Exact<{
  year: Scalars['Year']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  contractId: Scalars['ContractId']['input'];
  hasAnnualLeave: Scalars['Boolean']['input'];
}>;


export type UserTimeReportEntryModalLimitsQuery = { readonly __typename?: 'Query', readonly remainingWorkTagReportingLimit:
    | { readonly __typename?: 'ListOfKVWorkTagIdMinutesResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'KVWorkTagIdMinutes', readonly key: string, readonly value?: number | null }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly paidLeaveBalanceYearlySummary?:
    | (
      { readonly __typename?: 'DaysBalance' }
      & LeaveBalanceFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null, readonly annualLeaveSummary?:
    | (
      { readonly __typename?: 'AnnualLeaveSummary' }
      & TimeReportEntryModalAnnualLeaveSummaryFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats' }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly reportedLeaveDays: (
            { readonly __typename?: 'ReportedLeaveDays' }
            & ReportedLeaveDaysFragment
          ) }
       | null }
   };

export type UserTimeReportEntryModalCreateSingularAbsenceRecordMutationVariables = Exact<{
  absenceRecord: CreateAbsenceRecordInput;
  attachment: Scalars['Upload']['input'];
}>;


export type UserTimeReportEntryModalCreateSingularAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly userCreate: { readonly __typename?: 'UserReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly create:
        | (
          { readonly __typename?: 'AbsenceRecord' }
          & AbsenceRecordFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserTimeReportEntryModalUpdateAbsenceRecordMutationVariables = Exact<{
  id: Scalars['AbsenceRecordId']['input'];
  absenceType?: InputMaybe<AbsenceTypeInput>;
  dateFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  dateTo?: InputMaybe<Scalars['LocalDate']['input']>;
  comment?: InputMaybe<ClearableStringInput>;
  customDurationPerDay?: InputMaybe<ClearableMinutesInput>;
  isOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  attachment?: InputMaybe<ClearableUploadInput>;
}>;


export type UserTimeReportEntryModalUpdateAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly userUpdate: { readonly __typename?: 'UserReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly update:
        | (
          { readonly __typename?: 'AbsenceRecord' }
          & AbsenceRecordFragment
        )
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type UserTimeReportEntryModalCreateAbsenceRecordMutationVariables = Exact<{
  absenceRecords: ReadonlyArray<CreateAbsenceRecordInput> | CreateAbsenceRecordInput;
}>;


export type UserTimeReportEntryModalCreateAbsenceRecordMutation = { readonly __typename?: 'Mutation', readonly userCreate: { readonly __typename?: 'UserReportingApi', readonly absenceRecord: { readonly __typename?: 'AbsenceRecordApi', readonly createMany:
        | { readonly __typename?: 'ListOfAbsenceRecordResponse', readonly value: ReadonlyArray<(
            { readonly __typename?: 'AbsenceRecord' }
            & AbsenceRecordFragment
          )> }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type TimeReportFinancesSalaryDetailsFragment = { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
    | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null }
    | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly transferAmount?: number | null, readonly accountingData?: { readonly __typename?: 'AccountingData', readonly taxPrepayment: number, readonly zusContribution: number, readonly ppkAmount?: number | null } | null, readonly transferDeduction?: { readonly __typename?: 'TransferDeduction', readonly grossValue: number, readonly note?: string | null } | null }
   };

export type TimeReportFinancesBenefitValueFragment = { readonly __typename?: 'BenefitValue', readonly variant: { readonly __typename?: 'BenefitVariant', readonly id: string, readonly productId: string, readonly promiseeRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly promisorRate: { readonly __typename?: 'TimeBasedOptClearableBenefitVariantRate', readonly value?: (
        { readonly __typename?: 'BenefitVariantRate' }
        & BenefitVariantRateFragment
      ) | null }, readonly parent:
      | { readonly __typename?: 'Benefit', readonly id: string, readonly name: string }
      | { readonly __typename?: 'SubBenefit', readonly id: string, readonly name: string }
     }, readonly refundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly notRefundedValue?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly totalValue: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type TimeReportFinancesIncomeDetailsFragment = { readonly __typename?: 'IncomeDetails', readonly from: Date, readonly to: Date, readonly totalWorkTime: number, readonly overtimeWorkTime: number, readonly standardWorkTime: number, readonly rateDetails?: (
    { readonly __typename?: 'RateDetails' }
    & RateDetailsFragment
  ) | null, readonly remoteWorkReimbursement?: { readonly __typename?: 'RemoteWorkReimbursement', readonly time: number, readonly rate: number, readonly totalValue: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } | null, readonly totalPayout: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly payoutWithoutBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueStandardTimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncome: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly standardTimeIncome: ReadonlyArray<
    | (
      { readonly __typename?: 'DailyIncomeRow' }
      & IncomeRowDailyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'HourlyIncomeRow' }
      & IncomeRowHourlyIncomeRowFragment
    )
    | (
      { readonly __typename?: 'MonthlyIncomeRow' }
      & IncomeRowMonthlyIncomeRowFragment
    )
  >, readonly overtimeIncome: ReadonlyArray<(
    { readonly __typename?: 'HourlyIncomeRow' }
    & HourlyIncomeRowFragment
  )>, readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly multiplier: OnCallMultiplier, readonly shifts: number, readonly dates: ReadonlyArray<Date>, readonly shift: Shift, readonly multiplierRate: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly totalValue: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) }>, readonly totalValueOnCalls: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) }>, readonly totalValueStandardTimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueOvertimeIncomeIncludingBenefits: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly totalValueBonuses: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly benefitsValue: { readonly __typename?: 'BenefitsValue', readonly totalValueRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly refunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & TimeReportFinancesBenefitValueFragment
    )>, readonly totalValueNotRefunded: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly notRefunded: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & TimeReportFinancesBenefitValueFragment
    )>, readonly totalValueThirdParty: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly thirdParty: ReadonlyArray<(
      { readonly __typename?: 'BenefitValue' }
      & TimeReportFinancesBenefitValueFragment
    )>, readonly totalValueAll: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly refundedHourlyRate: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } };

export type TimeReportFinancesContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly rate: { readonly __typename?: 'TimeBasedRate', readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }, readonly overtimeRate: { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) | null } };

export type TimeReportFinancesContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly id: string, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly rate: { readonly __typename?: 'TimeBasedRate', readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }, readonly overtimeRate: { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) | null } };

export type TimeReportFinancesContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string };

export type TimeReportFinancesContractFragment =
  | TimeReportFinancesContractB2BContractFragment
  | TimeReportFinancesContractEmploymentContractFragment
  | TimeReportFinancesContractSubcontractFragment
;

export type UserTimeReportFinancesQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  month: Scalars['YearMonth']['input'];
}>;


export type UserTimeReportFinancesQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & TimeReportFinancesContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & TimeReportFinancesContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & TimeReportFinancesContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly contractSalaryDetails:
    | (
      { readonly __typename?: 'ContractSalaryDetailsResponse' }
      & TimeReportFinancesSalaryDetailsFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | { readonly __typename?: 'B2BTimeReportStats', readonly incomeDetails: ReadonlyArray<(
            { readonly __typename?: 'IncomeDetails' }
            & TimeReportFinancesIncomeDetailsFragment
          )> }
        | { readonly __typename?: 'EmploymentTimeReportStats', readonly incomeDetails: ReadonlyArray<(
            { readonly __typename?: 'IncomeDetails' }
            & TimeReportFinancesIncomeDetailsFragment
          )> }
       | null }
   };

export type TimeReportLeaveAndTrainingAnnualLeaveSummaryFragment = { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly balanceThisYear: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ), readonly carriedOverEntitlementBalance?: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ) | null, readonly onDemandBalance: (
        { readonly __typename?: 'AnnualLeaveBalance' }
        & AnnualLeaveBalanceFragment
      ) } }> };

export type TimeReportLeaveAndTrainingTrainingPackageFragment = { readonly __typename?: 'TrainingBudgetSummary', readonly currency: string, readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearTrainingBudgetYearSummary', readonly key: number, readonly value: { readonly __typename?: 'TrainingBudgetYearSummary', readonly year: number, readonly totalBalance: (
        { readonly __typename?: 'CentsBalance' }
        & CentsBalanceFragment
      ), readonly balanceThisYear: (
        { readonly __typename?: 'CentsBalance' }
        & CentsBalanceFragment
      ), readonly carriedOverEntitlementBalance?: (
        { readonly __typename?: 'CentsBalance' }
        & CentsBalanceFragment
      ) | null } }> };

export type TimeReportLeaveAndTrainingTimeReportFragment = { readonly __typename?: 'TimeReport', readonly timeReportStats?:
    | (
      { readonly __typename?: 'B2BTimeReportStats', readonly reportedDaysOff: number }
      & TimeReportLeaveAndTrainingStatsB2BTimeReportStatsFragment
    )
    | (
      { readonly __typename?: 'EmploymentTimeReportStats', readonly reportedLeaveDays: (
        { readonly __typename?: 'ReportedLeaveDays' }
        & ReportedLeaveDaysFragment
      ), readonly flexTime?: { readonly __typename?: 'TimeBalance', readonly balance: number, readonly absenceTime: number } | null }
      & TimeReportLeaveAndTrainingStatsEmploymentTimeReportStatsFragment
    )
   | null };

export type UserTimeReportLeaveAndTrainingQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  year: Scalars['Year']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
}>;


export type UserTimeReportLeaveAndTrainingQuery = { readonly __typename?: 'Query', readonly annualLeaveSummary:
    | (
      { readonly __typename?: 'AnnualLeaveSummary' }
      & TimeReportLeaveAndTrainingAnnualLeaveSummaryFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly paidLeaveBalanceYearlySummary?:
    | (
      { readonly __typename?: 'DaysBalance' }
      & LeaveBalanceFragment
    )
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   | null, readonly remainingWorkTagReportingLimit:
    | { readonly __typename?: 'ListOfKVWorkTagIdMinutesResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'KVWorkTagIdMinutes', readonly key: string, readonly value?: number | null }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'TimeReport' }
      & TimeReportLeaveAndTrainingTimeReportFragment
    )
  , readonly trainingBudgetSummary:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'TrainingBudgetSummary' }
      & TimeReportLeaveAndTrainingTrainingPackageFragment
    )
   };

export type TimeReportLeaveAndTrainingStatsB2BTimeReportStatsFragment = { readonly __typename?: 'B2BTimeReportStats', readonly incomeDetails: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly from: Date, readonly to: Date, readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number } }> }> };

export type TimeReportLeaveAndTrainingStatsEmploymentTimeReportStatsFragment = { readonly __typename?: 'EmploymentTimeReportStats', readonly incomeDetails: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly from: Date, readonly to: Date, readonly bonusesValueByCategory: ReadonlyArray<{ readonly __typename?: 'BonusCategoryAmount', readonly bonusCategory: BonusType, readonly amount: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number } }> }> };

export type TimeReportLeaveAndTrainingStatsFragment =
  | TimeReportLeaveAndTrainingStatsB2BTimeReportStatsFragment
  | TimeReportLeaveAndTrainingStatsEmploymentTimeReportStatsFragment
;

export type UserTimeReportOnCallDetailsModalQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTimeReportOnCallDetailsModalQuery = { readonly __typename?: 'Query', readonly onCallMultipliers:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OnCallMultipliers', readonly weekdays: { readonly __typename?: 'WeekdayDayAndNightMultipliers', readonly day: { readonly __typename?: 'WeekendMultipliers', readonly saturday: OnCallMultiplier, readonly sunday: OnCallMultiplier }, readonly night: { readonly __typename?: 'WeekdayMultipliers', readonly monday: OnCallMultiplier, readonly tuesday: OnCallMultiplier, readonly wednesday: OnCallMultiplier, readonly thursday: OnCallMultiplier, readonly friday: OnCallMultiplier, readonly saturday: OnCallMultiplier, readonly sunday: OnCallMultiplier } }, readonly holidays: { readonly __typename?: 'HolidayMultipliers', readonly beforeHolidayNight: OnCallMultiplier, readonly holidayDay: OnCallMultiplier, readonly holidayNight: OnCallMultiplier } }
   };

export type TimeReportStatsB2BStatsFragment = { readonly __typename?: 'B2BTimeReportStats', readonly reportedDaysOff: number, readonly overtime: number, readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number, readonly balance: number, readonly currentTimeRequirementWithAbsenceTimeSubtracted: number, readonly totalTimeInPeriod: number }, readonly incomeDetails: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly shifts: number, readonly multiplier: OnCallMultiplier, readonly dates: ReadonlyArray<Date>, readonly shift: Shift, readonly multiplierRate: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ), readonly totalValue: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) }> }> };

export type TimeReportStatsEmploymentStatsFragment = { readonly __typename?: 'EmploymentTimeReportStats', readonly overtime: number, readonly timeBalanceAtEndOfMonth: { readonly __typename?: 'TimeBalance', readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number, readonly balance: number, readonly currentTimeRequirementWithAbsenceTimeSubtracted: number, readonly totalTimeInPeriod: number }, readonly reportedLeaveDays: (
    { readonly __typename?: 'ReportedLeaveDays' }
    & ReportedLeaveDaysFragment
  ), readonly flexTime?: { readonly __typename?: 'TimeBalance', readonly balance: number, readonly reportedStandardWorkTime: number, readonly currentTimeRequirement: number, readonly totalTimeInPeriod: number, readonly period: { readonly __typename?: 'ClosedEndMonthRange', readonly from: Date, readonly to: Date } } | null, readonly incomeDetails: ReadonlyArray<{ readonly __typename?: 'IncomeDetails', readonly onCallLogs: ReadonlyArray<{ readonly __typename?: 'OnCallLog', readonly shifts: number, readonly multiplier: OnCallMultiplier, readonly dates: ReadonlyArray<Date>, readonly shift: Shift, readonly multiplierRate: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ), readonly totalValue: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) }> }> };

export type UserTimeReportStatsQueryVariables = Exact<{
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  year: Scalars['Year']['input'];
  contractId: Scalars['ContractId']['input'];
  hasAnnualLeave: Scalars['Boolean']['input'];
}>;


export type UserTimeReportStatsQuery = { readonly __typename?: 'Query', readonly annualLeaveSummary?:
    | { readonly __typename?: 'AnnualLeaveSummary', readonly yearlySummary: ReadonlyArray<{ readonly __typename?: 'KVYearAnnualLeaveYearSummary', readonly key: number, readonly value: { readonly __typename?: 'AnnualLeaveYearSummary', readonly year: number, readonly totalBalance: (
            { readonly __typename?: 'AnnualLeaveBalance' }
            & AnnualLeaveBalanceFragment
          ) } }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportStats?:
        | (
          { readonly __typename?: 'B2BTimeReportStats' }
          & TimeReportStatsB2BStatsFragment
        )
        | (
          { readonly __typename?: 'EmploymentTimeReportStats' }
          & TimeReportStatsEmploymentStatsFragment
        )
       | null }
   };

export type TimeReportWorkTimeInsightsQueryVariables = Exact<{
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type TimeReportWorkTimeInsightsQuery = { readonly __typename?: 'Query', readonly timeReport:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'TimeReport', readonly timeReportRecords: { readonly __typename?: 'TimeReportRecords', readonly work: ReadonlyArray<{ readonly __typename?: 'WorkRecord', readonly id: string, readonly duration?: number | null, readonly remoteWork: boolean, readonly overtime: boolean, readonly workTag: { readonly __typename?: 'WorkTag', readonly id: string, readonly name: string }, readonly project?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null }>, readonly onCall: ReadonlyArray<{ readonly __typename?: 'OnCallRecord', readonly id: string }> }, readonly timeReportStats?:
        | (
          { readonly __typename?: 'B2BTimeReportStats', readonly currentTimeBalance: { readonly __typename?: 'TimeBalance', readonly currentTimeRequirement: number, readonly balance: number, readonly reportedStandardWorkTime: number, readonly absenceTime: number } }
          & TimeReportStatsB2BStatsFragment
        )
        | (
          { readonly __typename?: 'EmploymentTimeReportStats', readonly currentTimeBalance: { readonly __typename?: 'TimeBalance', readonly currentTimeRequirement: number, readonly balance: number, readonly reportedStandardWorkTime: number, readonly absenceTime: number } }
          & TimeReportStatsEmploymentStatsFragment
        )
       | null }
   };

export type NfsErrorFragment = { readonly __typename?: 'NfsError', readonly error:
    | { readonly __typename?: 'ActiveReportingRangeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'AggregatedValidationErrors', readonly nfsErrorId: string, readonly msg: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly fields: ReadonlyArray<string>, readonly desc: string }> }
    | { readonly __typename?: 'DuplicatedEntityError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EmptyRequestInputError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EntitiesNotFoundError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EntityNotFoundError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'EntityVersionMismatched', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ForeignKeyConstraintError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'IllegalPositionRemovalError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'IncompleteArgumentError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'IncompleteArgumentsError', readonly missingFields: ReadonlyArray<string>, readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InternalNfsError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidApiTokenError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidArgumentsError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidCompanyTypeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidContentTypeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidCursorError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidEmailAddress', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvalidStateError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvoiceAlreadyAcceptedError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'InvoiceImportedFromSaldeoError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'LeaveEntitlementExceededError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'MissingFileMetadataError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'NBPBaseCurrencyError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'NoParkingSpotAvailableError', readonly dates: ReadonlyArray<Date>, readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'OperationAlreadyInProgressError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'OperationNotAvailableError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'OtherInvalidRequestError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'PaymentCouldNotBeChangedError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'PositionInactiveError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'RaiseNoLongerDueError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ReservationNotPendingError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ReservationRequestStateError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ResourceAlreadyReservedError', readonly dates: ReadonlyArray<Date>, readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeBasedActivityOverlapError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeBasedEffectiveFromInPastError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeReportOverlapError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'TimeReportRecordApprovalNotInPendingStateError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'UnauthorizedOperationError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'UnknownContentTypeError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'UserFacingAuthzError', readonly nfsErrorId: string, readonly msg: string }
    | { readonly __typename?: 'ValidationError', readonly fields: ReadonlyArray<string>, readonly nfsErrorId: string, readonly msg: string }
   };

export type ApprovalApprovedFragment = { readonly __typename?: 'Approved', readonly at: Date, readonly by: { readonly __typename?: 'Admin', readonly id: string, readonly firstName: string, readonly lastName: string } };

export type ApprovalNotRequiredFragment = { readonly __typename?: 'NotRequired' };

export type ApprovalPendingApprovalFragment = { readonly __typename?: 'PendingApproval', readonly isCurrentUserAllowedToApprove: boolean };

export type ApprovalFragment =
  | ApprovalApprovedFragment
  | ApprovalNotRequiredFragment
  | ApprovalPendingApprovalFragment
;

export type AddressFragment = { readonly __typename?: 'Address', readonly country: string, readonly region?: string | null, readonly city: string, readonly postalCode?: string | null, readonly streetLine: string };

export type ExternalBeneficiaryFragment = { readonly __typename?: 'ExternalBeneficiary', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly address: (
    { readonly __typename?: 'Address' }
    & AddressFragment
  ) };

export type WorkRecordFragment = { readonly __typename?: 'WorkRecord', readonly id: string, readonly date: Date, readonly duration?: number | null, readonly overtime: boolean, readonly draft: boolean, readonly comment?: string | null, readonly remoteWork: boolean, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly workTag: { readonly __typename?: 'WorkTag', readonly id: string, readonly name: string }, readonly workTime?: { readonly __typename?: 'WorkTime', readonly timeFrom: Date, readonly timeTo?: Date | null, readonly break?: number | null } | null, readonly project?: { readonly __typename?: 'Project', readonly id: string, readonly name: string } | null };

export type OnCallRecordFragment = { readonly __typename?: 'OnCallRecord', readonly id: string, readonly date: Date, readonly dayShift: boolean, readonly nightShift: boolean, readonly comment?: string | null, readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } };

export type NetGrossFragment = { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number };

export type RateFragment = { readonly __typename?: 'Rate', readonly settlement: Settlement, readonly amount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type ChildLevel3AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer' }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel3BookDeskDrawerFragment = (
  { readonly __typename?: 'BookDeskDrawer' }
  & AbstractDrawerBookDeskDrawerFragment
);

export type ChildLevel3BookParkingDrawerFragment = (
  { readonly __typename?: 'BookParkingDrawer' }
  & AbstractDrawerBookParkingDrawerFragment
);

export type ChildLevel3CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer' }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel3EditAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditAdditionalDataDrawer' }
  & AbstractDrawerEditAdditionalDataDrawerFragment
);

export type ChildLevel3EditAddressDrawerFragment = (
  { readonly __typename?: 'EditAddressDrawer' }
  & AbstractDrawerEditAddressDrawerFragment
);

export type ChildLevel3EditProfileDetailsDrawerFragment = (
  { readonly __typename?: 'EditProfileDetailsDrawer' }
  & AbstractDrawerEditProfileDetailsDrawerFragment
);

export type ChildLevel3EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel3EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel3InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer' }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel3TimeReportPreferencesDrawerFragment = (
  { readonly __typename?: 'TimeReportPreferencesDrawer' }
  & AbstractDrawerTimeReportPreferencesDrawerFragment
);

export type ChildLevel3Fragment =
  | ChildLevel3AdditionalCostsDrawerFragment
  | ChildLevel3BookDeskDrawerFragment
  | ChildLevel3BookParkingDrawerFragment
  | ChildLevel3CopyrightsDrawerFragment
  | ChildLevel3EditAdditionalDataDrawerFragment
  | ChildLevel3EditAddressDrawerFragment
  | ChildLevel3EditProfileDetailsDrawerFragment
  | ChildLevel3EditSkillsAndCertificatesDrawerFragment
  | ChildLevel3EditSocialMediaHandlesDrawerFragment
  | ChildLevel3InvoicesDrawerFragment
  | ChildLevel3TimeReportPreferencesDrawerFragment
;

export type ChildLevel2AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer', readonly child?: ChildLevel3Fragment | null }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel2BookDeskDrawerFragment = (
  { readonly __typename?: 'BookDeskDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBookDeskDrawerFragment
);

export type ChildLevel2BookParkingDrawerFragment = (
  { readonly __typename?: 'BookParkingDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerBookParkingDrawerFragment
);

export type ChildLevel2CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel2EditAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditAdditionalDataDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditAdditionalDataDrawerFragment
);

export type ChildLevel2EditAddressDrawerFragment = (
  { readonly __typename?: 'EditAddressDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditAddressDrawerFragment
);

export type ChildLevel2EditProfileDetailsDrawerFragment = (
  { readonly __typename?: 'EditProfileDetailsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditProfileDetailsDrawerFragment
);

export type ChildLevel2EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel2EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel2InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel2TimeReportPreferencesDrawerFragment = (
  { readonly __typename?: 'TimeReportPreferencesDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerTimeReportPreferencesDrawerFragment
);

export type ChildLevel2Fragment =
  | ChildLevel2AdditionalCostsDrawerFragment
  | ChildLevel2BookDeskDrawerFragment
  | ChildLevel2BookParkingDrawerFragment
  | ChildLevel2CopyrightsDrawerFragment
  | ChildLevel2EditAdditionalDataDrawerFragment
  | ChildLevel2EditAddressDrawerFragment
  | ChildLevel2EditProfileDetailsDrawerFragment
  | ChildLevel2EditSkillsAndCertificatesDrawerFragment
  | ChildLevel2EditSocialMediaHandlesDrawerFragment
  | ChildLevel2InvoicesDrawerFragment
  | ChildLevel2TimeReportPreferencesDrawerFragment
;

export type ChildLevel1AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer', readonly child?: ChildLevel2Fragment | null }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel1BookDeskDrawerFragment = (
  { readonly __typename?: 'BookDeskDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBookDeskDrawerFragment
);

export type ChildLevel1BookParkingDrawerFragment = (
  { readonly __typename?: 'BookParkingDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerBookParkingDrawerFragment
);

export type ChildLevel1CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel1EditAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditAdditionalDataDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditAdditionalDataDrawerFragment
);

export type ChildLevel1EditAddressDrawerFragment = (
  { readonly __typename?: 'EditAddressDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditAddressDrawerFragment
);

export type ChildLevel1EditProfileDetailsDrawerFragment = (
  { readonly __typename?: 'EditProfileDetailsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditProfileDetailsDrawerFragment
);

export type ChildLevel1EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel1EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel1InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel1TimeReportPreferencesDrawerFragment = (
  { readonly __typename?: 'TimeReportPreferencesDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerTimeReportPreferencesDrawerFragment
);

export type ChildLevel1Fragment =
  | ChildLevel1AdditionalCostsDrawerFragment
  | ChildLevel1BookDeskDrawerFragment
  | ChildLevel1BookParkingDrawerFragment
  | ChildLevel1CopyrightsDrawerFragment
  | ChildLevel1EditAdditionalDataDrawerFragment
  | ChildLevel1EditAddressDrawerFragment
  | ChildLevel1EditProfileDetailsDrawerFragment
  | ChildLevel1EditSkillsAndCertificatesDrawerFragment
  | ChildLevel1EditSocialMediaHandlesDrawerFragment
  | ChildLevel1InvoicesDrawerFragment
  | ChildLevel1TimeReportPreferencesDrawerFragment
;

export type ChildLevel0AdditionalCostsDrawerFragment = (
  { readonly __typename?: 'AdditionalCostsDrawer', readonly child?: ChildLevel1Fragment | null }
  & AbstractDrawerAdditionalCostsDrawerFragment
);

export type ChildLevel0BookDeskDrawerFragment = (
  { readonly __typename?: 'BookDeskDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBookDeskDrawerFragment
);

export type ChildLevel0BookParkingDrawerFragment = (
  { readonly __typename?: 'BookParkingDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerBookParkingDrawerFragment
);

export type ChildLevel0CopyrightsDrawerFragment = (
  { readonly __typename?: 'CopyrightsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerCopyrightsDrawerFragment
);

export type ChildLevel0EditAdditionalDataDrawerFragment = (
  { readonly __typename?: 'EditAdditionalDataDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditAdditionalDataDrawerFragment
);

export type ChildLevel0EditAddressDrawerFragment = (
  { readonly __typename?: 'EditAddressDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditAddressDrawerFragment
);

export type ChildLevel0EditProfileDetailsDrawerFragment = (
  { readonly __typename?: 'EditProfileDetailsDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditProfileDetailsDrawerFragment
);

export type ChildLevel0EditSkillsAndCertificatesDrawerFragment = (
  { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditSkillsAndCertificatesDrawerFragment
);

export type ChildLevel0EditSocialMediaHandlesDrawerFragment = (
  { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerEditSocialMediaHandlesDrawerFragment
);

export type ChildLevel0InvoicesDrawerFragment = (
  { readonly __typename?: 'InvoicesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerInvoicesDrawerFragment
);

export type ChildLevel0TimeReportPreferencesDrawerFragment = (
  { readonly __typename?: 'TimeReportPreferencesDrawer', readonly child?: ChildLevel0Fragment | null }
  & AbstractDrawerTimeReportPreferencesDrawerFragment
);

export type ChildLevel0Fragment =
  | ChildLevel0AdditionalCostsDrawerFragment
  | ChildLevel0BookDeskDrawerFragment
  | ChildLevel0BookParkingDrawerFragment
  | ChildLevel0CopyrightsDrawerFragment
  | ChildLevel0EditAdditionalDataDrawerFragment
  | ChildLevel0EditAddressDrawerFragment
  | ChildLevel0EditProfileDetailsDrawerFragment
  | ChildLevel0EditSkillsAndCertificatesDrawerFragment
  | ChildLevel0EditSocialMediaHandlesDrawerFragment
  | ChildLevel0InvoicesDrawerFragment
  | ChildLevel0TimeReportPreferencesDrawerFragment
;

export type BenefitVariantRateFragment = { readonly __typename?: 'BenefitVariantRate', readonly period: BenefitBillingPeriod, readonly vat:
    | (
      { readonly __typename?: 'VatApplied' }
      & VatTypeVatAppliedFragment
    )
    | (
      { readonly __typename?: 'VatNotApplied' }
      & VatTypeVatNotAppliedFragment
    )
  , readonly netGross: { readonly __typename?: 'NetGross', readonly net: number, readonly gross: number } };

export type BenefitAdditionalPeopleBenefitAdditionalAdultsFragment = { readonly __typename?: 'BenefitAdditionalAdults', readonly adults: AdditionalPeopleNumber };

export type BenefitAdditionalPeopleBenefitAdditionalFamilyFragment = { readonly __typename?: 'BenefitAdditionalFamily', readonly adults: AdditionalPeopleNumber, readonly kids: AdditionalPeopleNumber };

export type BenefitAdditionalPeopleBenefitAdditionalKidsFragment = { readonly __typename?: 'BenefitAdditionalKids', readonly kids: AdditionalPeopleNumber };

export type BenefitAdditionalPeopleFragment =
  | BenefitAdditionalPeopleBenefitAdditionalAdultsFragment
  | BenefitAdditionalPeopleBenefitAdditionalFamilyFragment
  | BenefitAdditionalPeopleBenefitAdditionalKidsFragment
;

export type WorkTagFragment = { readonly __typename?: 'WorkTag', readonly id: string, readonly name: string, readonly canBeOvertime: boolean, readonly canHaveProjectSelected: boolean, readonly canHaveRecurringWorkRecords: boolean };

export type WorkingTimeFragment = { readonly __typename?: 'WorkingTime', readonly numerator: number, readonly denominator: number, readonly monday?: number | null, readonly tuesday?: number | null, readonly wednesday?: number | null, readonly thursday?: number | null, readonly friday?: number | null, readonly saturday?: number | null };

export type AnnualLeaveEntitlementValueFragment = { readonly __typename?: 'AnnualLeaveEntitlementValue', readonly days: number, readonly minutes: number };

export type VatTypeVatAppliedFragment = { readonly __typename?: 'VatApplied', readonly value: number };

export type VatTypeVatNotAppliedFragment = { readonly __typename?: 'VatNotApplied', readonly reason: VatNotAppliedReason };

export type VatTypeFragment =
  | VatTypeVatAppliedFragment
  | VatTypeVatNotAppliedFragment
;

export type ReportedLeaveDaysFragment = { readonly __typename?: 'ReportedLeaveDays', readonly outOfOffice: number, readonly sickLeave: number, readonly sickFamilyMemberCare: number, readonly paid: number, readonly unpaid: number, readonly special: number, readonly maternity: number, readonly paternity: number, readonly caregiving: number, readonly childCare: number, readonly dueToForceMajeure: number, readonly parental: number, readonly annual: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ) };

export type AnnualLeaveBalanceFragment = { readonly __typename?: 'AnnualLeaveBalance', readonly entitlement: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ), readonly used: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ), readonly available: (
    { readonly __typename?: 'AnnualLeaveEntitlementValue' }
    & AnnualLeaveEntitlementValueFragment
  ) };

export type LeaveBalanceFragment = { readonly __typename?: 'DaysBalance', readonly entitlement: number, readonly used: number, readonly available: number };

export type CentsBalanceFragment = { readonly __typename?: 'CentsBalance', readonly entitlement: number, readonly used: number, readonly available: number };

export type DailyIncomeRowFragment = { readonly __typename?: 'DailyIncomeRow', readonly workDays: number, readonly value: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly rateAmount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type HourlyIncomeRowFragment = { readonly __typename?: 'HourlyIncomeRow', readonly workHours: number, readonly rateAmount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly rateIncreaseDueToRefundedBenefits?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly valueWithoutRateIncrease: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ), readonly valueIncludingRateIncrease: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type MonthlyIncomeRowFragment = { readonly __typename?: 'MonthlyIncomeRow', readonly rateAmount: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) };

export type IncomeRowDailyIncomeRowFragment = (
  { readonly __typename?: 'DailyIncomeRow' }
  & DailyIncomeRowFragment
);

export type IncomeRowHourlyIncomeRowFragment = (
  { readonly __typename?: 'HourlyIncomeRow' }
  & HourlyIncomeRowFragment
);

export type IncomeRowMonthlyIncomeRowFragment = (
  { readonly __typename?: 'MonthlyIncomeRow' }
  & MonthlyIncomeRowFragment
);

export type IncomeRowFragment =
  | IncomeRowDailyIncomeRowFragment
  | IncomeRowHourlyIncomeRowFragment
  | IncomeRowMonthlyIncomeRowFragment
;

export type RateDetailsFragment = { readonly __typename?: 'RateDetails', readonly vat?: number | null, readonly currency: string, readonly rate: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ), readonly overtimeRate?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly rateIncreaseDueToRefundedBenefits?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null };

export type AbsenceRecordFragment = { readonly __typename?: 'AbsenceRecord', readonly id: string, readonly absenceType: AbsenceType, readonly from: Date, readonly to: Date, readonly comment?: string | null, readonly customDurationPerDay?: number | null, readonly isOnDemand?: boolean | null, readonly approval:
    | (
      { readonly __typename?: 'Approved' }
      & ApprovalApprovedFragment
    )
    | (
      { readonly __typename?: 'NotRequired' }
      & ApprovalNotRequiredFragment
    )
    | (
      { readonly __typename?: 'PendingApproval' }
      & ApprovalPendingApprovalFragment
    )
  , readonly attachment?: { readonly __typename?: 'DownloadableFileUrl', readonly url: string, readonly fileName: string } | null };

export type UserPreviousMonthSalaryStateQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  date: Scalars['YearMonth']['input'];
}>;


export type UserPreviousMonthSalaryStateQuery = { readonly __typename?: 'Query', readonly contractSalaryDetails:
    | { readonly __typename?: 'ContractSalaryDetailsResponse', readonly value:
        | { readonly __typename?: 'B2BContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | { readonly __typename: 'IncompleteData' }
            | { readonly __typename: 'PaymentDisbursed' }
            | { readonly __typename: 'Ready' }
           }
        | { readonly __typename?: 'EmploymentContractSalaryDetails', readonly contractId: string, readonly yearMonth: Date, readonly salaryState:
            | { readonly __typename: 'IncompleteData' }
            | { readonly __typename: 'PaymentDisbursed' }
            | { readonly __typename: 'Ready' }
           }
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type BookDeskDrawerRoomFragment = { readonly __typename?: 'ReservableRoom', readonly id: string, readonly name: string, readonly desks: ReadonlyArray<{ readonly __typename?: 'ReservableDesk', readonly id: string, readonly name: string, readonly monitors: number, readonly standing: boolean }> };

export type BookDeskDrawerInputQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type BookDeskDrawerInputQuery = { readonly __typename?: 'Query', readonly reservableOffices:
    | { readonly __typename?: 'ListOfReservableOfficeResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ReservableOffice', readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null, readonly blocked: boolean }, readonly rooms: ReadonlyArray<(
          { readonly __typename?: 'ReservableRoom' }
          & BookDeskDrawerRoomFragment
        )> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly officeReservationLimits:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeReservationSettings', readonly deskMaxDays: number, readonly deskMaxAdvanceDays: number, readonly parkingMaxAdvanceDays: number }
  , readonly officeAvailability:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeAvailability', readonly desks: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }> }
   };

export type BookDeskDrawerReserveMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
  roomId: Scalars['RoomId']['input'];
  deskIds: ReadonlyArray<Scalars['DeskId']['input']> | Scalars['DeskId']['input'];
  range: ClosedEndLocalDateRangeInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  guestEmails: ReadonlyArray<Scalars['EmailAddress']['input']> | Scalars['EmailAddress']['input'];
}>;


export type BookDeskDrawerReserveMutation = { readonly __typename?: 'Mutation', readonly officeReservations: { readonly __typename?: 'OfficeReservationsApi', readonly reserveDesks:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
     } };

export type BookParkingDrawerSpotFragment = { readonly __typename?: 'ReservableParkingSpot', readonly id: string, readonly number: string, readonly name: string, readonly guest: boolean };

export type BookParkingDrawerInputQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
}>;


export type BookParkingDrawerInputQuery = { readonly __typename?: 'Query', readonly reservableOffices:
    | { readonly __typename?: 'ListOfReservableOfficeResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ReservableOffice', readonly parkingInformation?: string | null, readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null, readonly blocked: boolean }, readonly parkingSpots: ReadonlyArray<(
          { readonly __typename?: 'ReservableParkingSpot' }
          & BookParkingDrawerSpotFragment
        )> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly officeReservationLimits:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeReservationSettings', readonly deskMaxAdvanceDays: number, readonly parkingMaxAdvanceDays: number, readonly parkingMaxDays: number }
  , readonly officeAvailability:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeAvailability', readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }> }
  , readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly plateNumber?: string | null }
   };

export type BookParkingDrawerReserveMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
  officeId: Scalars['OfficeId']['input'];
  parkingSpotId?: InputMaybe<Scalars['ParkingSpotId']['input']>;
  range: ClosedEndLocalDateRangeInput;
  plateNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  guestEmails: ReadonlyArray<Scalars['EmailAddress']['input']> | Scalars['EmailAddress']['input'];
}>;


export type BookParkingDrawerReserveMutation = { readonly __typename?: 'Mutation', readonly officeReservations: { readonly __typename?: 'OfficeReservationsApi', readonly reserveParking:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
     } };

export type EditAdditionalDataDrawerInputQueryVariables = Exact<{ [key: string]: never; }>;


export type EditAdditionalDataDrawerInputQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly passportExpirationDate?: Date | null }
   };

export type EditAdditionalDataDrawerUpdateMutationVariables = Exact<{
  passportExpirationDate?: InputMaybe<ClearableLocalDateInput>;
}>;


export type EditAdditionalDataDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateProfile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly passportExpirationDate?: Date | null }
   };

export type EditAddressDrawerInputQueryVariables = Exact<{ [key: string]: never; }>;


export type EditAddressDrawerInputQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly contactEmail?: string | null, readonly phoneNumber?: string | null, readonly paczkomat?: string | null, readonly plateNumber?: string | null, readonly emergencyContact?: string | null, readonly address?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null, readonly mailingAddress?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
   };

export type EditAddressDrawerUpdateMutationVariables = Exact<{
  mailingAddress?: InputMaybe<ClearableAddressInput>;
  contactEmail?: InputMaybe<ClearableEmailAddressInput>;
  phoneNumber?: InputMaybe<ClearablePhoneNumberInput>;
  paczkomat?: InputMaybe<ClearableStringInput>;
  plateNumber?: InputMaybe<ClearableStringInput>;
  emergencyContact?: InputMaybe<ClearableStringInput>;
}>;


export type EditAddressDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateProfile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly contactEmail?: string | null, readonly phoneNumber?: string | null, readonly paczkomat?: string | null, readonly plateNumber?: string | null, readonly emergencyContact?: string | null, readonly address?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null, readonly mailingAddress?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null }
   };

export type EditProfileDetailsDrawerInputQueryVariables = Exact<{ [key: string]: never; }>;


export type EditProfileDetailsDrawerInputQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly areaOfExpertise?: string | null }
   };

export type EditProfileDetailsDrawerUpdateMutationVariables = Exact<{
  area?: InputMaybe<ClearableStringInput>;
}>;


export type EditProfileDetailsDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateProfile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly areaOfExpertise?: string | null }
   };

export type EditSkillsAndCertificatesDrawerUserFragment = { readonly __typename?: 'User', readonly id: string, readonly skillsAndCompetences: ReadonlyArray<string>, readonly declaredNoCertificates: boolean, readonly certificates: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly file?: { readonly __typename?: 'DownloadableFileUrl', readonly fileName: string, readonly url: string } | null }> };

export type EditSkillsAndCertificatesDrawerInputQueryVariables = Exact<{ [key: string]: never; }>;


export type EditSkillsAndCertificatesDrawerInputQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EditSkillsAndCertificatesDrawerUserFragment
    )
   };

export type EditSkillsAndCertificatesDrawerUpdateSkillsMutationVariables = Exact<{
  skills?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EditSkillsAndCertificatesDrawerUpdateSkillsMutation = { readonly __typename?: 'Mutation', readonly updateProfile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & EditSkillsAndCertificatesDrawerUserFragment
    )
   };

export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutationVariables = Exact<{
  declaredNoCertificates: Scalars['Boolean']['input'];
}>;


export type EditSkillsAndCertificatesDrawerUpdateDeclaredNoCertificatesMutation = { readonly __typename?: 'Mutation', readonly updateProfile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly declaredNoCertificates: boolean }
   };

export type EditSkillsAndCertificatesDrawerCreateCertificateMutationVariables = Exact<{
  id: Scalars['CertificateId']['input'];
  name: Scalars['String']['input'];
  issueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type EditSkillsAndCertificatesDrawerCreateCertificateMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly certificateApi: { readonly __typename?: 'CertificateApi', readonly createCertificate:
        | { readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly file?: { readonly __typename?: 'DownloadableFileUrl', readonly fileName: string, readonly url: string } | null }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type EditSkillsAndCertificatesDrawerUpdateCertificateMutationVariables = Exact<{
  certificateId: Scalars['CertificateId']['input'];
  certificate: UpdateCertificateInput;
}>;


export type EditSkillsAndCertificatesDrawerUpdateCertificateMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly certificateApi: { readonly __typename?: 'CertificateApi', readonly updateCertificate:
        | { readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly file?: { readonly __typename?: 'DownloadableFileUrl', readonly fileName: string, readonly url: string } | null }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type EditSkillsAndCertificatesDrawerRemoveCertificateMutationVariables = Exact<{
  certificateId: Scalars['CertificateId']['input'];
}>;


export type EditSkillsAndCertificatesDrawerRemoveCertificateMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly certificateApi: { readonly __typename?: 'CertificateApi', readonly removeCertificate:
        | { readonly __typename?: 'BooleanResponse', readonly value: boolean }
        | (
          { readonly __typename?: 'NfsError' }
          & NfsErrorFragment
        )
       } } };

export type EditSocialMediaHandlesDrawerInputQueryVariables = Exact<{ [key: string]: never; }>;


export type EditSocialMediaHandlesDrawerInputQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly socialMediaHandles: ReadonlyArray<{ readonly __typename?: 'SocialMediaHandle', readonly platform: string, readonly handle: string }> }
   };

export type EditSocialMediaHandlesDrawerUpdateMutationVariables = Exact<{
  socialMediaHandles?: InputMaybe<ReadonlyArray<SocialMediaHandleInput> | SocialMediaHandleInput>;
}>;


export type EditSocialMediaHandlesDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly updateProfile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly socialMediaHandles: ReadonlyArray<{ readonly __typename?: 'SocialMediaHandle', readonly platform: string, readonly handle: string }> }
   };

export type SecureRoutesWrapperContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type SecureRoutesWrapperContractsQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly contracts: ReadonlyArray<
        | { readonly __typename?: 'B2BContract', readonly id: string, readonly name: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly conclusionDate: Date, readonly status: ContractStatus, readonly promiseeCompany: { readonly __typename?: 'Company', readonly countryOfRegistration: string }, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly vat: { readonly __typename?: 'TimeBasedVatType', readonly value:
              | (
                { readonly __typename?: 'VatApplied' }
                & VatTypeVatAppliedFragment
              )
              | (
                { readonly __typename?: 'VatNotApplied' }
                & VatTypeVatNotAppliedFragment
              )
             }, readonly promisor: { readonly __typename?: 'Company', readonly name: string, readonly countryOfRegistration: string, readonly logo?: string | null } }
        | { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly name: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly conclusionDate: Date, readonly status: ContractStatus, readonly currency: { readonly __typename?: 'TimeBasedCurrency', readonly value: string }, readonly promisor: { readonly __typename?: 'Company', readonly name: string, readonly countryOfRegistration: string, readonly logo?: string | null } }
        | { readonly __typename?: 'Subcontract', readonly id: string, readonly name: string, readonly createdAt: Date, readonly startDate: Date, readonly expectedEndDate?: Date | null, readonly terminationDate?: Date | null, readonly conclusionDate: Date, readonly status: ContractStatus, readonly promisor: { readonly __typename?: 'Company', readonly name: string, readonly countryOfRegistration: string, readonly logo?: string | null } }
      > }
   };

export type TimeReportPreferencesDrawerUpdateMutationVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
  workTagId?: InputMaybe<ClearableWorkTagIdInput>;
  projectId?: InputMaybe<ClearablePreselectedProjectIdInput>;
  fromTime?: InputMaybe<ClearableLocalTimeInput>;
  toTime?: InputMaybe<ClearableLocalTimeInput>;
  isRemoteWork?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TimeReportPreferencesDrawerUpdateMutation = { readonly __typename?: 'Mutation', readonly reporting: { readonly __typename?: 'UserReportingApi', readonly setPreselectedFields:
      | { readonly __typename?: 'ContractResponse', readonly value:
          | { readonly __typename?: 'B2BContract', readonly id: string, readonly preselectedFromTime?: Date | null, readonly preselectedToTime?: Date | null, readonly preselectedWorkTag?: { readonly __typename?: 'WorkTag', readonly id: string } | null, readonly preselectedProject?: { readonly __typename?: 'PreselectedProject', readonly value?: { readonly __typename?: 'Project', readonly id: string } | null } | null }
          | { readonly __typename?: 'EmploymentContract', readonly preselectedIsRemoteWork?: boolean | null, readonly id: string, readonly preselectedFromTime?: Date | null, readonly preselectedToTime?: Date | null, readonly preselectedWorkTag?: { readonly __typename?: 'WorkTag', readonly id: string } | null, readonly preselectedProject?: { readonly __typename?: 'PreselectedProject', readonly value?: { readonly __typename?: 'Project', readonly id: string } | null } | null }
          | { readonly __typename?: 'Subcontract', readonly id: string, readonly preselectedFromTime?: Date | null, readonly preselectedToTime?: Date | null, readonly preselectedWorkTag?: { readonly __typename?: 'WorkTag', readonly id: string } | null, readonly preselectedProject?: { readonly __typename?: 'PreselectedProject', readonly value?: { readonly __typename?: 'Project', readonly id: string } | null } | null }
         }
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
     } };

export type AbsencesQueryVariables = Exact<{
  projectId_in?: InputMaybe<ReadonlyArray<Scalars['ProjectId']['input']> | Scalars['ProjectId']['input']>;
  from: Scalars['YearMonth']['input'];
  to: Scalars['YearMonth']['input'];
}>;


export type AbsencesQuery = { readonly __typename?: 'Query', readonly projectsTimeReports:
    | { readonly __typename?: 'ListOfProjectTimeReportsResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ProjectTimeReports', readonly membersTimeReports: ReadonlyArray<{ readonly __typename?: 'ProjectMemberTimeReports', readonly person: { readonly __typename?: 'Person', readonly firstName: string, readonly lastName: string, readonly avatar?: string | null, readonly email: string }, readonly holidayCalendar: { readonly __typename?: 'HolidayCalendarDetails', readonly id: HolidayCalendarId }, readonly absenceRecords: ReadonlyArray<{ readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }> }> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly holidayCalendars: ReadonlyArray<{ readonly __typename?: 'HolidayCalendar', readonly id: HolidayCalendarId, readonly calendarDays: ReadonlyArray<{ readonly __typename?: 'CalendarDay', readonly date: Date, readonly dayType: CalendarDayType }> }> };

export type AbsencesInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type AbsencesInfoQuery = { readonly __typename?: 'Query', readonly absenceTypeDetails: ReadonlyArray<{ readonly __typename?: 'KVAbsenceTypeAbsenceTypeDetails', readonly key: AbsenceType, readonly value: { readonly __typename?: 'AbsenceTypeDetails', readonly canBeReportedOnHoliday: boolean, readonly applicableFor: ReadonlyArray<ContractType>, readonly canTakeCustomNumberOfHours: boolean, readonly limit?: number | null } }>, readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly assignedProjects: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string } }> } }
   };

export type DirectReportingAssignedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type DirectReportingAssignedProjectsQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly directSubordinates: ReadonlyArray<{ readonly __typename?: 'Person', readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: CompanyRole }>, readonly assignedProjects: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly lead?: { readonly __typename?: 'Person', readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: CompanyRole } | null }, readonly periods: ReadonlyArray<{ readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }> }> } }
   };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly middleName?: string | null, readonly lastName: string, readonly email: string, readonly contactEmail?: string | null, readonly phoneNumber?: string | null, readonly skillsAndCompetences: ReadonlyArray<string>, readonly declaredNoCertificates: boolean, readonly areaOfExpertise?: string | null, readonly pesel?: string | null, readonly citizenship?: string | null, readonly birthDate?: Date | null, readonly idType?: IdType | null, readonly idNumber?: string | null, readonly isStudent: boolean, readonly isStudentRevisionDate?: Date | null, readonly nextMedicalExaminationDate?: Date | null, readonly nextOhsTrainingDate?: Date | null, readonly passportExpirationDate?: Date | null, readonly paczkomat?: string | null, readonly plateNumber?: string | null, readonly emergencyContact?: string | null, readonly consentedForUseOfImage: boolean, readonly personalDataProcessingAuthorization: boolean, readonly certificates: ReadonlyArray<{ readonly __typename?: 'Certificate', readonly id: string, readonly name: string, readonly issueDate?: Date | null, readonly expirationDate?: Date | null, readonly file?: { readonly __typename?: 'DownloadableFileUrl', readonly fileName: string, readonly url: string } | null }>, readonly revenueAdministrationOffice?: { readonly __typename?: 'RevenueAdministrationOffice', readonly id: number, readonly officeName: string } | null, readonly address?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null, readonly mailingAddress?: (
        { readonly __typename?: 'Address' }
        & AddressFragment
      ) | null, readonly office?: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string } | null, readonly socialMediaHandles: ReadonlyArray<{ readonly __typename?: 'SocialMediaHandle', readonly platform: string, readonly handle: string }> }
   };

export type OfficeQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficeQuery = { readonly __typename?: 'Query', readonly reservableOffices:
    | { readonly __typename?: 'ListOfReservableOfficeResponse', readonly value: ReadonlyArray<{ readonly __typename?: 'ReservableOffice', readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string, readonly validFrom: Date, readonly validTo?: Date | null, readonly blocked: boolean }, readonly floorMap?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly downloadUrl: string } | null, readonly parkingMap?: { readonly __typename?: 'DownloadableExternallyHostedFileUrl', readonly fileName: string, readonly downloadUrl: string } | null, readonly rooms: ReadonlyArray<{ readonly __typename?: 'ReservableRoom', readonly id: string, readonly name: string, readonly desks: ReadonlyArray<{ readonly __typename?: 'ReservableDesk', readonly id: string, readonly name: string, readonly monitors: number, readonly standing: boolean }> }>, readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ReservableParkingSpot', readonly id: string, readonly number: string, readonly name: string, readonly guest: boolean }> }> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly officeReservationLimits:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeReservationSettings', readonly deskMaxAdvanceDays: number, readonly deskMaxDays: number, readonly parkingMaxAdvanceDays: number, readonly parkingMaxDays: number }
  , readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly office?: { readonly __typename?: 'Office', readonly officeId: string } | null }
   };

export type OfficeAvailabilityQueryVariables = Exact<{
  officeId: Scalars['OfficeId']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
}>;


export type OfficeAvailabilityQuery = { readonly __typename?: 'Query', readonly officeAvailability:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'OfficeAvailability', readonly desks: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }>, readonly parkingSpots: ReadonlyArray<{ readonly __typename?: 'ResourceAvailability', readonly resourceId: string, readonly takenDates: ReadonlyArray<Date> }> }
  , readonly myOfficeReservations:
    | { readonly __typename?: 'ListOfReservationRequestResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'ReservationRequest' }
        & OfficeReservationFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly myDeskAssignments:
    | { readonly __typename?: 'ListOfDeskAssignmentResponse', readonly value: ReadonlyArray<(
        { readonly __typename?: 'DeskAssignment' }
        & OfficeDeskAssignmentFragment
      )> }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type OfficeDeskAssignmentFragment = { readonly __typename?: 'DeskAssignment', readonly id: string, readonly from: Date, readonly to?: Date | null, readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string }, readonly desk: { readonly __typename?: 'ReservedResource', readonly id: string, readonly name: string } };

export type OfficeReservationFragment = { readonly __typename?: 'ReservationRequest', readonly requestId: string, readonly kind: ResourceKind, readonly plateNumber?: string | null, readonly guestEmails: ReadonlyArray<string>, readonly office: { readonly __typename?: 'Office', readonly officeId: string, readonly name: string }, readonly resources: ReadonlyArray<{ readonly __typename?: 'ReservedResource', readonly id: string, readonly name: string }>, readonly range: { readonly __typename?: 'ClosedEndLocalDateRange', readonly from: Date, readonly to: Date }, readonly approval:
    | { readonly __typename: 'Approved' }
    | { readonly __typename: 'NotRequired' }
    | { readonly __typename: 'PendingApproval' }
   };

export type OfficeCancelMutationVariables = Exact<{
  requestId: Scalars['ReservationRequestId']['input'];
}>;


export type OfficeCancelMutation = { readonly __typename?: 'Mutation', readonly officeReservations: { readonly __typename?: 'OfficeReservationsApi', readonly cancelOfficeReservation:
      | (
        { readonly __typename?: 'NfsError' }
        & NfsErrorFragment
      )
      | { readonly __typename?: 'ReservationRequest', readonly requestId: string }
     } };

export type ProgressionCurrencyFragment = { readonly __typename?: 'TimeBasedCurrency', readonly value: string, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantCurrency', readonly applyDate: Date, readonly activityId: string, readonly value: string }> };

export type ProgressionRateFragment = { readonly __typename?: 'TimeBasedRate', readonly value: (
    { readonly __typename?: 'Rate' }
    & RateFragment
  ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly activityId: string, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantRate', readonly applyDate: Date, readonly activityId: string, readonly value: (
      { readonly __typename?: 'Rate' }
      & RateFragment
    ) }> };

export type ProgressionPositionFragment = { readonly __typename?: 'TimeBasedOptClearableString', readonly value?: string | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableString', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableString', readonly value?: string | null } }> };

export type ProgressionOvertimeRateFragment = { readonly __typename?: 'TimeBasedOptClearableNetGross', readonly value?: (
    { readonly __typename?: 'NetGross' }
    & NetGrossFragment
  ) | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableNetGross', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableNetGross', readonly value?: (
        { readonly __typename?: 'NetGross' }
        & NetGrossFragment
      ) | null } }> };

export type ProgressionOnCallsFragment = { readonly __typename?: 'TimeBasedOptClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly holiday: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ), readonly weekend: (
      { readonly __typename?: 'NetGross' }
      & NetGrossFragment
    ) } | null, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly holiday: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly weekend: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) } | null } }>, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableOnCallRate', readonly activityId: string, readonly applyDate: Date, readonly value: { readonly __typename?: 'ClearableOnCallRate', readonly value?: { readonly __typename?: 'OnCallRate', readonly night: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly holiday: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ), readonly weekend: (
          { readonly __typename?: 'NetGross' }
          & NetGrossFragment
        ) } | null } }> };

export type ProgressionWorkingTimeFragment = { readonly __typename?: 'TimeBasedWorkingTime', readonly value: (
    { readonly __typename?: 'WorkingTime' }
    & WorkingTimeFragment
  ), readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'WorkingTime' }
      & WorkingTimeFragment
    ) }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantWorkingTime', readonly activityId: string, readonly applyDate: Date, readonly value: (
      { readonly __typename?: 'WorkingTime' }
      & WorkingTimeFragment
    ) }> };

export type ProgressionContractB2BContractFragment = { readonly __typename?: 'B2BContract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency: (
    { readonly __typename?: 'TimeBasedCurrency' }
    & ProgressionCurrencyFragment
  ), readonly rate: (
    { readonly __typename?: 'TimeBasedRate' }
    & ProgressionRateFragment
  ), readonly overtimeRate: (
    { readonly __typename?: 'TimeBasedOptClearableNetGross' }
    & ProgressionOvertimeRateFragment
  ), readonly onCall: (
    { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
    & ProgressionOnCallsFragment
  ), readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & ProgressionPositionFragment
  ) };

export type ProgressionContractEmploymentContractFragment = { readonly __typename?: 'EmploymentContract', readonly type: EmploymentContractType, readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null, readonly currency: (
    { readonly __typename?: 'TimeBasedCurrency' }
    & ProgressionCurrencyFragment
  ), readonly rate: (
    { readonly __typename?: 'TimeBasedRate' }
    & ProgressionRateFragment
  ), readonly overtimeRate: (
    { readonly __typename?: 'TimeBasedOptClearableNetGross' }
    & ProgressionOvertimeRateFragment
  ), readonly onCall: (
    { readonly __typename?: 'TimeBasedOptClearableOnCallRate' }
    & ProgressionOnCallsFragment
  ), readonly position: (
    { readonly __typename?: 'TimeBasedOptClearableString' }
    & ProgressionPositionFragment
  ), readonly workingTime: (
    { readonly __typename?: 'TimeBasedWorkingTime' }
    & ProgressionWorkingTimeFragment
  ) };

export type ProgressionContractSubcontractFragment = { readonly __typename?: 'Subcontract', readonly id: string, readonly status: ContractStatus, readonly startDate: Date, readonly terminationDate?: Date | null };

export type ProgressionContractFragment =
  | ProgressionContractB2BContractFragment
  | ProgressionContractEmploymentContractFragment
  | ProgressionContractSubcontractFragment
;

export type ProgressionUserFragment = { readonly __typename?: 'User', readonly id: string, readonly progressionLevel: { readonly __typename?: 'TimeBasedOptClearableProgressionLevel', readonly value?: ProgressionLevel | null, readonly history: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }>, readonly futureUpdates: ReadonlyArray<{ readonly __typename?: 'TimeBasedInstantClearableProgressionLevel', readonly applyDate: Date, readonly activityId: string, readonly value: { readonly __typename?: 'ClearableProgressionLevel', readonly value?: ProgressionLevel | null } }> } };

export type ProgressionQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type ProgressionQuery = { readonly __typename?: 'Query', readonly contract:
    | { readonly __typename?: 'ContractResponse', readonly value:
        | (
          { readonly __typename?: 'B2BContract' }
          & ProgressionContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & ProgressionContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & ProgressionContractSubcontractFragment
        )
       }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
  , readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User' }
      & ProgressionUserFragment
    )
   };

export type ProgressionMergedQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgressionMergedQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | (
      { readonly __typename?: 'User', readonly contracts: ReadonlyArray<
        | (
          { readonly __typename?: 'B2BContract' }
          & ProgressionContractB2BContractFragment
        )
        | (
          { readonly __typename?: 'EmploymentContract' }
          & ProgressionContractEmploymentContractFragment
        )
        | (
          { readonly __typename?: 'Subcontract' }
          & ProgressionContractSubcontractFragment
        )
      > }
      & ProgressionUserFragment
    )
   };

export type ProjectsAssignedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsAssignedProjectsQuery = { readonly __typename?: 'Query', readonly profile:
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
    | { readonly __typename?: 'User', readonly id: string, readonly directReporting: { readonly __typename?: 'DirectReporting', readonly directSubordinates: ReadonlyArray<{ readonly __typename?: 'Person', readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: CompanyRole }>, readonly assignedProjects: ReadonlyArray<{ readonly __typename?: 'ProjectAssignment', readonly project: { readonly __typename?: 'Project', readonly id: string, readonly name: string, readonly lead?: { readonly __typename?: 'Person', readonly firstName: string, readonly lastName: string, readonly email: string, readonly avatar?: string | null, readonly role: CompanyRole } | null }, readonly periods: ReadonlyArray<{ readonly __typename?: 'LocalDateRange', readonly from: Date, readonly to?: Date | null }> }> } }
   };

export type TimeReportFileQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
  contractId: Scalars['ContractId']['input'];
}>;


export type TimeReportFileQuery = { readonly __typename?: 'Query', readonly timeReportFile:
    | { readonly __typename?: 'DownloadableFileUrl', readonly url: string, readonly fileName: string }
    | (
      { readonly __typename?: 'NfsError' }
      & NfsErrorFragment
    )
   };

export type DrawerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DrawerQuery = { readonly __typename?: 'Query', readonly drawer?:
    | (
      { readonly __typename?: 'AdditionalCostsDrawer' }
      & ChildLevel0AdditionalCostsDrawerFragment
    )
    | (
      { readonly __typename?: 'BookDeskDrawer' }
      & ChildLevel0BookDeskDrawerFragment
    )
    | (
      { readonly __typename?: 'BookParkingDrawer' }
      & ChildLevel0BookParkingDrawerFragment
    )
    | (
      { readonly __typename?: 'CopyrightsDrawer' }
      & ChildLevel0CopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditAdditionalDataDrawer' }
      & ChildLevel0EditAdditionalDataDrawerFragment
    )
    | (
      { readonly __typename?: 'EditAddressDrawer' }
      & ChildLevel0EditAddressDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileDetailsDrawer' }
      & ChildLevel0EditProfileDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
      & ChildLevel0EditSkillsAndCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
      & ChildLevel0EditSocialMediaHandlesDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoicesDrawer' }
      & ChildLevel0InvoicesDrawerFragment
    )
    | (
      { readonly __typename?: 'TimeReportPreferencesDrawer' }
      & ChildLevel0TimeReportPreferencesDrawerFragment
    )
   | null };

export type AbstractDrawerAdditionalCostsDrawerFragment = { readonly __typename?: 'AdditionalCostsDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerBookDeskDrawerFragment = { readonly __typename?: 'BookDeskDrawer', readonly prefillDeskId?: string | null, readonly prefillFrom?: Date | null, readonly prefillRoomId?: string | null, readonly prefillTo?: Date | null, readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerBookParkingDrawerFragment = { readonly __typename?: 'BookParkingDrawer', readonly prefillFrom?: Date | null, readonly prefillParkingSpotId?: string | null, readonly prefillTo?: Date | null, readonly requiredOfficeId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerCopyrightsDrawerFragment = { readonly __typename?: 'CopyrightsDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditAdditionalDataDrawerFragment = { readonly __typename?: 'EditAdditionalDataDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditAddressDrawerFragment = { readonly __typename?: 'EditAddressDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditProfileDetailsDrawerFragment = { readonly __typename?: 'EditProfileDetailsDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditSkillsAndCertificatesDrawerFragment = { readonly __typename?: 'EditSkillsAndCertificatesDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerEditSocialMediaHandlesDrawerFragment = { readonly __typename?: 'EditSocialMediaHandlesDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerInvoicesDrawerFragment = { readonly __typename?: 'InvoicesDrawer', readonly id: string, readonly visible: boolean };

export type AbstractDrawerTimeReportPreferencesDrawerFragment = { readonly __typename?: 'TimeReportPreferencesDrawer', readonly requiredContractId: string, readonly id: string, readonly visible: boolean };

export type AbstractDrawerFragment =
  | AbstractDrawerAdditionalCostsDrawerFragment
  | AbstractDrawerBookDeskDrawerFragment
  | AbstractDrawerBookParkingDrawerFragment
  | AbstractDrawerCopyrightsDrawerFragment
  | AbstractDrawerEditAdditionalDataDrawerFragment
  | AbstractDrawerEditAddressDrawerFragment
  | AbstractDrawerEditProfileDetailsDrawerFragment
  | AbstractDrawerEditSkillsAndCertificatesDrawerFragment
  | AbstractDrawerEditSocialMediaHandlesDrawerFragment
  | AbstractDrawerInvoicesDrawerFragment
  | AbstractDrawerTimeReportPreferencesDrawerFragment
;

export type RootDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type RootDrawerQuery = { readonly __typename?: 'Query', readonly rootDrawer?:
    | (
      { readonly __typename?: 'AdditionalCostsDrawer' }
      & ChildLevel0AdditionalCostsDrawerFragment
    )
    | (
      { readonly __typename?: 'BookDeskDrawer' }
      & ChildLevel0BookDeskDrawerFragment
    )
    | (
      { readonly __typename?: 'BookParkingDrawer' }
      & ChildLevel0BookParkingDrawerFragment
    )
    | (
      { readonly __typename?: 'CopyrightsDrawer' }
      & ChildLevel0CopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditAdditionalDataDrawer' }
      & ChildLevel0EditAdditionalDataDrawerFragment
    )
    | (
      { readonly __typename?: 'EditAddressDrawer' }
      & ChildLevel0EditAddressDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileDetailsDrawer' }
      & ChildLevel0EditProfileDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
      & ChildLevel0EditSkillsAndCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
      & ChildLevel0EditSocialMediaHandlesDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoicesDrawer' }
      & ChildLevel0InvoicesDrawerFragment
    )
    | (
      { readonly __typename?: 'TimeReportPreferencesDrawer' }
      & ChildLevel0TimeReportPreferencesDrawerFragment
    )
   | null };

export type TopDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type TopDrawerQuery = { readonly __typename?: 'Query', readonly topDrawer?:
    | (
      { readonly __typename?: 'AdditionalCostsDrawer' }
      & ChildLevel0AdditionalCostsDrawerFragment
    )
    | (
      { readonly __typename?: 'BookDeskDrawer' }
      & ChildLevel0BookDeskDrawerFragment
    )
    | (
      { readonly __typename?: 'BookParkingDrawer' }
      & ChildLevel0BookParkingDrawerFragment
    )
    | (
      { readonly __typename?: 'CopyrightsDrawer' }
      & ChildLevel0CopyrightsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditAdditionalDataDrawer' }
      & ChildLevel0EditAdditionalDataDrawerFragment
    )
    | (
      { readonly __typename?: 'EditAddressDrawer' }
      & ChildLevel0EditAddressDrawerFragment
    )
    | (
      { readonly __typename?: 'EditProfileDetailsDrawer' }
      & ChildLevel0EditProfileDetailsDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSkillsAndCertificatesDrawer' }
      & ChildLevel0EditSkillsAndCertificatesDrawerFragment
    )
    | (
      { readonly __typename?: 'EditSocialMediaHandlesDrawer' }
      & ChildLevel0EditSocialMediaHandlesDrawerFragment
    )
    | (
      { readonly __typename?: 'InvoicesDrawer' }
      & ChildLevel0InvoicesDrawerFragment
    )
    | (
      { readonly __typename?: 'TimeReportPreferencesDrawer' }
      & ChildLevel0TimeReportPreferencesDrawerFragment
    )
   | null };
